import { inject as pn, provide as fn, shallowRef as vn, watchEffect as ee, readonly as rt, ref as x, watch as X, customRef as uo, effectScope as $a, computed as P, nextTick as Y, getCurrentScope as Pa, onScopeDispose as Ba, unref as a, toRef as Ta, getCurrentInstance as Ve, onMounted as U, Fragment as re, defineComponent as g, toRefs as z, renderSlot as y, onBeforeUnmount as co, onBeforeUpdate as Da, onUpdated as Ia, toHandlerKey as Aa, camelize as mn, onUnmounted as fe, mergeProps as B, h as ke, cloneVNode as Fa, openBlock as h, createBlock as b, withCtx as v, createVNode as F, createCommentVNode as q, withKeys as ie, Teleport as Ue, normalizeProps as k, guardReactiveProps as K, reactive as hn, normalizeStyle as ae, withModifiers as te, createElementBlock as Q, mergeDefaults as yn, createElementVNode as lt, renderList as po, markRaw as en, withDirectives as fo, vShow as gn, resolveDynamicComponent as xe, createTextVNode as ue, toDisplayString as je, isRef as ut, onBeforeMount as bn, vModelSelect as Ma, useSlots as Cn } from "vue";
import { useFloating as ka, autoUpdate as Ra, offset as Va, shift as ja, limitShift as La, flip as Ka, size as Na, arrow as Ha, hide as Wa } from "@floating-ui/vue";
function H(o, t) {
  const e = typeof o == "string" && !t ? `${o}Context` : t, n = Symbol(e);
  return [(r) => {
    const l = pn(n, r);
    if (l || l === null)
      return l;
    throw new Error(
      `Injection \`${n.toString()}\` not found. Component must be used within ${Array.isArray(o) ? `one of the following components: ${o.join(
        ", "
      )}` : `\`${o}\``}`
    );
  }, (r) => (fn(n, r), r)];
}
function vo(o, t, e) {
  const n = e.originalEvent.target, s = new CustomEvent(o, {
    bubbles: !1,
    cancelable: !0,
    detail: e
  });
  t && n.addEventListener(o, t, { once: !0 }), n.dispatchEvent(s);
}
function za(o, t) {
  var e;
  const n = vn();
  return ee(() => {
    n.value = o();
  }, {
    ...t,
    flush: (e = t == null ? void 0 : t.flush) != null ? e : "sync"
  }), rt(n);
}
function mo(o, t) {
  let e, n, s;
  const i = x(!0), r = () => {
    i.value = !0, s();
  };
  X(o, r, { flush: "sync" });
  const l = typeof t == "function" ? t : t.get, u = typeof t == "function" ? void 0 : t.set, d = uo((c, p) => (n = c, s = p, {
    get() {
      return i.value && (e = l(), i.value = !1), n(), e;
    },
    set(f) {
      u == null || u(f);
    }
  }));
  return Object.isExtensible(d) && (d.trigger = r), d;
}
function dt(o) {
  return Pa() ? (Ba(o), !0) : !1;
}
function Bt(o) {
  let t = !1, e;
  const n = $a(!0);
  return (...s) => (t || (e = n.run(() => o(...s)), t = !0), e);
}
function ge(o) {
  return typeof o == "function" ? o() : a(o);
}
const Oe = typeof window < "u" && typeof document < "u", Ua = (o) => typeof o < "u", qa = Object.prototype.toString, Ga = (o) => qa.call(o) === "[object Object]", tn = (o, t, e) => Math.min(e, Math.max(t, o)), at = () => {
};
function Ya(o, t) {
  function e(...n) {
    return new Promise((s, i) => {
      Promise.resolve(o(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(s).catch(i);
    });
  }
  return e;
}
function Xa(o, t = {}) {
  let e, n, s = at;
  const i = (l) => {
    clearTimeout(l), s(), s = at;
  };
  return (l) => {
    const u = ge(o), d = ge(t.maxWait);
    return e && i(e), u <= 0 || d !== void 0 && d <= 0 ? (n && (i(n), n = null), Promise.resolve(l())) : new Promise((c, p) => {
      s = t.rejectOnCancel ? p : c, d && !n && (n = setTimeout(() => {
        e && i(e), n = null, c(l());
      }, d)), e = setTimeout(() => {
        n && i(n), n = null, c(l());
      }, u);
    });
  };
}
function Ja(...o) {
  if (o.length !== 1)
    return Ta(...o);
  const t = o[0];
  return typeof t == "function" ? rt(uo(() => ({ get: t, set: at }))) : x(t);
}
function ho(o, t = 1e4) {
  return uo((e, n) => {
    let s = ge(o), i;
    const r = () => setTimeout(() => {
      s = ge(o), n();
    }, ge(t));
    return dt(() => {
      clearTimeout(i);
    }), {
      get() {
        return e(), s;
      },
      set(l) {
        s = l, n(), clearTimeout(i), i = r();
      }
    };
  });
}
function yo(o, t = 200, e = {}) {
  return Ya(
    Xa(t, e),
    o
  );
}
function go(o, t, e = {}) {
  const {
    immediate: n = !0
  } = e, s = x(!1);
  let i = null;
  function r() {
    i && (clearTimeout(i), i = null);
  }
  function l() {
    s.value = !1, r();
  }
  function u(...d) {
    r(), s.value = !0, i = setTimeout(() => {
      s.value = !1, i = null, o(...d);
    }, ge(t));
  }
  return n && (s.value = !0, Oe && u()), dt(l), {
    isPending: rt(s),
    start: u,
    stop: l
  };
}
function Za(o = 1e3, t = {}) {
  const {
    controls: e = !1,
    callback: n
  } = t, s = go(
    n ?? at,
    o,
    t
  ), i = P(() => !s.isPending.value);
  return e ? {
    ready: i,
    ...s
  } : i;
}
function Qa(o, t, e) {
  const n = X(o, (...s) => (Y(() => n()), t(...s)), e);
}
function ve(o) {
  var t;
  const e = ge(o);
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
const ct = Oe ? window : void 0;
function Re(...o) {
  let t, e, n, s;
  if (typeof o[0] == "string" || Array.isArray(o[0]) ? ([e, n, s] = o, t = ct) : [t, e, n, s] = o, !t)
    return at;
  Array.isArray(e) || (e = [e]), Array.isArray(n) || (n = [n]);
  const i = [], r = () => {
    i.forEach((c) => c()), i.length = 0;
  }, l = (c, p, f, m) => (c.addEventListener(p, f, m), () => c.removeEventListener(p, f, m)), u = X(
    () => [ve(t), ge(s)],
    ([c, p]) => {
      if (r(), !c)
        return;
      const f = Ga(p) ? { ...p } : p;
      i.push(
        ...e.flatMap((m) => n.map((C) => l(c, m, C, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    u(), r();
  };
  return dt(d), d;
}
function es(o) {
  return typeof o == "function" ? o : typeof o == "string" ? (t) => t.key === o : Array.isArray(o) ? (t) => o.includes(t.key) : () => !0;
}
function bo(...o) {
  let t, e, n = {};
  o.length === 3 ? (t = o[0], e = o[1], n = o[2]) : o.length === 2 ? typeof o[1] == "object" ? (t = !0, e = o[0], n = o[1]) : (t = o[0], e = o[1]) : (t = !0, e = o[0]);
  const {
    target: s = ct,
    eventName: i = "keydown",
    passive: r = !1,
    dedupe: l = !1
  } = n, u = es(t);
  return Re(s, i, (c) => {
    c.repeat && ge(l) || u(c) && e(c);
  }, r);
}
function ts(o = {}) {
  var t;
  const {
    window: e = ct,
    deep: n = !0
  } = o, s = (t = o.document) != null ? t : e == null ? void 0 : e.document, i = () => {
    var l;
    let u = s == null ? void 0 : s.activeElement;
    if (n)
      for (; u != null && u.shadowRoot; )
        u = (l = u == null ? void 0 : u.shadowRoot) == null ? void 0 : l.activeElement;
    return u;
  }, r = mo(
    () => null,
    () => i()
  );
  return e && (Re(e, "blur", (l) => {
    l.relatedTarget === null && r.trigger();
  }, !0), Re(e, "focus", r.trigger, !0)), r;
}
function Tt() {
  const o = x(!1);
  return Ve() && U(() => {
    o.value = !0;
  }), o;
}
function os(o) {
  const t = Tt();
  return P(() => (t.value, !!o()));
}
function ns(o, t = {}) {
  const {
    immediate: e = !0,
    fpsLimit: n = void 0,
    window: s = ct
  } = t, i = x(!1), r = n ? 1e3 / n : null;
  let l = 0, u = null;
  function d(f) {
    if (!i.value || !s)
      return;
    const m = f - (l || f);
    if (r && m < r) {
      u = s.requestAnimationFrame(d);
      return;
    }
    o({ delta: m, timestamp: f }), l = f, u = s.requestAnimationFrame(d);
  }
  function c() {
    !i.value && s && (i.value = !0, u = s.requestAnimationFrame(d));
  }
  function p() {
    i.value = !1, u != null && s && (s.cancelAnimationFrame(u), u = null);
  }
  return e && c(), dt(p), {
    isActive: rt(i),
    pause: p,
    resume: c
  };
}
function as(o) {
  return JSON.parse(JSON.stringify(o));
}
function _e(o, t, e = {}) {
  const { window: n = ct, ...s } = e;
  let i;
  const r = os(() => n && "ResizeObserver" in n), l = () => {
    i && (i.disconnect(), i = void 0);
  }, u = P(() => Array.isArray(o) ? o.map((p) => ve(p)) : [ve(o)]), d = X(
    u,
    (p) => {
      if (l(), r.value && n) {
        i = new ResizeObserver(t);
        for (const f of p)
          f && i.observe(f, s);
      }
    },
    { immediate: !0, flush: "post", deep: !0 }
  ), c = () => {
    l(), d();
  };
  return dt(c), {
    isSupported: r,
    stop: c
  };
}
function ss(o, t = {}) {
  const e = ts(t), n = P(() => ve(o));
  return { focused: P(() => n.value && e.value ? n.value.contains(e.value) : !1) };
}
function is(o, t) {
  const e = vn(t);
  return X(
    Ja(o),
    (n, s) => {
      e.value = s;
    },
    { flush: "sync" }
  ), rt(e);
}
function J(o, t, e, n = {}) {
  var s, i, r;
  const {
    clone: l = !1,
    passive: u = !1,
    eventName: d,
    deep: c = !1,
    defaultValue: p,
    shouldEmit: f
  } = n, m = Ve(), C = e || (m == null ? void 0 : m.emit) || ((s = m == null ? void 0 : m.$emit) == null ? void 0 : s.bind(m)) || ((r = (i = m == null ? void 0 : m.proxy) == null ? void 0 : i.$emit) == null ? void 0 : r.bind(m == null ? void 0 : m.proxy));
  let w = d;
  t || (t = "modelValue"), w = w || `update:${t.toString()}`;
  const O = (E) => l ? typeof l == "function" ? l(E) : as(E) : E, _ = () => Ua(o[t]) ? O(o[t]) : p, S = (E) => {
    f ? f(E) && C(w, E) : C(w, E);
  };
  if (u) {
    const E = _(), $ = x(E);
    let I = !1;
    return X(
      () => o[t],
      (A) => {
        I || (I = !0, $.value = O(A), Y(() => I = !1));
      }
    ), X(
      $,
      (A) => {
        !I && (A !== o[t] || c) && S(A);
      },
      { deep: c }
    ), $;
  } else
    return P({
      get() {
        return _();
      },
      set(E) {
        S(E);
      }
    });
}
function Dt(o) {
  return o ? o.flatMap((t) => t.type === re ? Dt(t.children) : [t]) : [];
}
function qe(o, t, e, n = {}) {
  if (!t)
    return null;
  const {
    arrowKeyOptions: s = "both",
    attributeName: i = "data-radix-vue-collection-item",
    itemsArray: r = [],
    loop: l = !0,
    dir: u = "ltr",
    preventScroll: d = !0,
    focus: c = !1
  } = n, [p, f, m, C, w, O] = [
    o.key === "ArrowRight",
    o.key === "ArrowLeft",
    o.key === "ArrowUp",
    o.key === "ArrowDown",
    o.key === "Home",
    o.key === "End"
  ], _ = m || C, S = p || f;
  if (!w && !O && (!_ && !S || s === "vertical" && S || s === "horizontal" && _))
    return null;
  const E = e ? Array.from(e.querySelectorAll(`[${i}]`)) : r;
  if (!E.length)
    return null;
  d && o.preventDefault();
  let $ = null;
  return S || _ ? $ = _n(E, t, {
    goForward: _ ? C : u === "ltr" ? p : f,
    loop: l
  }) : w ? $ = E.at(0) || null : O && ($ = E.at(-1) || null), c && ($ == null || $.focus()), $;
}
function _n(o, t, { goForward: e, loop: n }, s = o.length) {
  if (--s === 0)
    return null;
  const i = o.indexOf(t), r = e ? i + 1 : i - 1;
  if (!n && (r < 0 || r >= o.length))
    return null;
  const l = (r + o.length) % o.length, u = o[l];
  return u ? u.hasAttribute("disabled") && u.getAttribute("disabled") !== "false" ? _n(
    o,
    u,
    { goForward: e, loop: n },
    s
  ) : u : null;
}
function Jt(o) {
  return o !== null && typeof o == "object";
}
function oo(o, t, e = ".", n) {
  if (!Jt(t))
    return oo(o, {}, e, n);
  const s = Object.assign({}, t);
  for (const i in o) {
    if (i === "__proto__" || i === "constructor")
      continue;
    const r = o[i];
    r != null && (n && n(s, i, r, e) || (Array.isArray(r) && Array.isArray(s[i]) ? s[i] = [...r, ...s[i]] : Jt(r) && Jt(s[i]) ? s[i] = oo(
      r,
      s[i],
      (e ? `${e}.` : "") + i.toString(),
      n
    ) : s[i] = r));
  }
  return s;
}
function rs(o) {
  return (...t) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    t.reduce((e, n) => oo(e, n, "", o), {})
  );
}
const ls = rs(), [wn, us] = H("ConfigProvider"), ql = /* @__PURE__ */ g({
  __name: "ConfigProvider",
  props: {
    dir: { default: "ltr" },
    scrollBody: { type: [Boolean, Object], default: !0 }
  },
  setup(o) {
    const t = o, { dir: e, scrollBody: n } = z(t);
    return us({
      dir: e,
      scrollBody: n
    }), (s, i) => y(s.$slots, "default");
  }
}), ds = Bt(() => x()), cs = Bt(() => x(0));
function pt(o) {
  const t = wn({
    scrollBody: x(!0)
  }), e = cs(), n = ds(), s = x(o), i = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = n.value ?? "", n.value = void 0;
  };
  return o && e.value++, X(s, (r) => {
    var l;
    if (Oe && r) {
      n.value === void 0 && (n.value = document.body.style.overflow);
      const u = window.innerWidth - document.documentElement.clientWidth, d = { padding: u, margin: 0 }, c = (l = t.scrollBody) != null && l.value ? typeof t.scrollBody.value == "object" ? ls({
        padding: t.scrollBody.value.padding === !0 ? u : t.scrollBody.value.padding,
        margin: t.scrollBody.value.margin === !0 ? u : t.scrollBody.value.margin
      }, d) : d : { padding: 0, margin: 0 };
      u > 0 && (document.body.style.paddingRight = `${c.padding}px`, document.body.style.marginRight = `${c.margin}px`, document.body.style.setProperty("--scrollbar-width", `${u}px`), document.body.style.overflow = "hidden"), Y(() => {
        document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
      });
    }
  }, { immediate: !0 }), co(() => {
    o && e.value--, e.value === 0 && i();
  }), s;
}
const ps = "data-radix-vue-collection-item";
function le(o, t = ps) {
  const e = o ?? Symbol();
  return { createCollection: (i) => {
    const r = x([]);
    function l() {
      const u = ve(i);
      return u ? r.value = Array.from(
        u.querySelectorAll(`[${t}]:not([data-disabled=true])`)
      ) : r.value = [];
    }
    return Da(() => {
      r.value = [];
    }), U(l), Ia(l), X(() => i == null ? void 0 : i.value, l, { immediate: !0 }), fn(e, r), r;
  }, injectCollection: () => pn(e, x([])) };
}
function de(o) {
  const t = wn({
    dir: x("ltr")
  });
  return P(() => {
    var e;
    return (o == null ? void 0 : o.value) || ((e = t.dir) == null ? void 0 : e.value) || "ltr";
  });
}
function ce(o) {
  const t = Ve(), e = t == null ? void 0 : t.type.emits, n = {};
  return e != null && e.length || console.warn(
    `No emitted event found. Please check component: ${t == null ? void 0 : t.type.__name}`
  ), e == null || e.forEach((s) => {
    n[Aa(mn(s))] = (...i) => o(s, ...i);
  }), n;
}
let Zt = 0;
function Co() {
  ee((o) => {
    if (!Oe)
      return;
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      t[0] ?? on()
    ), document.body.insertAdjacentElement(
      "beforeend",
      t[1] ?? on()
    ), Zt++, o(() => {
      Zt === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), Zt--;
    });
  });
}
function on() {
  const o = document.createElement("span");
  return o.setAttribute("data-radix-focus-guard", ""), o.tabIndex = 0, o.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", o;
}
function Le(o) {
  return P(() => {
    var t;
    return ge(o) ? !!((t = ve(o)) != null && t.closest("form")) : !0;
  });
}
function It(o) {
  const t = Ve(), e = Object.keys((t == null ? void 0 : t.type.props) ?? {}).reduce((n, s) => {
    const i = (t == null ? void 0 : t.type.props[s]).default;
    return i !== void 0 && (n[s] = i), n;
  }, {});
  return mo(() => ({ ...o }), () => {
    const n = {}, s = (t == null ? void 0 : t.vnode.props) ?? {};
    return Object.keys(s).forEach((i) => {
      n[mn(i)] = s[i];
    }), Object.keys({ ...e, ...n }).reduce((i, r) => (o[r] !== void 0 && (i[r] = o[r]), i), {});
  });
}
function pe(o, t) {
  const e = It(o), n = t ? ce(t) : {};
  return P(() => ({
    ...e.value,
    ...n
  }));
}
function be() {
  const o = Ve();
  function t(e) {
    typeof e == "object" && (o.exposed = e, o.exposeProxy = e);
  }
  return t;
}
var fs = function(o) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(o) ? o[0] : o;
  return t.ownerDocument.body;
}, ze = /* @__PURE__ */ new WeakMap(), bt = /* @__PURE__ */ new WeakMap(), Ct = {}, Qt = 0, Sn = function(o) {
  return o && (o.host || Sn(o.parentNode));
}, vs = function(o, t) {
  return t.map(function(e) {
    if (o.contains(e))
      return e;
    var n = Sn(e);
    return n && o.contains(n) ? n : (console.error("aria-hidden", e, "in not contained inside", o, ". Doing nothing"), null);
  }).filter(function(e) {
    return !!e;
  });
}, ms = function(o, t, e, n) {
  var s = vs(t, Array.isArray(o) ? o : [o]);
  Ct[e] || (Ct[e] = /* @__PURE__ */ new WeakMap());
  var i = Ct[e], r = [], l = /* @__PURE__ */ new Set(), u = new Set(s), d = function(p) {
    !p || l.has(p) || (l.add(p), d(p.parentNode));
  };
  s.forEach(d);
  var c = function(p) {
    !p || u.has(p) || Array.prototype.forEach.call(p.children, function(f) {
      if (l.has(f))
        c(f);
      else {
        var m = f.getAttribute(n), C = m !== null && m !== "false", w = (ze.get(f) || 0) + 1, O = (i.get(f) || 0) + 1;
        ze.set(f, w), i.set(f, O), r.push(f), w === 1 && C && bt.set(f, !0), O === 1 && f.setAttribute(e, "true"), C || f.setAttribute(n, "true");
      }
    });
  };
  return c(t), l.clear(), Qt++, function() {
    r.forEach(function(p) {
      var f = ze.get(p) - 1, m = i.get(p) - 1;
      ze.set(p, f), i.set(p, m), f || (bt.has(p) || p.removeAttribute(n), bt.delete(p)), m || p.removeAttribute(e);
    }), Qt--, Qt || (ze = /* @__PURE__ */ new WeakMap(), ze = /* @__PURE__ */ new WeakMap(), bt = /* @__PURE__ */ new WeakMap(), Ct = {});
  };
}, hs = function(o, t, e) {
  e === void 0 && (e = "data-aria-hidden");
  var n = Array.from(Array.isArray(o) ? o : [o]), s = t || fs(o);
  return s ? (n.push.apply(n, Array.from(s.querySelectorAll("[aria-live]"))), ms(n, s, e, "aria-hidden")) : function() {
    return null;
  };
};
function ft(o) {
  let t;
  X(() => ve(o), (e) => {
    e ? t = hs(e) : t && t();
  }), fe(() => {
    t && t();
  });
}
const ys = Bt(() => ({ count: x(0) }));
function oe(o) {
  const { count: t } = ys();
  return o || t.value++, o || `radix-${t.value}`;
}
function En(o) {
  const t = x(), e = P(() => {
    var s;
    return ((s = t.value) == null ? void 0 : s.width) ?? 0;
  }), n = P(() => {
    var s;
    return ((s = t.value) == null ? void 0 : s.height) ?? 0;
  });
  return U(() => {
    const s = ve(o);
    if (s) {
      t.value = { width: s.offsetWidth, height: s.offsetHeight };
      const i = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const l = r[0];
        let u, d;
        if ("borderBoxSize" in l) {
          const c = l.borderBoxSize, p = Array.isArray(c) ? c[0] : c;
          u = p.inlineSize, d = p.blockSize;
        } else
          u = s.offsetWidth, d = s.offsetHeight;
        t.value = { width: u, height: d };
      });
      return i.observe(s, { box: "border-box" }), () => i.unobserve(s);
    } else
      t.value = void 0;
  }), {
    width: e,
    height: n
  };
}
function xn(o, t) {
  const e = x(o);
  function n(i) {
    return t[e.value][i] ?? e.value;
  }
  return {
    state: e,
    dispatch: (i) => {
      e.value = n(i);
    }
  };
}
function _o(o) {
  const t = ho("", 1e3);
  return {
    search: t,
    handleTypeaheadSearch: (s) => {
      var p, f;
      t.value = t.value + s;
      const i = o.value, r = document.activeElement, l = ((f = (p = i.find((m) => m === r)) == null ? void 0 : p.textContent) == null ? void 0 : f.trim()) ?? "", u = i.map((m) => {
        var C;
        return ((C = m.textContent) == null ? void 0 : C.trim()) ?? "";
      }), d = gs(u, t.value, l), c = i.find(
        (m) => {
          var C;
          return ((C = m.textContent) == null ? void 0 : C.trim()) === d;
        }
      );
      c && c.focus();
    },
    resetTypeahead: () => {
      t.value = "";
    }
  };
}
function wo(o, t) {
  return o.map((e, n) => o[(t + n) % o.length]);
}
function gs(o, t, e) {
  const s = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = e ? o.indexOf(e) : -1;
  let r = wo(o, Math.max(i, 0));
  s.length === 1 && (r = r.filter((d) => d !== e));
  const u = r.find(
    (d) => d.toLowerCase().startsWith(s.toLowerCase())
  );
  return u !== e ? u : void 0;
}
function Gl(o, t) {
  return {
    inheritAttrs: !1,
    name: `${o.__name ?? ""}Wrapper`,
    setup(e, n) {
      return () => {
        const s = typeof (t == null ? void 0 : t.props) == "function" ? t == null ? void 0 : t.props(n.attrs) : t == null ? void 0 : t.props, i = be(), r = B(s, n.attrs);
        return ke(o, { ...r, ref: i }, n.slots);
      };
    }
  };
}
const So = g({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(o, { attrs: t, slots: e }) {
    return () => {
      var r, l;
      if (!e.default)
        return null;
      const n = Dt(e.default()), [s, ...i] = n;
      if (Object.keys(t).length > 0) {
        (r = s.props) == null || delete r.ref;
        const u = B(t, s.props ?? {});
        t.class && ((l = s.props) != null && l.class) && delete s.props.class;
        const d = Fa(s, u);
        for (const c in u)
          c.startsWith("on") && (d.props || (d.props = {}), d.props[c] = u[c]);
        return n.length === 1 ? d : [d, ...i];
      }
      return n;
    };
  }
}), T = g({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(o, { attrs: t, slots: e }) {
    return (o.asChild ? "template" : o.as) !== "template" ? () => ke(o.as, t, { default: e.default }) : () => ke(So, t, { default: e.default });
  }
});
function R() {
  const o = x(), t = P(() => {
    var e, n;
    return ["#text", "#comment"].includes((e = o.value) == null ? void 0 : e.$el.nodeName) ? (n = o.value) == null ? void 0 : n.$el.nextElementSibling : ve(o);
  });
  return {
    primitiveElement: o,
    currentElement: t
  };
}
const [On, bs] = H("CollapsibleRoot"), Cs = /* @__PURE__ */ g({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(o, { expose: t, emit: e }) {
    const n = o, i = J(n, "open", e, {
      defaultValue: n.defaultOpen,
      passive: n.open === void 0
    }), r = J(n, "disabled");
    return bs({
      contentId: oe(),
      disabled: r,
      open: i,
      onOpenToggle: () => {
        i.value = !i.value;
      }
    }), t({ open: i }), (l, u) => (h(), b(a(T), {
      as: l.as,
      "as-child": n.asChild,
      "data-state": n.open ? "open" : "closed",
      "data-disabled": n.disabled ? "" : void 0
    }, {
      default: v(() => [
        y(l.$slots, "default", { open: a(i) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), _s = /* @__PURE__ */ g({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = On();
    return (n, s) => {
      var i, r;
      return h(), b(a(T), {
        type: n.as === "button" ? "button" : void 0,
        as: n.as,
        "as-child": t.asChild,
        "aria-controls": a(e).contentId,
        "aria-expanded": a(e).open.value,
        "data-state": a(e).open.value ? "open" : "closed",
        "data-disabled": (i = a(e).disabled) != null && i.value ? "" : void 0,
        disabled: (r = a(e).disabled) == null ? void 0 : r.value,
        onClick: a(e).onOpenToggle
      }, {
        default: v(() => [
          y(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
});
function ws(o, t) {
  const e = x({}), n = x("none"), s = o.value ? "mounted" : "unmounted", { state: i, dispatch: r } = xn(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  X(
    o,
    async (f, m) => {
      var w;
      const C = m !== f;
      if (await Y(), C) {
        const O = n.value, _ = _t(t.value);
        f ? r("MOUNT") : _ === "none" || ((w = e.value) == null ? void 0 : w.display) === "none" ? r("UNMOUNT") : r(m && O !== _ ? "ANIMATION_OUT" : "UNMOUNT");
      }
    },
    { immediate: !0 }
  );
  const l = (f) => {
    const m = _t(t.value), C = m.includes(
      f.animationName
    );
    f.target === t.value && C && r("ANIMATION_END"), f.target === t.value && m === "none" && r("ANIMATION_END");
  }, u = (f) => {
    f.target === t.value && (n.value = _t(t.value));
  }, d = X(
    t,
    (f, m) => {
      f ? (e.value = getComputedStyle(f), f.addEventListener("animationstart", u), f.addEventListener("animationcancel", l), f.addEventListener("animationend", l)) : (r("ANIMATION_END"), m == null || m.removeEventListener("animationstart", u), m == null || m.removeEventListener("animationcancel", l), m == null || m.removeEventListener("animationend", l));
    },
    { immediate: !0 }
  ), c = X(i, () => {
    const f = _t(t.value);
    n.value = i.value === "mounted" ? f : "none";
  });
  return fe(() => {
    d(), c();
  }), {
    isPresent: P(
      () => ["mounted", "unmountSuspended"].includes(i.value)
    )
  };
}
function _t(o) {
  return o && getComputedStyle(o).animationName || "none";
}
const se = g({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(o, { slots: t, expose: e }) {
    var d;
    const { present: n, forceMount: s } = z(o), i = x(), { isPresent: r } = ws(n, i);
    e({ present: r });
    let l = t.default({ present: r });
    l = Dt(l || []);
    const u = Ve();
    if (l && (l == null ? void 0 : l.length) > 1) {
      const c = (d = u == null ? void 0 : u.parent) != null && d.type.name ? `<${u.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${c}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((p) => `  - ${p}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => s.value || n.value || r.value ? ke(t.default({ present: r })[0], {
      ref: (c) => {
        const p = ve(c);
        return typeof (p == null ? void 0 : p.hasAttribute) > "u" || (p != null && p.hasAttribute("data-radix-popper-content-wrapper") ? i.value = p.firstChild : i.value = p), p;
      }
    }) : null;
  }
}), Ss = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = On(), n = x(), { primitiveElement: s, currentElement: i } = R(), r = x(0), l = x(0), u = P(() => e.open.value), d = x(u.value), c = x();
    return X(
      () => {
        var p;
        return [u.value, (p = n.value) == null ? void 0 : p.present];
      },
      async () => {
        await Y();
        const p = i.value;
        if (!p)
          return;
        c.value = c.value || {
          transitionDuration: p.style.transitionDuration,
          animationName: p.style.animationName
        }, p.style.transitionDuration = "0s", p.style.animationName = "none";
        const f = p.getBoundingClientRect();
        l.value = f.height, r.value = f.width, d.value || (p.style.transitionDuration = c.value.transitionDuration, p.style.animationName = c.value.animationName);
      },
      {
        immediate: !0
      }
    ), U(() => {
      requestAnimationFrame(() => {
        d.value = !1;
      });
    }), (p, f) => (h(), b(a(se), {
      ref_key: "presentRef",
      ref: n,
      present: p.forceMount || a(e).open.value,
      "force-mount": !0
    }, {
      default: v(() => {
        var m, C;
        return [
          F(a(T), B(p.$attrs, {
            id: a(e).contentId,
            ref_key: "primitiveElement",
            ref: s,
            "as-child": t.asChild,
            as: p.as,
            "data-state": a(e).open.value ? "open" : "closed",
            "data-disabled": (m = a(e).disabled) != null && m.value ? "true" : void 0,
            hidden: !((C = n.value) != null && C.present),
            style: {
              "--radix-collapsible-content-height": `${l.value}px`,
              "--radix-collapsible-content-width": `${r.value}px`
            }
          }), {
            default: v(() => {
              var w;
              return [
                (w = n.value) != null && w.present ? y(p.$slots, "default", { key: 0 }) : q("", !0)
              ];
            }),
            _: 3
          }, 16, ["id", "as-child", "as", "data-state", "data-disabled", "hidden", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
});
function Es(o, t) {
  if (o === "single") {
    if (Array.isArray(t)) {
      console.error(`Invalid prop \`value\` of value \`${t}\` supplied to \`AccordionRoot\`, which type is \`single\`. The \`value\` prop must be:
  - a string
  - \`undefined\`

If you want to use multiple values, use the \`AccordionRoot\` with type \`multiple\`.

Defaulting to \`undefined\`.`);
      return;
    }
  } else if (o === "multiple" && (typeof t == "string" || typeof t > "u"))
    return console.error(`Invalid prop \`value\` of value \`${t}\` supplied to \`AccordionRoot\`, which type is \`multiple\`. The \`value\` prop must be:
- an array of strings
- empty array (\`[]\`)

If you want to use just one value, use the \`AccordionRoot\` with type \`single\`.

Defaulting to empty array (\`[]\`).`), [];
  return t;
}
function xs({ type: o, defaultValue: t }) {
  if (o === "multiple")
    return Array.isArray(t) ? t : t === void 0 ? [] : (console.error(
      `Invalid prop \`defaultValue\` of value \`${t}\` supplied to \`AccordionRoot\`, which type is \`multiple\`. The \`defaultValue\` prop must be:
  - an array of strings
  - empty array (\`[]\`)

If you want to use just one value, use the \`AccordionRoot\` with type \`single\`.

Defaulting to empty array (\`[]\`).`
    ), []);
  if (o === "single") {
    if (typeof t == "string")
      return t;
    if (t === void 0)
      return;
    console.error(
      `Invalid prop \`defaultValue\` of value \`${t}\` supplied to \`AccordionRoot\`, which type is \`single\`. The \`defaultValue\` prop must be:
  - a string
  - \`undefined\`

Defaulting to \`undefined\`.`
    );
    return;
  }
}
function $n(o, t) {
  const e = J(o, "modelValue", t, {
    defaultValue: xs(o),
    passive: o.modelValue === void 0
  });
  X(
    () => [o.type, o.modelValue],
    () => {
      const s = Es(o.type, e.value);
      e.value !== s && (e.value = s);
    },
    { immediate: !0 }
  );
  function n(s) {
    if (o.type === "single")
      e.value = s === e.value ? void 0 : s;
    else {
      const i = e.value || [];
      if (i.includes(s)) {
        const r = i.findIndex((l) => l === s);
        i.splice(r, 1);
      } else
        i.push(s);
      e.value = i, t("update:modelValue", e.value);
    }
  }
  return {
    modelValue: e,
    changeModelValue: n
  };
}
const [At, Os] = H("AccordionRoot"), Yl = /* @__PURE__ */ g({
  __name: "AccordionRoot",
  props: {
    type: {},
    modelValue: {},
    defaultValue: {},
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    asChild: { type: Boolean, default: !1 },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(o, { expose: t, emit: e }) {
    const n = o, s = e, { dir: i, disabled: r } = z(n), l = de(i), { modelValue: u, changeModelValue: d } = $n(n, s), { primitiveElement: c, currentElement: p } = R();
    return Os({
      disabled: r,
      direction: l,
      orientation: n.orientation,
      parentElement: p,
      isSingle: P(() => n.type === "single"),
      collapsible: n.collapsible,
      modelValue: u,
      changeModelValue: d
    }), t({
      modelValue: u
    }), (f, m) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: c,
      "as-child": f.asChild,
      as: f.as
    }, {
      default: v(() => [
        y(f.$slots, "default", { modelValue: a(u) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [Eo, $s] = H("AccordionItem"), Xl = /* @__PURE__ */ g({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o, { expose: t }) {
    const e = o, n = At(), s = P(
      () => n.isSingle.value ? e.value === n.modelValue.value : Array.isArray(n.modelValue.value) && n.modelValue.value.includes(e.value)
    ), i = P(() => n.disabled.value || e.disabled || n.isSingle.value && s.value && !n.collapsible), r = P(() => i.value ? "" : void 0), l = P(
      () => s.value ? "open" : "closed"
      /* Closed */
    ), { primitiveElement: u, currentElement: d } = R();
    $s({
      open: s,
      dataState: l,
      disabled: i,
      dataDisabled: r,
      triggerId: oe(),
      primitiveElement: u,
      currentElement: d,
      value: P(() => e.value)
    });
    function c(p) {
      qe(
        p,
        d.value,
        n.parentElement.value,
        {
          arrowKeyOptions: n.orientation,
          dir: n.direction.value,
          focus: !0
        }
      );
    }
    return t({ open: s }), (p, f) => (h(), b(a(Cs), {
      "data-orientation": a(n).orientation,
      "data-disabled": r.value,
      "data-state": l.value,
      disabled: i.value,
      open: s.value,
      "as-child": e.asChild,
      onKeydown: ie(c, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: v(() => [
        y(p.$slots, "default", { open: s.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as-child", "onKeydown"]));
  }
}), Jl = /* @__PURE__ */ g({
  __name: "AccordionContent",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = At(), n = Eo();
    return (s, i) => (h(), b(a(Ss), {
      id: a(n).triggerId,
      role: "region",
      open: a(n).open.value,
      hidden: !a(n).open.value,
      "as-child": t.asChild,
      "aria-labelledby": a(n).triggerId,
      "data-state": a(n).dataState.value,
      "data-disabled": a(n).dataDisabled.value,
      "data-orientation": a(e).orientation,
      style: { "--radix-accordion-content-width": "var(--radix-collapsible-content-width)", "--radix-accordion-content-height": "var(--radix-collapsible-content-height)" }
    }, {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "open", "hidden", "as-child", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), Zl = /* @__PURE__ */ g({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "h3" }
  },
  setup(o) {
    const t = o, e = At(), n = Eo();
    return (s, i) => (h(), b(a(T), {
      as: t.as,
      "as-child": t.asChild,
      "data-orientation": a(e).orientation,
      "data-state": a(n).dataState.value,
      "data-disabled": a(n).dataDisabled.value
    }, {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), Ql = /* @__PURE__ */ g({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = At(), n = Eo();
    function s() {
      n.disabled.value || e.changeModelValue(n.value.value);
    }
    return (i, r) => (h(), b(a(_s), {
      id: a(n).triggerId,
      ref: a(n).primitiveElement,
      "data-radix-vue-collection-item": "",
      as: t.as,
      "as-child": t.asChild,
      "aria-controls": a(n).triggerId,
      "aria-disabled": a(n).disabled.value || void 0,
      "aria-expanded": a(n).open.value || !1,
      "data-disabled": a(n).dataDisabled.value,
      "data-orientation": a(e).orientation,
      "data-state": a(n).dataState.value,
      disabled: a(n).disabled.value,
      onClick: s
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-controls", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), [ye, Ps] = H("DialogRoot"), Bs = /* @__PURE__ */ g({
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "open", t, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    }), i = x(), r = x(), { modal: l } = z(e);
    return Ps({
      open: s,
      modal: l,
      openModal: () => {
        s.value = !0;
      },
      onOpenChange: (u) => {
        s.value = u;
      },
      onOpenToggle: () => {
        s.value = !s.value;
      },
      contentId: oe(),
      titleId: oe(),
      descriptionId: oe(),
      triggerElement: i,
      contentElement: r
    }), (u, d) => y(u.$slots, "default");
  }
}), Ts = /* @__PURE__ */ g({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = ye(), { primitiveElement: n, currentElement: s } = R();
    return U(() => {
      e.triggerElement = s;
    }), (i, r) => (h(), b(a(T), B({
      ref_key: "primitiveElement",
      ref: n
    }, t, {
      type: i.as === "button" ? "button" : void 0,
      "aria-haspopup": "dialog",
      "aria-expanded": a(e).open.value || !1,
      "aria-controls": a(e).contentId,
      "data-state": a(e).open.value ? "open" : "closed",
      onClick: a(e).onOpenToggle
    }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "onClick"]));
  }
}), $e = /* @__PURE__ */ g({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = Tt();
    return (e, n) => a(t) || e.forceMount ? (h(), b(Ue, {
      key: 0,
      to: e.to,
      disabled: e.disabled
    }, [
      y(e.$slots, "default")
    ], 8, ["to", "disabled"])) : q("", !0);
  }
}), eu = /* @__PURE__ */ g({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ds = "dismissableLayer.pointerDownOutside", Is = "dismissableLayer.focusOutside";
function Pn(o, t) {
  const e = t.closest(
    "[data-dismissable-layer]"
  ), n = o.querySelector(
    "[data-dismissable-layer]"
  ), s = Array.from(
    o.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(e && n === e || s.indexOf(n) < s.indexOf(e));
}
function As(o, t) {
  var i;
  const e = ((i = t == null ? void 0 : t.value) == null ? void 0 : i.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), n = x(!1), s = x(() => {
  });
  return ee((r) => {
    if (!Oe)
      return;
    const l = async (d) => {
      if (t != null && t.value) {
        if (Pn(t.value, d.target)) {
          n.value = !1;
          return;
        }
        if (d.target && !n.value) {
          let c = function() {
            vo(
              Ds,
              o,
              p
            );
          };
          const p = { originalEvent: d };
          d.pointerType === "touch" ? (e.removeEventListener("click", s.value), s.value = c, e.addEventListener("click", s.value, {
            once: !0
          })) : c();
        } else
          e.removeEventListener("click", s.value);
        n.value = !1;
      }
    }, u = window.setTimeout(() => {
      e.addEventListener("pointerdown", l);
    }, 0);
    r(() => {
      window.clearTimeout(u), e.removeEventListener("pointerdown", l), e.removeEventListener("click", s.value);
    });
  }), {
    onPointerDownCapture: () => n.value = !0
  };
}
function Fs(o, t) {
  var s;
  const e = ((s = t == null ? void 0 : t.value) == null ? void 0 : s.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), n = x(!1);
  return ee((i) => {
    if (!Oe)
      return;
    const r = async (l) => {
      t != null && t.value && (await Y(), !Pn(t.value, l.target) && l.target && !n.value && vo(
        Is,
        o,
        { originalEvent: l }
      ));
    };
    e.addEventListener("focusin", r), i(() => e.removeEventListener("focusin", r));
  }), {
    onFocusCapture: () => n.value = !0,
    onBlurCapture: () => n.value = !1
  };
}
const he = hn({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Pe = /* @__PURE__ */ g({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const e = o, n = t, { primitiveElement: s, currentElement: i } = R(), r = P(
      () => {
        var C;
        return ((C = i.value) == null ? void 0 : C.ownerDocument) ?? globalThis.document;
      }
    ), l = P(() => he.layersRoot), u = P(() => i.value ? Array.from(l.value).indexOf(i.value) : -1), d = P(() => he.layersWithOutsidePointerEventsDisabled.size > 0), c = P(() => {
      const C = Array.from(l.value), [w] = [...he.layersWithOutsidePointerEventsDisabled].slice(-1), O = C.indexOf(w);
      return u.value >= O;
    }), p = As(async (C) => {
      const w = [...he.branches].some(
        (O) => O.contains(C.target)
      );
      !c.value || w || (n("pointerDownOutside", C), n("interactOutside", C), await Y(), C.defaultPrevented || n("dismiss"));
    }, i), f = Fs((C) => {
      [...he.branches].some(
        (O) => O.contains(C.target)
      ) || (n("focusOutside", C), n("interactOutside", C), C.defaultPrevented || n("dismiss"));
    }, i);
    bo("Escape", (C) => {
      u.value === l.value.size - 1 && (n("escapeKeyDown", C), C.defaultPrevented || n("dismiss"));
    });
    let m;
    return ee((C) => {
      i.value && (e.disableOutsidePointerEvents && (he.layersWithOutsidePointerEventsDisabled.size === 0 && (m = r.value.body.style.pointerEvents, r.value.body.style.pointerEvents = "none"), he.layersWithOutsidePointerEventsDisabled.add(i.value)), l.value.add(i.value), C(() => {
        e.disableOutsidePointerEvents && he.layersWithOutsidePointerEventsDisabled.size === 1 && (r.value.body.style.pointerEvents = m);
      }));
    }), ee((C) => {
      C(() => {
        i.value && (l.value.delete(i.value), he.layersWithOutsidePointerEventsDisabled.delete(i.value));
      });
    }), (C, w) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: s,
      "as-child": C.asChild,
      as: C.as,
      "data-dismissable-layer": "",
      style: ae({
        pointerEvents: d.value ? c.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: a(f).onFocusCapture,
      onBlurCapture: a(f).onBlurCapture,
      onPointerdownCapture: a(p).onPointerDownCapture
    }, {
      default: v(() => [
        y(C.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), Ms = /* @__PURE__ */ g({
  __name: "DismissableLayerBranch",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, { primitiveElement: e, currentElement: n } = R();
    return U(() => {
      he.branches.add(n.value);
    }), fe(() => {
      he.branches.delete(n.value);
    }), (s, i) => (h(), b(a(T), B({
      ref_key: "primitiveElement",
      ref: e
    }, t), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), eo = "focusScope.autoFocusOnMount", to = "focusScope.autoFocusOnUnmount", nn = { bubbles: !1, cancelable: !0 };
function xt(o, { select: t = !1 } = {}) {
  const e = document.activeElement;
  for (const n of o)
    if (Ee(n, { select: t }), document.activeElement !== e)
      return !0;
}
function ks(o) {
  const t = xo(o), e = an(t, o), n = an(t.reverse(), o);
  return [e, n];
}
function xo(o) {
  const t = [], e = document.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const s = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || s ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; e.nextNode(); )
    t.push(e.currentNode);
  return t;
}
function an(o, t) {
  for (const e of o)
    if (!Rs(e, { upTo: t }))
      return e;
}
function Rs(o, { upTo: t }) {
  if (getComputedStyle(o).visibility === "hidden")
    return !0;
  for (; o; ) {
    if (t !== void 0 && o === t)
      return !1;
    if (getComputedStyle(o).display === "none")
      return !0;
    o = o.parentElement;
  }
  return !1;
}
function Vs(o) {
  return o instanceof HTMLInputElement && "select" in o;
}
function Ee(o, { select: t = !1 } = {}) {
  if (o && o.focus) {
    const e = document.activeElement;
    o.focus({ preventScroll: !0 }), o !== e && Vs(o) && t && o.select();
  }
}
const js = Bt(() => x([]));
function Ls() {
  const o = js();
  return {
    add(t) {
      const e = o.value[0];
      t !== e && (e == null || e.pause()), o.value = sn(o.value, t), o.value.unshift(t);
    },
    remove(t) {
      var e;
      o.value = sn(o.value, t), (e = o.value[0]) == null || e.resume();
    }
  };
}
function sn(o, t) {
  const e = [...o], n = e.indexOf(t);
  return n !== -1 && e.splice(n, 1), e;
}
function Ks(o) {
  return o.filter((t) => t.tagName !== "A");
}
const Ft = /* @__PURE__ */ g({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, { primitiveElement: s, currentElement: i } = R(), r = x(null), l = Ls(), u = hn({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    ee((c) => {
      if (!Oe)
        return;
      const p = i.value;
      if (!e.trapped)
        return;
      function f(O) {
        if (u.paused || !p)
          return;
        const _ = O.target;
        p.contains(_) ? r.value = _ : Ee(r.value, { select: !0 });
      }
      function m(O) {
        if (u.paused || !p)
          return;
        const _ = O.relatedTarget;
        _ !== null && (p.contains(_) || Ee(r.value, { select: !0 }));
      }
      function C(O) {
        p.contains(r.value) || Ee(p);
      }
      document.addEventListener("focusin", f), document.addEventListener("focusout", m);
      const w = new MutationObserver(C);
      p && w.observe(p, { childList: !0, subtree: !0 }), c(() => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", m), w.disconnect();
      });
    }), ee(async (c) => {
      const p = i.value;
      if (await Y(), !p)
        return;
      l.add(u);
      const f = document.activeElement;
      if (!p.contains(f)) {
        const C = new CustomEvent(eo, nn);
        p.addEventListener(
          eo,
          (w) => n("mountAutoFocus", w)
        ), p.dispatchEvent(C), C.defaultPrevented || (xt(Ks(xo(p)), {
          select: !0
        }), document.activeElement === f && Ee(p));
      }
      c(() => {
        p.removeEventListener(
          eo,
          (O) => n("mountAutoFocus", O)
        );
        const C = new CustomEvent(to, nn), w = (O) => {
          n("unmountAutoFocus", O);
        };
        p.addEventListener(to, w), p.dispatchEvent(C), setTimeout(() => {
          C.defaultPrevented || Ee(f ?? document.body, { select: !0 }), p.removeEventListener(to, w), l.remove(u);
        }, 0);
      });
    });
    function d(c) {
      if (!e.loop && !e.trapped || u.paused)
        return;
      const p = c.key === "Tab" && !c.altKey && !c.ctrlKey && !c.metaKey, f = document.activeElement;
      if (p && f) {
        const m = c.currentTarget, [C, w] = ks(m);
        C && w ? !c.shiftKey && f === w ? (c.preventDefault(), e.loop && Ee(C, { select: !0 })) : c.shiftKey && f === C && (c.preventDefault(), e.loop && Ee(w, { select: !0 })) : f === m && c.preventDefault();
      }
    }
    return (c, p) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: s,
      tabindex: "-1",
      "as-child": e.asChild,
      as: e.as,
      onKeydown: d
    }, {
      default: v(() => [
        y(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), Ns = "menu.itemSelect", no = ["Enter", " "], Hs = ["ArrowDown", "PageUp", "Home"], Bn = ["ArrowUp", "PageDown", "End"], Ws = [...Hs, ...Bn], zs = {
  ltr: [...no, "ArrowRight"],
  rtl: [...no, "ArrowLeft"]
}, Us = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
};
function Oo(o) {
  return o ? "open" : "closed";
}
function $t(o) {
  return o === "indeterminate";
}
function $o(o) {
  return $t(o) ? "indeterminate" : o ? "checked" : "unchecked";
}
function ao(o) {
  const t = document.activeElement;
  for (const e of o)
    if (e === t || (e.focus(), document.activeElement !== t))
      return;
}
function qs(o, t) {
  const { x: e, y: n } = o;
  let s = !1;
  for (let i = 0, r = t.length - 1; i < t.length; r = i++) {
    const l = t[i].x, u = t[i].y, d = t[r].x, c = t[r].y;
    u > n != c > n && e < (d - l) * (n - u) / (c - u) + l && (s = !s);
  }
  return s;
}
function Gs(o, t) {
  if (!t)
    return !1;
  const e = { x: o.clientX, y: o.clientY };
  return qs(e, t);
}
function st(o) {
  return o.pointerType === "mouse";
}
function Ys() {
  const o = "DialogContent", t = "DialogTitle", e = ye(), n = `Warning: \`${o}\` requires a \`${t}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.radix-vue.com/components/dialog.html#title;`, s = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${o}.`;
  U(() => {
    var l;
    document.getElementById(e.titleId) || console.warn(n);
    const r = (l = e.contentElement.value) == null ? void 0 : l.getAttribute("aria-describedby");
    e.descriptionId && r && (document.getElementById(e.descriptionId) || console.warn(s));
  });
}
const Tn = /* @__PURE__ */ g({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = ye(), { primitiveElement: i, currentElement: r } = R();
    return U(() => {
      s.contentElement = r;
    }), process.env.NODE_ENV !== "production" && Ys(), (l, u) => (h(), b(a(Ft), {
      "as-child": "",
      loop: "",
      trapped: e.trapFocus,
      onMountAutoFocus: u[5] || (u[5] = (d) => n("openAutoFocus", d)),
      onUnmountAutoFocus: u[6] || (u[6] = (d) => n("closeAutoFocus", d))
    }, {
      default: v(() => [
        F(a(Pe), B({
          id: a(s).contentId,
          ref_key: "primitiveElement",
          ref: i,
          as: l.as,
          "as-child": l.asChild,
          "disable-outside-pointer-events": l.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": a(s).descriptionId,
          "aria-labelledby": a(s).titleId,
          "data-state": a(Oo)(a(s).open.value)
        }, l.$attrs, {
          onDismiss: u[0] || (u[0] = (d) => a(s).onOpenChange(!1)),
          onEscapeKeyDown: u[1] || (u[1] = (d) => n("escapeKeyDown", d)),
          onFocusOutside: u[2] || (u[2] = (d) => n("focusOutside", d)),
          onInteractOutside: u[3] || (u[3] = (d) => n("interactOutside", d)),
          onPointerDownOutside: u[4] || (u[4] = (d) => n("pointerDownOutside", d))
        }), {
          default: v(() => [
            y(l.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), Xs = /* @__PURE__ */ g({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = ye(), i = ce(n), { primitiveElement: r, currentElement: l } = R();
    return ft(l), (u, d) => (h(), b(Tn, B({
      ref_key: "primitiveElement",
      ref: r
    }, { ...e, ...a(i) }, {
      "trap-focus": a(s).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: d[0] || (d[0] = (c) => {
        var p;
        n("closeAutoFocus", c), c.defaultPrevented || (c.preventDefault(), (p = a(s).triggerElement.value) == null || p.focus());
      }),
      onPointerDownOutside: d[1] || (d[1] = (c) => {
        const p = c.detail.originalEvent, f = p.button === 0 && p.ctrlKey === !0;
        (p.button === 2 || f) && c.preventDefault();
      }),
      onFocusOutside: d[2] || (d[2] = (c) => {
        c.preventDefault();
      }),
      onOpenAutoFocus: d[3] || (d[3] = (c) => n("openAutoFocus", c))
    }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), Js = /* @__PURE__ */ g({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = ce(n), i = ye(), r = x(!1), l = x(!1);
    return (u, d) => (h(), b(Tn, B({ ...e, ...a(s) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: d[0] || (d[0] = (c) => {
        var p;
        n("closeAutoFocus", c), c.defaultPrevented || (r.value || (p = a(i).triggerElement.value) == null || p.focus(), c.preventDefault()), r.value = !1, l.value = !1;
      }),
      onInteractOutside: d[1] || (d[1] = (c) => {
        var m;
        c.defaultPrevented || (r.value = !0, c.detail.originalEvent.type === "pointerdown" && (l.value = !0));
        const p = c.target;
        ((m = a(i).triggerElement.value) == null ? void 0 : m.contains(p)) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && l.value && c.preventDefault();
      })
    }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Zs = /* @__PURE__ */ g({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = ye(), i = ce(n);
    return (r, l) => (h(), b(a(se), {
      present: r.forceMount || a(s).open.value
    }, {
      default: v(() => [
        a(s).modal.value ? (h(), b(Xs, B({ key: 0 }, { ...e, ...a(i), ...r.$attrs }, {
          onOpenAutoFocus: l[0] || (l[0] = (u) => n("openAutoFocus", u))
        }), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16)) : (h(), b(Js, k(B({ key: 1 }, { ...e, ...a(i), ...r.$attrs })), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Qs = /* @__PURE__ */ g({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = ye();
    return pt(!0), (e, n) => (h(), b(a(T), {
      as: e.as,
      "as-child": e.asChild,
      "data-state": a(t).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), ei = /* @__PURE__ */ g({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = ye();
    return (e, n) => {
      var s;
      return (s = a(t)) != null && s.modal.value ? (h(), b(a(se), {
        key: 0,
        present: e.forceMount || a(t).open.value
      }, {
        default: v(() => [
          F(Qs, B({
            as: e.as,
            "as-child": e.asChild
          }, e.$attrs), {
            default: v(() => [
              y(e.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : q("", !0);
    };
  }
}), Dn = /* @__PURE__ */ g({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = ye();
    return (n, s) => (h(), b(a(T), B(t, {
      type: n.as === "button" ? "button" : void 0,
      onClick: s[0] || (s[0] = (i) => a(e).onOpenChange(!1))
    }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), ti = /* @__PURE__ */ g({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "h2" }
  },
  setup(o) {
    const t = o, e = ye();
    return (n, s) => (h(), b(a(T), B(t, {
      id: a(e).titleId
    }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), oi = /* @__PURE__ */ g({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "p" }
  },
  setup(o) {
    const t = o, e = ye();
    return (n, s) => (h(), b(a(T), B(t, {
      id: a(e).descriptionId
    }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), tu = /* @__PURE__ */ g({
  __name: "AlertDialogRoot",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const s = pe(o, t);
    return (i, r) => (h(), b(a(Bs), B(a(s), { modal: !0 }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ou = /* @__PURE__ */ g({
  __name: "AlertDialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ts), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), nu = /* @__PURE__ */ g({
  __name: "AlertDialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [ni, ai] = H("AlertDialogContent"), au = /* @__PURE__ */ g({
  __name: "AlertDialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t), i = x();
    return ai({
      onCancelElementChange: (r) => {
        i.value = r;
      }
    }), (r, l) => (h(), b(a(Zs), B({ ...e, ...a(s) }, {
      role: "alertdialog",
      onPointerDownOutside: l[0] || (l[0] = te(() => {
      }, ["prevent"])),
      onInteractOutside: l[1] || (l[1] = te(() => {
      }, ["prevent"])),
      onOpenAutoFocus: l[2] || (l[2] = () => {
        Y(() => {
          var u;
          (u = i.value) == null || u.focus({
            preventScroll: !0
          });
        });
      })
    }), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), su = /* @__PURE__ */ g({
  __name: "AlertDialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(ei), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), iu = /* @__PURE__ */ g({
  __name: "AlertDialogCancel",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = ni(), { primitiveElement: n, currentElement: s } = R();
    return U(() => {
      e.onCancelElementChange(s.value);
    }), (i, r) => (h(), b(a(Dn), B(t, {
      ref_key: "primitiveElement",
      ref: n
    }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ru = /* @__PURE__ */ g({
  __name: "AlertDialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(ti), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), lu = /* @__PURE__ */ g({
  __name: "AlertDialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(oi), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), uu = /* @__PURE__ */ g({
  __name: "AlertDialogAction",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Dn), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), du = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "AspectRatio",
  props: {
    ratio: { default: 1 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o, e = P(() => 1 / t.ratio * 100);
    return (n, s) => (h(), Q("div", {
      style: ae(`position: relative; width: 100%; padding-bottom: ${e.value}%`),
      "data-radix-aspect-ratio-wrapper": ""
    }, [
      F(a(T), B({
        "as-child": n.asChild,
        as: n.as,
        style: { position: "absolute", inset: "0px" }
      }, n.$attrs), {
        default: v(() => [
          y(n.$slots, "default", { aspect: e.value })
        ]),
        _: 3
      }, 16, ["as-child", "as"])
    ], 4));
  }
}), [In, si] = H("AvatarRoot"), cu = /* @__PURE__ */ g({
  __name: "AvatarRoot",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o;
    return si({
      imageLoadingStatus: x("loading")
    }), (e, n) => (h(), b(a(T), {
      as: e.as,
      "as-child": t.asChild
    }, {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function ii(o) {
  const t = x("idle"), e = x(!1), n = (s) => () => {
    e.value && (t.value = s);
  };
  return U(() => {
    e.value = !0, X(o, (s) => {
      if (!s)
        t.value = "error";
      else {
        const i = new window.Image();
        t.value = "loading", i.onload = n("loaded"), i.onerror = n("error"), i.src = s;
      }
    }, { immediate: !0 });
  }), fe(() => {
    e.value = !1;
  }), t;
}
const pu = /* @__PURE__ */ g({
  __name: "AvatarImage",
  props: {
    src: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "img" }
  },
  emits: ["loadingStatusChange"],
  setup(o, { emit: t }) {
    const e = o, n = t, { src: s } = z(e), i = In(), r = ii(s);
    return X(
      r,
      (l) => {
        n("loadingStatusChange", l), l !== "idle" && (i.imageLoadingStatus.value = l);
      },
      { immediate: !0 }
    ), (l, u) => a(r) === "loaded" ? (h(), b(a(T), {
      key: 0,
      role: "img",
      "as-child": l.asChild,
      as: l.as,
      src: a(s)
    }, {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "src"])) : q("", !0);
  }
}), fu = /* @__PURE__ */ g({
  __name: "AvatarFallback",
  props: {
    delayMs: { default: 0 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = In(), n = x(!1);
    let s;
    return X(e.imageLoadingStatus, (i) => {
      i === "loading" && (n.value = !1, t.delayMs ? s = setTimeout(() => {
        n.value = !0, clearTimeout(s);
      }, t.delayMs) : n.value = !0);
    }, { immediate: !0 }), (i, r) => n.value && a(e).imageLoadingStatus.value !== "loaded" ? (h(), b(a(T), {
      key: 0,
      "as-child": t.asChild,
      as: i.as
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"])) : q("", !0);
  }
});
function Po(o) {
  return o === "indeterminate";
}
function An(o) {
  return Po(o) ? "indeterminate" : o ? "checked" : "unchecked";
}
const ri = ["value", "checked", "name", "disabled", "required"], [li, ui] = H("CheckboxRoot"), vu = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "CheckboxRoot",
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: [Boolean, String], default: void 0 },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    value: { default: "on" },
    id: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  emits: ["update:checked"],
  setup(o, { emit: t }) {
    const e = o, n = t, { disabled: s } = z(e), i = J(e, "checked", n, {
      defaultValue: e.defaultChecked,
      passive: e.checked === void 0
    }), { primitiveElement: r, currentElement: l } = R(), u = Le(l), d = P(() => {
      var c;
      return e.id && l.value ? (c = document.querySelector(`[for="${e.id}"]`)) == null ? void 0 : c.innerText : void 0;
    });
    return ui({
      disabled: s,
      state: i
    }), (c, p) => (h(), Q(re, null, [
      F(a(T), B(c.$attrs, {
        id: c.id,
        ref_key: "primitiveElement",
        ref: r,
        role: "checkbox",
        "as-child": e.asChild,
        as: c.as,
        type: c.as === "button" ? "button" : void 0,
        "aria-checked": a(Po)(a(i)) ? "mixed" : a(i),
        "aria-required": !1,
        "aria-label": c.$attrs["aria-label"] || d.value,
        "data-state": a(An)(a(i)),
        "data-disabled": a(s) ? "" : void 0,
        disabled: a(s),
        onKeydown: ie(te(() => {
        }, ["prevent"]), ["enter"]),
        onClick: p[0] || (p[0] = (f) => i.value = !a(i))
      }), {
        default: v(() => [
          y(c.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "as-child", "as", "type", "aria-checked", "aria-label", "data-state", "data-disabled", "disabled", "onKeydown"]),
      a(u) ? (h(), Q("input", {
        key: 0,
        type: "checkbox",
        tabindex: "-1",
        "aria-hidden": "",
        value: c.value,
        checked: !!a(i),
        name: e.name,
        disabled: e.disabled,
        required: e.required,
        style: ae({
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        })
      }, null, 12, ri)) : q("", !0)
    ], 64));
  }
}), mu = /* @__PURE__ */ g({
  __name: "CheckboxIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = li();
    return (e, n) => (h(), b(a(se), {
      present: e.forceMount || a(Po)(a(t).state.value) || a(t).state.value === !0
    }, {
      default: v(() => [
        F(a(T), B({
          "data-state": a(An)(a(t).state.value),
          "data-disabled": a(t).disabled.value ? "" : void 0,
          style: { pointerEvents: "none" },
          "as-child": e.asChild,
          as: e.as
        }, e.$attrs), {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "data-disabled", "as-child", "as"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), [Fn, di] = H("PopperRoot"), Ke = /* @__PURE__ */ g({
  __name: "PopperRoot",
  setup(o) {
    const t = x();
    return di({
      anchor: t,
      onAnchorChange: (e) => t.value = e
    }), (e, n) => y(e.$slots, "default");
  }
}), Ne = /* @__PURE__ */ g({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, { primitiveElement: e, currentElement: n } = R(), s = Fn();
    return X(n, () => {
      s.onAnchorChange(t.element ?? n.value);
    }), (i, r) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: e,
      as: i.as,
      "as-child": i.asChild
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function ci(o) {
  return o !== null;
}
function pi(o) {
  return {
    name: "transformOrigin",
    options: o,
    fn(t) {
      var O, _, S;
      const { placement: e, rects: n, middlewareData: s } = t, r = ((O = s.arrow) == null ? void 0 : O.centerOffset) !== 0, l = r ? 0 : o.arrowWidth, u = r ? 0 : o.arrowHeight, [d, c] = so(e), p = { start: "0%", center: "50%", end: "100%" }[c], f = (((_ = s.arrow) == null ? void 0 : _.x) ?? 0) + l / 2, m = (((S = s.arrow) == null ? void 0 : S.y) ?? 0) + u / 2;
      let C = "", w = "";
      return d === "bottom" ? (C = r ? p : `${f}px`, w = `${-u}px`) : d === "top" ? (C = r ? p : `${f}px`, w = `${n.floating.height + u}px`) : d === "right" ? (C = `${-u}px`, w = r ? p : `${m}px`) : d === "left" && (C = `${n.floating.width + u}px`, w = r ? p : `${m}px`), { data: { x: C, y: w } };
    }
  };
}
function so(o) {
  const [t, e = "center"] = o.split("-");
  return [t, e];
}
const Mn = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [fi, vi] = H("PopperContent"), Ge = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: yn({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  }, {
    ...Mn
  }),
  setup(o, { expose: t }) {
    const e = o, n = Fn(), s = be(), { primitiveElement: i, currentElement: r } = R(), l = x(), u = x(), { width: d, height: c } = En(u), p = P(
      () => e.side + (e.align !== "center" ? `-${e.align}` : "")
    ), f = P(() => typeof e.collisionPadding == "number" ? e.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...e.collisionPadding }), m = P(() => Array.isArray(e.collisionBoundary) ? e.collisionBoundary : [e.collisionBoundary]), C = P(() => ({
      padding: f.value,
      boundary: m.value.filter(ci),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: m.value.length > 0
    })), w = za(() => [
      Va({
        mainAxis: e.sideOffset + c.value,
        alignmentAxis: e.alignOffset
      }),
      e.avoidCollisions && ja({
        mainAxis: !0,
        crossAxis: !!e.prioritizePosition,
        limiter: e.sticky === "partial" ? La() : void 0,
        ...C.value
      }),
      !e.prioritizePosition && e.avoidCollisions && Ka({
        ...C.value
      }),
      Na({
        ...C.value,
        apply: ({ elements: D, rects: L, availableWidth: W, availableHeight: Z }) => {
          const { width: j, height: G } = L.reference, ne = D.floating.style;
          Object.assign(D.floating.style, {
            maxWidth: `${W}px`,
            maxHeight: `${Z}px`
          }), ne.setProperty(
            "--radix-popper-available-width",
            `${W}px`
          ), ne.setProperty(
            "--radix-popper-available-height",
            `${Z}px`
          ), ne.setProperty(
            "--radix-popper-anchor-width",
            `${j}px`
          ), ne.setProperty(
            "--radix-popper-anchor-height",
            `${G}px`
          );
        }
      }),
      u.value && Ha({ element: u.value, padding: e.arrowPadding }),
      pi({
        arrowWidth: d.value,
        arrowHeight: c.value
      }),
      e.hideWhenDetached && Wa({ strategy: "referenceHidden", ...C.value })
    ]), { floatingStyles: O, placement: _, isPositioned: S, middlewareData: E } = ka(
      n.anchor,
      l,
      {
        strategy: "fixed",
        placement: p,
        whileElementsMounted: (...D) => Ra(...D, {
          animationFrame: e.updatePositionStrategy === "always"
        }),
        middleware: w
      }
    ), $ = P(
      () => so(_.value)[0]
    ), I = P(
      () => so(_.value)[1]
    );
    ee(() => {
      var D;
      S.value && ((D = e.onPlaced) == null || D.call(e));
    });
    const A = P(
      () => {
        var D;
        return ((D = E.value.arrow) == null ? void 0 : D.centerOffset) !== 0;
      }
    ), V = x("");
    ee(() => {
      r.value && (V.value = window.getComputedStyle(r.value).zIndex);
    });
    const M = P(() => {
      var D;
      return ((D = E.value.arrow) == null ? void 0 : D.x) ?? 0;
    }), N = P(() => {
      var D;
      return ((D = E.value.arrow) == null ? void 0 : D.y) ?? 0;
    });
    return vi({
      placedSide: $,
      onArrowChange: (D) => u.value = D,
      arrowX: M,
      arrowY: N,
      shouldHideArrow: A
    }), t({
      $el: r
    }), (D, L) => {
      var W, Z, j;
      return h(), Q("div", {
        ref_key: "floatingRef",
        ref: l,
        "data-radix-popper-content-wrapper": "",
        style: ae({
          ...a(O),
          transform: a(S) ? a(O).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: V.value,
          "--radix-popper-transform-origin": [
            (W = a(E).transformOrigin) == null ? void 0 : W.x,
            (Z = a(E).transformOrigin) == null ? void 0 : Z.y
          ].join(" ")
        })
      }, [
        F(a(T), B({
          ref: (G) => {
            a(s)(G), i.value = G;
          }
        }, D.$attrs, {
          "as-child": e.asChild,
          as: D.as,
          "data-side": $.value,
          "data-align": I.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: a(S) ? void 0 : "none",
            // hide the content if using the hide middleware and should be hidden
            opacity: (j = a(E).hide) != null && j.referenceHidden ? 0 : void 0
          }
        }), {
          default: v(() => [
            y(D.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), mi = /* @__PURE__ */ lt("polygon", { points: "0,0 30,0 15,10" }, null, -1), hi = /* @__PURE__ */ g({
  __name: "Arrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "svg" }
  },
  setup(o) {
    const t = o, { primitiveElement: e } = R();
    return (n, s) => (h(), b(a(T), B({
      ref_key: "primitiveElement",
      ref: e
    }, t, {
      width: n.width,
      height: n.height,
      viewBox: n.asChild ? void 0 : "0 0 30 10",
      preserveAspectRatio: n.asChild ? void 0 : "none"
    }), {
      default: v(() => [
        y(n.$slots, "default", {}, () => [
          mi
        ])
      ]),
      _: 3
    }, 16, ["width", "height", "viewBox", "preserveAspectRatio"]));
  }
}), yi = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Ye = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "PopperArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "svg" }
  },
  setup(o) {
    const t = fi(), e = P(() => yi[t.placedSide.value]);
    return (n, s) => {
      var i, r, l, u;
      return h(), Q("span", {
        ref: (d) => {
          a(t).onArrowChange(d);
        },
        style: ae({
          position: "absolute",
          left: (i = a(t).arrowX) != null && i.value ? `${(r = a(t).arrowX) == null ? void 0 : r.value}px` : void 0,
          top: (l = a(t).arrowY) != null && l.value ? `${(u = a(t).arrowY) == null ? void 0 : u.value}px` : void 0,
          [e.value]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a(t).placedSide.value],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a(t).placedSide.value],
          visibility: a(t).shouldHideArrow.value ? "hidden" : void 0
        })
      }, [
        F(hi, B(n.$attrs, {
          style: {
            display: "block"
          },
          as: n.as,
          "as-child": n.asChild,
          width: n.width,
          height: n.height
        }), {
          default: v(() => [
            y(n.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "width", "height"])
      ], 4);
    };
  }
}), Xe = /* @__PURE__ */ g({
  __name: "VisuallyHidden",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    return (t, e) => (h(), b(a(T), {
      as: t.as,
      "as-child": t.asChild,
      style: ae({
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        display: "inline-block",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      })
    }, {
      default: v(() => [
        y(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "style"]));
  }
}), kn = /* @__PURE__ */ g({
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(o) {
    const t = o, e = P(() => typeof t.value == "string" || typeof t.value == "number" || typeof t.value == "boolean" ? [{ name: t.name, value: t.value }] : typeof t.value == "object" && Array.isArray(t.value) ? t.value.flatMap((n, s) => typeof n == "object" ? Object.entries(n).map(([i, r]) => ({ name: `[${s}][${t.name}][${i}]`, value: r })) : { name: `[${t.name}][${s}]`, value: n }) : typeof t.value == "object" && !Array.isArray(t.value) ? Object.entries(t.value).map(([n, s]) => ({ name: `[${t.name}][${n}]`, value: s })) : []);
    return (n, s) => (h(!0), Q(re, null, po(e.value, (i) => (h(), b(Xe, {
      key: i.name,
      as: "input",
      type: "hidden",
      hidden: "",
      readonly: "",
      name: i.name,
      value: i.value,
      required: n.required,
      disabled: n.disabled
    }, null, 8, ["name", "value", "required", "disabled"]))), 128));
  }
});
function gi(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var bi = function o(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    var n, s, i;
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (s = n; s-- !== 0; )
        if (!o(t[s], e[s]))
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === e.toString();
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (s = n; s-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[s]))
        return !1;
    for (s = n; s-- !== 0; ) {
      var r = i[s];
      if (!o(t[r], e[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
};
const nt = /* @__PURE__ */ gi(bi), Ci = "data-radix-vue-collection-item", [Bo, _i] = H("CollectionProvider");
function Rn(o = Ci) {
  const t = x(/* @__PURE__ */ new Map()), e = x(), n = _i({
    collectionRef: e,
    itemMap: t,
    attrName: o
  }), { getItems: s } = wi(n), i = P(() => Array.from(n.itemMap.value.values())), r = P(() => n.itemMap.value.size);
  return { getItems: s, reactiveItems: i, itemMapSize: r };
}
const Vn = g({
  name: "CollectionSlot",
  setup(o, { slots: t }) {
    const e = Bo(), { primitiveElement: n, currentElement: s } = R();
    return X(s, () => {
      e.collectionRef.value = s.value;
    }), () => ke(So, { ref: n }, t);
  }
}), jn = g({
  name: "CollectionItem",
  setup(o, { slots: t, attrs: e }) {
    const n = Bo(), { primitiveElement: s, currentElement: i } = R(), r = Ve();
    return ee((l) => {
      var u;
      if (i.value) {
        const d = en(i.value);
        n.itemMap.value.set(d, { ref: i.value, ...en(((u = r == null ? void 0 : r.parent) == null ? void 0 : u.props) ?? {}) }), l(() => n.itemMap.value.delete(d));
      }
    }), () => ke(So, { ...e, [n.attrName]: "", ref: s }, t);
  }
});
function wi(o) {
  const t = o ?? Bo();
  return { getItems: () => {
    const n = t.collectionRef.value;
    if (!n)
      return [];
    const s = Array.from(n.querySelectorAll(`[${t.attrName}]`));
    return Array.from(t.itemMap.value.values()).sort(
      (l, u) => s.indexOf(l.ref) - s.indexOf(u.ref)
    );
  } };
}
const [we, Si] = H("ComboboxRoot"), hu = /* @__PURE__ */ g({
  __name: "ComboboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm"],
  setup(o, { emit: t }) {
    const e = o, n = t, { multiple: s, disabled: i, name: r, dir: l } = z(e), u = de(l), d = J(e, "searchTerm", n, {
      // @ts-expect-error ignore the type error here
      defaultValue: "",
      passive: e.searchTerm === void 0
    }), c = J(e, "modelValue", n, {
      // @ts-expect-error ignore the type error here
      defaultValue: e.defaultValue ?? s.value ? [] : void 0,
      passive: e.modelValue === void 0,
      deep: !0
    }), p = J(e, "open", n, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    }), f = x();
    async function m(j) {
      var G, ne;
      p.value = j, await Y(), j ? (c.value && (Array.isArray(c.value) && s.value ? f.value = (G = $().find((tt) => {
        var ot, ht;
        return ((ht = (ot = tt.ref) == null ? void 0 : ot.dataset) == null ? void 0 : ht.state) === "checked";
      })) == null ? void 0 : G.value : f.value = c.value), (ne = O.value) == null || ne.focus(), Z()) : (w.value = !1, N());
    }
    function C(j) {
      if (Array.isArray(c.value) && s.value) {
        const G = c.value.findIndex((ne) => nt(ne, j));
        G === -1 ? c.value.push(j) : c.value.splice(G, 1);
      } else
        c.value = j, m(!1);
    }
    const w = x(!1), O = x(), _ = x(), { primitiveElement: S, currentElement: E } = R(), { getItems: $, reactiveItems: I, itemMapSize: A } = Rn("data-radix-vue-combobox-item"), V = mo(() => A.value, () => $().map((j) => j.value)), M = P(() => {
      if (w.value) {
        if (e.filterFunction)
          return e.filterFunction(V.value, d.value);
        if (typeof V.value[0] == "string")
          return V.value.filter((j) => {
            var G;
            return j.toLowerCase().includes((G = d.value) == null ? void 0 : G.toLowerCase());
          });
      }
      return V.value;
    });
    function N() {
      !s.value && c.value ? e.displayValue ? d.value = e.displayValue(c.value) : typeof c.value != "object" ? d.value = c.value.toString() : d.value = "" : d.value = "";
    }
    const D = P(() => M.value.findIndex((j) => nt(j, f.value))), L = P(() => {
      var j;
      return (j = I.value.find((G) => G.value === f.value)) == null ? void 0 : j.ref;
    });
    X(c, async () => {
      await Y(), N();
    }, { immediate: !0 }), X(() => M.value.length, async (j) => {
      await Y(), await Y(), j && D.value === -1 && (f.value = M.value[0]);
    });
    const W = Le(E);
    function Z() {
      L.value instanceof Element && L.value.scrollIntoView({ block: "nearest" });
    }
    return Si({
      searchTerm: d,
      modelValue: c,
      // @ts-expect-error igoring
      onValueChange: C,
      isUserInputted: w,
      multiple: s,
      disabled: i,
      open: p,
      onOpenChange: m,
      filteredOptions: M,
      contentId: oe(),
      inputElement: O,
      onInputElementChange: (j) => O.value = j,
      onInputNavigation: async (j) => {
        const G = D.value;
        G === 0 && j === "up" || G === M.value.length - 1 && j === "down" || (G === -1 && M.value.length || j === "home" ? f.value = M.value[0] : j === "end" ? f.value = M.value[M.value.length - 1] : f.value = M.value[j === "up" ? G - 1 : G + 1], Z());
      },
      onInputEnter: async () => {
        var j;
        M.value.length && f.value && L.value instanceof Element && ((j = L.value) == null || j.click());
      },
      selectedValue: f,
      onSelectedValueChange: (j) => f.value = j,
      parentElement: E,
      contentElement: _,
      onContentElementChange: (j) => _.value = j
    }), (j, G) => (h(), b(a(Ke), null, {
      default: v(() => [
        F(a(T), B({
          ref_key: "primitiveElement",
          ref: S,
          style: {
            pointerEvents: a(p) ? "auto" : void 0
          },
          as: j.as,
          "as-child": j.asChild,
          dir: a(u)
        }, j.$attrs), {
          default: v(() => [
            y(j.$slots, "default", {
              activeIndex: D.value,
              open: a(p),
              value: a(c)
            }),
            a(W) && a(r) ? (h(), b(a(kn), {
              key: 0,
              name: a(r),
              value: a(c)
            }, null, 8, ["name", "value"])) : q("", !0)
          ]),
          _: 3
        }, 16, ["style", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), yu = /* @__PURE__ */ g({
  __name: "ComboboxInput",
  props: {
    type: { default: "text" },
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "input" }
  },
  setup(o) {
    const t = o, e = we(), { primitiveElement: n, currentElement: s } = R();
    U(() => {
      const d = s.value.nodeName === "INPUT" ? s.value : s.value.querySelector("input");
      d && (e.onInputElementChange(d), setTimeout(() => {
        t.autoFocus && (d == null || d.focus());
      }, 1));
    });
    const i = P(() => t.disabled || e.disabled.value || !1);
    function r(d) {
      e.open.value ? e.onInputNavigation(d.key === "ArrowUp" ? "up" : "down") : e.onOpenChange(!0);
    }
    function l(d) {
      e.open.value && e.onInputNavigation(d.key === "Home" ? "home" : "end");
    }
    function u(d) {
      var c;
      e.searchTerm.value = (c = d.target) == null ? void 0 : c.value, e.open.value || e.onOpenChange(!0), e.isUserInputted.value = !0;
    }
    return (d, c) => (h(), b(a(T), B({
      ref_key: "primitiveElement",
      ref: n
    }, t, {
      value: a(e).searchTerm.value,
      "aria-expanded": a(e).open.value,
      "aria-controls": a(e).contentId,
      disabled: i.value,
      "aria-disabled": i.value ?? void 0,
      "aria-autocomplete": "list",
      role: "combobox",
      autocomplete: "false",
      onInput: u,
      onKeydown: [
        ie(te(r, ["prevent"]), ["down", "up"]),
        ie(a(e).onInputEnter, ["enter"]),
        ie(te(l, ["prevent"]), ["home", "end"])
      ]
    }), {
      default: v(() => [
        y(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["value", "aria-expanded", "aria-controls", "disabled", "aria-disabled", "onKeydown"]));
  }
}), gu = /* @__PURE__ */ g({
  __name: "ComboboxAnchor",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    return (t, e) => (h(), b(a(Ne), { "as-child": "" }, {
      default: v(() => [
        F(a(T), B({
          "as-child": t.asChild,
          as: t.as
        }, t.$attrs), {
          default: v(() => [
            y(t.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as"])
      ]),
      _: 3
    }));
  }
}), bu = /* @__PURE__ */ g({
  __name: "ComboboxTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = we(), n = P(() => t.disabled || e.disabled.value || !1);
    return (s, i) => (h(), b(a(T), B({
      type: s.as === "button" ? "button" : void 0
    }, t, {
      tabindex: "-1",
      "aria-label": "Show popup",
      "aria-haspopup": "listbox",
      "aria-expanded": a(e).open.value,
      "aria-controls": a(e).contentId,
      "data-state": a(e).open.value ? "open" : "closed",
      disabled: n.value,
      "data-disabled": n.value,
      "aria-disabled": n.value ?? void 0,
      onClick: i[0] || (i[0] = (r) => a(e).onOpenChange(!a(e).open.value))
    }), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "disabled", "data-disabled", "aria-disabled"]));
  }
}), Cu = /* @__PURE__ */ g({
  __name: "ComboboxCancel",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = we();
    function n() {
      var s;
      e.searchTerm.value = "", (s = e.inputElement.value) == null || s.focus();
    }
    return (s, i) => (h(), b(a(T), B({
      type: s.as === "button" ? "button" : void 0
    }, t, {
      tabindex: "-1",
      onClick: n
    }), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), [Ln, Ei] = H("ComboboxGroup"), _u = /* @__PURE__ */ g({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = oe(), n = x([]), s = we(), i = P(() => !s.isUserInputted.value || n.value.length === 0 || s.filteredOptions.value.map((r) => JSON.stringify(r)).some((r) => n.value.map((l) => JSON.stringify(l)).includes(r)));
    return Ei({
      id: e,
      options: n
    }), (r, l) => fo((h(), b(a(T), B({ role: "group" }, t, { "aria-labelledby": a(e) }), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"])), [
      [gn, i.value]
    ]);
  }
}), wu = /* @__PURE__ */ g({
  __name: "ComboboxLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "div" }
  },
  setup(o) {
    const t = o, e = Ln({ id: "" });
    return (n, s) => (h(), b(a(T), B(t, {
      id: a(e).id
    }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [xi, Oi] = H("ComboboxContent"), $i = /* @__PURE__ */ g({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const e = o, n = t, { position: s } = z(e), i = we();
    pt(e.bodyLock);
    const { primitiveElement: r, currentElement: l } = R();
    ft(l);
    const u = P(() => e.position === "popper" ? e : {});
    function d(p) {
      i.onSelectedValueChange("");
    }
    U(() => {
      i.onContentElementChange(l.value);
    });
    const c = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-combobox-content-available-width": "var(--radix-popper-available-width)",
      "--radix-combobox-content-available-height": "var(--radix-popper-available-height)",
      "--radix-combobox-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-combobox-trigger-height": "var(--radix-popper-anchor-height)"
    };
    return Oi({ position: s }), (p, f) => (h(), b(a(Vn), null, {
      default: v(() => [
        F(a(Pe), {
          "as-child": "",
          "disable-outside-pointer-events": p.disableOutsidePointerEvents,
          onDismiss: f[0] || (f[0] = (m) => a(i).onOpenChange(!1)),
          onFocusOutside: f[1] || (f[1] = (m) => {
            var C;
            (C = a(i).parentElement.value) != null && C.contains(m.target) && m.preventDefault(), n("focusOutside", m);
          }),
          onInteractOutside: f[2] || (f[2] = (m) => n("interactOutside", m)),
          onEscapeKeyDown: f[3] || (f[3] = (m) => n("escapeKeyDown", m)),
          onPointerDownOutside: f[4] || (f[4] = (m) => {
            var C;
            (C = a(i).parentElement.value) != null && C.contains(m.target) && m.preventDefault(), n("pointerDownOutside", m);
          })
        }, {
          default: v(() => [
            (h(), b(xe(a(s) === "popper" ? a(Ge) : a(T)), B({ ...p.$attrs, ...u.value }, {
              id: a(i).contentId,
              ref_key: "primitiveElement",
              ref: r,
              role: "listbox",
              "data-state": a(i).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...a(s) === "popper" ? c : {}
              },
              onPointerleave: d
            }), {
              default: v(() => [
                y(p.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }));
  }
}), Su = /* @__PURE__ */ g({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = we();
    return (r, l) => (h(), b(a(se), {
      present: r.forceMount || a(i).open.value
    }, {
      default: v(() => [
        F($i, k(K({ ...a(s), ...r.$attrs })), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Eu = /* @__PURE__ */ g({
  __name: "ComboboxEmpty",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = we(), n = P(() => e.searchTerm.value && e.filteredOptions.value.length === 0);
    return (s, i) => n.value ? (h(), b(a(T), k(B({ key: 0 }, t)), {
      default: v(() => [
        y(s.$slots, "default", {}, () => [
          ue("No options")
        ])
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), xu = /* @__PURE__ */ g({
  __name: "ComboboxViewport",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), Q(re, null, [
      F(a(T), { as: "style" }, {
        default: v(() => [
          ue(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-radix-combobox-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-radix-combobox-viewport]::-webkit-scrollbar { display: none; } ")
        ]),
        _: 1
      }),
      F(a(T), B({
        "data-radix-combobox-viewport": "",
        role: "presentation"
      }, { ...e.$attrs, ...t }, { style: {
        // we use position: 'relative' here on the `viewport` so that when we call
        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
        // (independent of the scrollUpButton).
        position: "relative",
        flex: 1,
        overflow: "auto"
      } }), {
        default: v(() => [
          y(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["style"])
    ], 64));
  }
}), [Pi, Bi] = H("ComboboxItem"), Ti = "combobox.select", Ou = /* @__PURE__ */ g({
  __name: "ComboboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, n = t, { disabled: s } = z(e), i = we(), r = Ln({ id: "", options: x([]) }), { primitiveElement: l, currentElement: u } = R(), d = P(
      () => {
        var _, S;
        return i.multiple.value && Array.isArray(i.modelValue.value) ? (_ = i.modelValue.value) == null ? void 0 : _.includes(e.value) : nt((S = i.modelValue) == null ? void 0 : S.value, e.value);
      }
    ), c = P(() => nt(i.selectedValue.value, e.value)), p = x(e.textValue ?? ""), f = oe(), m = P(() => i.isUserInputted.value ? i.searchTerm.value === "" || !!i.filteredOptions.value.find((_) => nt(_, e.value)) : !0);
    async function C(_) {
      n("select", _), !(_ != null && _.defaultPrevented) && !s.value && _ && i.onValueChange(e.value);
    }
    function w(_) {
      if (!_)
        return;
      const S = { originalEvent: _, value: e.value };
      vo(Ti, C, S);
    }
    async function O(_) {
      await Y(), !_.defaultPrevented && i.onSelectedValueChange(e.value);
    }
    if (e.value === "")
      throw new Error(
        "A <SelectItem /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return U(() => {
      var _, S, E, $;
      (S = (_ = r.options) == null ? void 0 : _.value) != null && S.includes(e.value) || (E = r.options) == null || E.value.push(e.value), !p.value && (($ = u.value) != null && $.textContent) && (p.value = u.value.textContent);
    }), Bi({
      isSelected: d
    }), (_, S) => (h(), b(a(jn), null, {
      default: v(() => [
        fo(F(a(T), {
          ref_key: "primitiveElement",
          ref: l,
          role: "option",
          tabindex: "-1",
          "aria-labelledby": a(f),
          "data-highlighted": c.value ? "" : void 0,
          "aria-selected": d.value,
          "data-state": d.value ? "checked" : "unchecked",
          "aria-disabled": a(s) || void 0,
          "data-disabled": a(s) ? "" : void 0,
          as: _.as,
          "as-child": _.asChild,
          onClick: w,
          onPointermove: O
        }, {
          default: v(() => [
            y(_.$slots, "default", {}, () => [
              ue(je(_.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "as", "as-child"]), [
          [gn, m.value]
        ])
      ]),
      _: 3
    }));
  }
}), $u = /* @__PURE__ */ g({
  __name: "ComboboxItemIndicator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = Pi();
    return (n, s) => a(e).isSelected.value ? (h(), b(a(T), B({
      key: 0,
      "aria-hidden": ""
    }, t), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), Pu = /* @__PURE__ */ g({
  __name: "ComboboxSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), B({ "aria-hidden": "" }, t), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Bu = /* @__PURE__ */ g({
  __name: "ComboboxArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = we(), n = xi();
    return (s, i) => a(e).open.value && a(n).position.value === "popper" ? (h(), b(a(Ye), k(B({ key: 0 }, t)), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), Tu = /* @__PURE__ */ g({
  __name: "ComboboxPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Mt = /* @__PURE__ */ g({
  __name: "MenuAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ne), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), To = /* @__PURE__ */ g({
  __name: "MenuArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ye), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [He, Kn] = H(["MenuRoot", "MenuSub"], "MenuContext"), [vt, Di] = H("MenuRoot"), Do = /* @__PURE__ */ g({
  __name: "MenuRoot",
  props: {
    open: { type: Boolean, default: !1 },
    onOpenChange: {},
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, { modal: s, dir: i } = z(e), r = de(i), l = J(e, "open", n), u = x(), d = x(!1);
    return ee((c) => {
      if (!Oe)
        return;
      const p = () => {
        d.value = !0, document.addEventListener("pointerdown", f, {
          capture: !0,
          once: !0
        }), document.addEventListener("pointermove", f, {
          capture: !0,
          once: !0
        });
      }, f = () => d.value = !1;
      document.addEventListener("keydown", p, { capture: !0 }), c(() => {
        document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", f, {
          capture: !0
        }), document.removeEventListener("pointermove", f, {
          capture: !0
        });
      });
    }), Kn({
      open: l,
      onOpenChange: (c) => {
        l.value = c;
      },
      content: u,
      onContentChange: (c) => {
        u.value = c;
      }
    }), Di({
      onClose: () => {
        l.value = !1;
      },
      isUsingKeyboardRef: d,
      dir: r,
      modal: s
    }), (c, p) => (h(), b(a(Ke), null, {
      default: v(() => [
        y(c.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Ii = "rovingFocusGroup.onEntryFocus", Ai = { bubbles: !1, cancelable: !0 }, Fi = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Mi(o, t) {
  return t !== "rtl" ? o : o === "ArrowLeft" ? "ArrowRight" : o === "ArrowRight" ? "ArrowLeft" : o;
}
function ki(o, t, e) {
  const n = Mi(o.key, e);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return Fi[n];
}
function Nn(o) {
  const t = document.activeElement;
  for (const e of o)
    if (e === t || (e.focus(), document.activeElement !== t))
      return;
}
function Ri(o, t) {
  return o.map((e, n) => o[(t + n) % o.length]);
}
const [Vi, ji] = H("RovingFocusGroup"), Je = /* @__PURE__ */ g({
  __name: "RovingFocusGroup",
  props: {
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !1 },
    currentTabStopId: {},
    defaultCurrentTabStopId: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["entryFocus", "update:currentTabStopId"],
  setup(o, { emit: t }) {
    const e = o, n = t, { loop: s, orientation: i, dir: r } = z(e), l = de(r), u = J(e, "currentTabStopId", n, {
      defaultValue: e.defaultCurrentTabStopId,
      passive: e.currentTabStopId === void 0
    }), d = x(!1), c = x(!1), p = x(0), { primitiveElement: f, currentElement: m } = R(), { createCollection: C } = le("rovingFocus"), w = C(m);
    function O(_) {
      const S = !c.value;
      if (_.currentTarget && _.target === _.currentTarget && S && !d.value) {
        const E = new CustomEvent(Ii, Ai);
        if (_.currentTarget.dispatchEvent(E), n("entryFocus", E), !E.defaultPrevented) {
          const $ = w.value, I = $.find((M) => M.getAttribute("data-active") === "true"), A = $.find(
            (M) => M.id === u.value
          ), V = [I, A, ...$].filter(
            Boolean
          );
          Nn(V);
        }
      }
      c.value = !1;
    }
    return ji({
      loop: s,
      dir: l,
      orientation: i,
      currentTabStopId: u,
      onItemFocus: (_) => {
        u.value = _;
      },
      onItemShiftTab: () => {
        d.value = !0;
      },
      onFocusableItemAdd: () => {
        p.value++;
      },
      onFocusableItemRemove: () => {
        p.value--;
      }
    }), (_, S) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: f,
      tabindex: d.value || p.value === 0 ? -1 : 0,
      "data-orientation": a(i),
      as: _.as,
      "as-child": _.asChild,
      dir: a(l),
      style: { outline: "none" },
      onMousedown: S[0] || (S[0] = (E) => c.value = !0),
      onFocus: O,
      onBlur: S[1] || (S[1] = (E) => d.value = !1)
    }, {
      default: v(() => [
        y(_.$slots, "default")
      ]),
      _: 3
    }, 8, ["tabindex", "data-orientation", "as", "as-child", "dir"]));
  }
}), Ze = /* @__PURE__ */ g({
  __name: "RovingFocusItem",
  props: {
    tabStopId: {},
    focusable: { type: Boolean, default: !0 },
    active: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = Vi(), n = oe(), s = P(() => t.tabStopId || n), i = P(
      () => e.currentTabStopId.value === s.value
    ), { injectCollection: r } = le("rovingFocus"), l = r();
    U(() => {
      t.focusable && e.onFocusableItemAdd();
    }), fe(() => {
      t.focusable && e.onFocusableItemRemove();
    });
    function u(d) {
      if (d.key === "Tab" && d.shiftKey) {
        e.onItemShiftTab();
        return;
      }
      if (d.target !== d.currentTarget)
        return;
      const c = ki(
        d,
        e.orientation.value,
        e.dir.value
      );
      if (c !== void 0) {
        d.preventDefault();
        let p = [...l.value];
        if (c === "last")
          p.reverse();
        else if (c === "prev" || c === "next") {
          c === "prev" && p.reverse();
          const f = p.indexOf(
            d.currentTarget
          );
          p = e.loop.value ? Ri(p, f + 1) : p.slice(f + 1);
        }
        Y(() => Nn(p));
      }
    }
    return (d, c) => (h(), b(a(T), {
      "data-radix-vue-collection-item": "",
      tabindex: i.value ? 0 : -1,
      "data-orientation": a(e).orientation.value,
      "data-active": d.active,
      "data-disabled": !d.focusable || void 0,
      as: d.as,
      "as-child": d.asChild,
      onMousedown: c[0] || (c[0] = (p) => {
        d.focusable ? a(e).onItemFocus(s.value) : p.preventDefault();
      }),
      onFocus: c[1] || (c[1] = (p) => a(e).onItemFocus(s.value)),
      onKeydown: u
    }, {
      default: v(() => [
        y(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["tabindex", "data-orientation", "data-active", "data-disabled", "as", "as-child"]));
  }
}), [Io, Li] = H("MenuContent"), Ao = /* @__PURE__ */ g({
  __name: "MenuContentImpl",
  props: yn({
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  }, {
    ...Mn
  }),
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = He(), i = vt(), { trapFocus: r, disableOutsidePointerEvents: l, loop: u } = z(e);
    Co(), pt(l.value);
    const d = x(""), c = x(0), p = x(0), f = x(null), m = x("right"), C = x(0), w = x(null), { createCollection: O } = le(), { primitiveElement: _, currentElement: S } = R(), E = O(S);
    X(S, (D) => {
      s.onContentChange(D);
    });
    const { handleTypeaheadSearch: $ } = _o(E);
    fe(() => {
      window.clearTimeout(c.value);
    });
    function I(D) {
      var W, Z;
      return m.value === ((W = f.value) == null ? void 0 : W.side) && Gs(D, (Z = f.value) == null ? void 0 : Z.area);
    }
    async function A(D) {
      var L;
      n("openAutoFocus", D), !D.defaultPrevented && (D.preventDefault(), (L = S.value) == null || L.focus());
    }
    function V(D) {
      if (D.defaultPrevented)
        return;
      const W = D.target.closest("[data-radix-menu-content]") === D.currentTarget, Z = D.ctrlKey || D.altKey || D.metaKey, j = D.key.length === 1, G = qe(
        D,
        document.activeElement,
        S.value,
        {
          loop: u.value,
          arrowKeyOptions: "vertical",
          dir: i == null ? void 0 : i.dir.value,
          focus: !0
        }
      );
      if (G)
        return G == null ? void 0 : G.focus();
      if (D.code === "Space" || (W && (D.key === "Tab" && D.preventDefault(), !Z && j && $(D.key)), D.target !== S.value) || !Ws.includes(D.key))
        return;
      D.preventDefault();
      const ne = E.value;
      Bn.includes(D.key) && ne.reverse(), ao(ne);
    }
    function M(D) {
      var L, W;
      (W = (L = D == null ? void 0 : D.currentTarget) == null ? void 0 : L.contains) != null && W.call(L, D.target) || (window.clearTimeout(c.value), d.value = "");
    }
    function N(D) {
      var Z;
      if (!st(D))
        return;
      const L = D.target, W = C.value !== D.clientX;
      if ((Z = D == null ? void 0 : D.currentTarget) != null && Z.contains(L) && W) {
        const j = D.clientX > C.value ? "right" : "left";
        m.value = j, C.value = D.clientX;
      }
    }
    return Li({
      onItemEnter: (D) => !!I(D),
      onItemLeave: (D) => {
        var L;
        I(D) || ((L = S.value) == null || L.focus(), w.value = null);
      },
      onTriggerLeave: (D) => !!I(D),
      searchRef: d,
      pointerGraceTimerRef: p,
      onPointerGraceIntentChange: (D) => {
        f.value = D;
      }
    }), (D, L) => (h(), b(a(Ft), {
      "as-child": "",
      trapped: a(r),
      onMountAutoFocus: A,
      onUnmountAutoFocus: L[7] || (L[7] = (W) => n("closeAutoFocus", W))
    }, {
      default: v(() => [
        F(a(Pe), {
          "as-child": "",
          "disable-outside-pointer-events": a(l),
          onEscapeKeyDown: L[2] || (L[2] = (W) => n("escapeKeyDown", W)),
          onPointerDownOutside: L[3] || (L[3] = (W) => n("pointerDownOutside", W)),
          onFocusOutside: L[4] || (L[4] = (W) => n("focusOutside", W)),
          onInteractOutside: L[5] || (L[5] = (W) => n("interactOutside", W)),
          onDismiss: L[6] || (L[6] = (W) => n("dismiss"))
        }, {
          default: v(() => [
            F(a(Je), {
              "current-tab-stop-id": w.value,
              "onUpdate:currentTabStopId": L[0] || (L[0] = (W) => w.value = W),
              "as-child": "",
              orientation: "vertical",
              dir: a(i).dir.value,
              loop: a(u),
              onEntryFocus: L[1] || (L[1] = (W) => {
                n("entryFocus", W), a(i).isUsingKeyboardRef.value || W.preventDefault();
              })
            }, {
              default: v(() => [
                F(a(Ge), {
                  ref_key: "primitiveElement",
                  ref: _,
                  role: "menu",
                  as: D.as,
                  "as-child": D.asChild,
                  "aria-orientation": "vertical",
                  "data-radix-menu-content": "",
                  "data-state": a(Oo)(a(s).open.value),
                  dir: a(i).dir.value,
                  side: D.side,
                  "side-offset": D.sideOffset,
                  align: D.align,
                  "align-offset": D.alignOffset,
                  "avoid-collisions": D.avoidCollisions,
                  "collision-boundary": D.collisionBoundary,
                  "collision-padding": D.collisionPadding,
                  "arrow-padding": D.arrowPadding,
                  sticky: D.sticky,
                  "hide-when-detached": D.hideWhenDetached,
                  onKeydown: V,
                  onBlur: M,
                  onPointermove: N
                }, {
                  default: v(() => [
                    y(D.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["as", "as-child", "data-state", "dir", "side", "side-offset", "align", "align-offset", "avoid-collisions", "collision-boundary", "collision-padding", "arrow-padding", "sticky", "hide-when-detached"])
              ]),
              _: 3
            }, 8, ["current-tab-stop-id", "dir", "loop"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), Hn = /* @__PURE__ */ g({
  __name: "MenuItemImpl",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o, { expose: t }) {
    const e = o, { primitiveElement: n, currentElement: s } = R(), i = Io(), r = x(!1);
    async function l(d) {
      if (!d.defaultPrevented && st(d)) {
        if (e.disabled)
          i.onItemLeave(d);
        else if (!i.onItemEnter(d)) {
          const p = d.currentTarget;
          p == null || p.focus();
        }
      }
    }
    async function u(d) {
      await Y(), !d.defaultPrevented && st(d) && i.onItemLeave(d);
    }
    return t({
      el: s
    }), (d, c) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: n,
      role: "menuitem",
      tabindex: "-1",
      as: d.as,
      "as-child": d.asChild,
      "data-radix-vue-collection-item": "",
      "aria-disabled": d.disabled || void 0,
      "data-disabled": d.disabled ? "" : void 0,
      disabled: d.disabled,
      "data-highlighted": r.value ? "" : void 0,
      onPointermove: l,
      onPointerleave: u,
      onFocus: c[0] || (c[0] = async (p) => {
        await Y(), !(p.defaultPrevented || d.disabled) && (r.value = !0);
      }),
      onBlur: c[1] || (c[1] = async (p) => {
        await Y(), !p.defaultPrevented && (r.value = !1);
      })
    }, {
      default: v(() => [
        y(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "aria-disabled", "data-disabled", "disabled", "data-highlighted"]));
  }
}), mt = /* @__PURE__ */ g({
  __name: "MenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, n = t, { primitiveElement: s, currentElement: i } = R(), r = vt(), l = Io(), u = x(!1);
    async function d() {
      const c = i.value;
      if (!e.disabled && c) {
        const p = new CustomEvent(Ns, {
          bubbles: !0,
          cancelable: !0
        });
        n("select", p), await Y(), p.defaultPrevented ? u.value = !1 : r.onClose();
      }
    }
    return (c, p) => (h(), b(Hn, B(e, {
      ref_key: "primitiveElement",
      ref: s,
      onClick: d,
      onPointerdown: p[0] || (p[0] = () => {
        u.value = !0;
      }),
      onPointerup: p[1] || (p[1] = async (f) => {
        var m;
        await Y(), !f.defaultPrevented && (u.value || (m = f.currentTarget) == null || m.click());
      }),
      onKeydown: p[2] || (p[2] = async (f) => {
        const m = a(l).searchRef.value !== "";
        c.disabled || m && f.key === " " || a(no).includes(f.key) && (f.currentTarget.click(), f.preventDefault());
      })
    }), {
      default: v(() => [
        y(c.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [Ki, Wn] = H(
  ["MenuCheckboxItem", "MenuRadioItem"],
  "MenuItemIndicatorContext"
), Fo = /* @__PURE__ */ g({
  __name: "MenuItemIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = Ki({
      checked: x(!1)
    });
    return (e, n) => (h(), b(a(se), {
      present: e.forceMount || a($t)(a(t).checked.value) || a(t).checked.value === !0
    }, {
      default: v(() => [
        F(a(T), {
          as: e.as,
          "as-child": e.asChild,
          "data-state": a($o)(a(t).checked.value)
        }, {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child", "data-state"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Mo = /* @__PURE__ */ g({
  __name: "MenuCheckboxItem",
  props: {
    checked: { type: [Boolean, String], default: !1 },
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select", "update:checked"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = J(e, "checked", n);
    return Wn({ checked: s }), (i, r) => (h(), b(mt, B({ role: "menuitemcheckbox" }, e, {
      "aria-checked": a($t)(a(s)) ? "mixed" : a(s),
      "data-state": a($o)(a(s)),
      onSelect: r[0] || (r[0] = async (l) => {
        n("select", l), a($t)(a(s)) ? s.value = !0 : s.value = !a(s);
      })
    }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-checked", "data-state"]));
  }
}), Ni = /* @__PURE__ */ g({
  __name: "MenuRootContentModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = pe(e, n), i = He(), { primitiveElement: r, currentElement: l } = R();
    return ft(l), (u, d) => (h(), b(Ao, B({
      ref_key: "primitiveElement",
      ref: r
    }, a(s), {
      "trap-focus": a(i).open.value,
      "disable-outside-pointer-events": a(i).open.value,
      "disable-outside-scroll": !0,
      onDismiss: d[0] || (d[0] = (c) => a(i).onOpenChange(!1)),
      onFocusOutside: d[1] || (d[1] = te((c) => n("focusOutside", c), ["prevent"]))
    }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus", "disable-outside-pointer-events"]));
  }
}), Hi = /* @__PURE__ */ g({
  __name: "MenuRootContentNonModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = He();
    return (r, l) => (h(), b(Ao, B(a(s), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      "disable-outside-scroll": !1,
      onDismiss: l[0] || (l[0] = (u) => a(i).onOpenChange(!1))
    }), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ko = /* @__PURE__ */ g({
  __name: "MenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = He(), r = vt();
    return (l, u) => (h(), b(a(se), {
      present: l.forceMount || a(i).open.value
    }, {
      default: v(() => [
        a(r).modal.value ? (h(), b(Ni, k(B({ key: 0 }, { ...l.$attrs, ...a(s) })), {
          default: v(() => [
            y(l.$slots, "default")
          ]),
          _: 3
        }, 16)) : (h(), b(Hi, k(B({ key: 1 }, { ...l.$attrs, ...a(s) })), {
          default: v(() => [
            y(l.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), kt = /* @__PURE__ */ g({
  __name: "MenuGroup",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), B({ role: "group" }, t), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ro = /* @__PURE__ */ g({
  __name: "MenuLabel",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "div" }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Vo = /* @__PURE__ */ g({
  __name: "MenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [Wi, zi] = H("MenuRadioGroup"), jo = /* @__PURE__ */ g({
  __name: "MenuRadioGroup",
  props: {
    modelValue: { default: "" },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "modelValue", t);
    return zi({
      modelValue: s,
      onValueChange: (i) => {
        s.value = i;
      }
    }), (i, r) => (h(), b(kt, k(K(e)), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Lo = /* @__PURE__ */ g({
  __name: "MenuRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, n = t, { value: s } = z(e), i = Wi(), r = P(
      () => i.modelValue.value === (s == null ? void 0 : s.value)
    );
    return Wn({ checked: r }), (l, u) => (h(), b(mt, B({ role: "menuitemradio" }, e, {
      "aria-checked": r.value,
      "data-state": a($o)(r.value),
      onSelect: u[0] || (u[0] = async (d) => {
        n("select", d), a(i).onValueChange(a(s));
      })
    }), {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-checked", "data-state"]));
  }
}), Ko = /* @__PURE__ */ g({
  __name: "MenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), B(t, {
      role: "separator",
      "aria-orientation": "horizontal"
    }), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [zn, Ui] = H("MenuSub"), No = /* @__PURE__ */ g({
  __name: "MenuSub",
  props: {
    open: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "open", t, {
      defaultValue: !1,
      passive: e.open === void 0
    }), i = He(), r = x(), l = x();
    return ee((u) => {
      (i == null ? void 0 : i.open.value) === !1 && (s.value = !1), u(() => s.value = !1);
    }), Kn({
      open: s,
      onOpenChange: (u) => {
        s.value = u;
      },
      content: l,
      onContentChange: (u) => {
        l.value = u;
      }
    }), Ui({
      triggerId: oe(),
      contentId: oe(),
      trigger: r,
      onTriggerChange: (u) => {
        r.value = u;
      }
    }), (u, d) => (h(), b(a(Ke), null, {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Ho = /* @__PURE__ */ g({
  __name: "MenuSubContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = He(), r = vt(), l = zn(), { primitiveElement: u, currentElement: d } = R();
    return (c, p) => (h(), b(a(se), {
      present: c.forceMount || a(i).open.value
    }, {
      default: v(() => [
        F(Ao, B(a(s), {
          id: a(l).contentId,
          ref_key: "primitiveElement",
          ref: u,
          "aria-labelledby": a(l).triggerId,
          align: "start",
          side: a(r).dir.value === "rtl" ? "left" : "right",
          "disable-outside-pointer-events": !1,
          "disable-outside-scroll": !1,
          "trap-focus": !1,
          onOpenAutoFocus: p[0] || (p[0] = te((f) => {
            var m;
            a(r).isUsingKeyboardRef.value && ((m = a(d)) == null || m.focus());
          }, ["prevent"])),
          onCloseAutoFocus: p[1] || (p[1] = te(() => {
          }, ["prevent"])),
          onFocusOutside: p[2] || (p[2] = (f) => {
            f.defaultPrevented || f.target !== a(l).trigger.value && a(i).onOpenChange(!1);
          }),
          onEscapeKeyDown: p[3] || (p[3] = (f) => {
            a(r).onClose(), f.preventDefault();
          }),
          onKeydown: p[4] || (p[4] = (f) => {
            var w, O;
            const m = (w = f.currentTarget) == null ? void 0 : w.contains(f.target), C = a(Us)[a(r).dir.value].includes(f.key);
            m && C && (a(i).onOpenChange(!1), (O = a(l).trigger.value) == null || O.focus(), f.preventDefault());
          })
        }), {
          default: v(() => [
            y(c.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "aria-labelledby", "side"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Wo = /* @__PURE__ */ g({
  __name: "MenuSubTrigger",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = He(), n = vt(), s = zn(), i = Io(), r = x(null);
    function l() {
      r.value && window.clearTimeout(r.value), r.value = null;
    }
    fe(() => {
      l();
    });
    function u(p) {
      !st(p) || i.onItemEnter(p) || !t.disabled && !e.open.value && !r.value && (i.onPointerGraceIntentChange(null), r.value = window.setTimeout(() => {
        e.onOpenChange(!0), l();
      }, 100));
    }
    async function d(p) {
      var m, C;
      if (!st(p))
        return;
      l();
      const f = (m = e.content.value) == null ? void 0 : m.getBoundingClientRect();
      if (f != null && f.width) {
        const w = (C = e.content.value) == null ? void 0 : C.dataset.side, O = w === "right", _ = O ? -5 : 5, S = f[O ? "left" : "right"], E = f[O ? "right" : "left"];
        i.onPointerGraceIntentChange({
          area: [
            // Apply a bleed on clientX to ensure that our exit point is
            // consistently within polygon bounds
            { x: p.clientX + _, y: p.clientY },
            { x: S, y: f.top },
            { x: E, y: f.top },
            { x: E, y: f.bottom },
            { x: S, y: f.bottom }
          ],
          side: w
        }), window.clearTimeout(i.pointerGraceTimerRef.value), i.pointerGraceTimerRef.value = window.setTimeout(
          () => i.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (i.onTriggerLeave(p))
          return;
        i.onPointerGraceIntentChange(null);
      }
    }
    async function c(p) {
      var m;
      const f = i.searchRef.value !== "";
      t.disabled || f && p.key === " " || zs[n.dir.value].includes(p.key) && (e.onOpenChange(!0), await Y(), (m = e.content.value) == null || m.focus(), p.preventDefault());
    }
    return (p, f) => (h(), b(Mt, { "as-child": "" }, {
      default: v(() => [
        F(Hn, B(t, {
          id: a(s).triggerId,
          ref: (m) => {
            var C;
            (C = a(s)) == null || C.onTriggerChange(m == null ? void 0 : m.el);
          },
          "aria-haspopup": "menu",
          "aria-expanded": a(e).open.value,
          "aria-controls": a(s).contentId,
          "data-state": a(Oo)(a(e).open.value),
          onClick: f[0] || (f[0] = async (m) => {
            t.disabled || m.defaultPrevented || (m.currentTarget.focus(), a(e).open.value || a(e).onOpenChange(!0));
          }),
          onPointermove: u,
          onPointerleave: d,
          onKeydown: c
        }), {
          default: v(() => [
            y(p.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "aria-expanded", "aria-controls", "data-state"])
      ]),
      _: 3
    }));
  }
}), [Un, qi] = H("ContextMenuRoot"), Du = /* @__PURE__ */ g({
  __name: "ContextMenuRoot",
  props: {
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, { dir: s, modal: i } = z(e), r = de(s), l = x(!1);
    return qi({
      open: l,
      onOpenChange: (u) => {
        l.value = u, n("update:open", u);
      },
      dir: r,
      modal: i
    }), (u, d) => (h(), b(a(Do), {
      open: l.value,
      "onUpdate:open": d[0] || (d[0] = (c) => l.value = c),
      dir: a(r),
      modal: a(i)
    }, {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["open", "dir", "modal"]));
  }
});
function rn(o) {
  return o.pointerType !== "mouse";
}
const Iu = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "ContextMenuTrigger",
  props: {
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, { disabled: e } = z(t), n = Un(), s = x({ x: 0, y: 0 }), i = P(() => ({
      getBoundingClientRect: () => ({
        width: 0,
        height: 0,
        left: s.value.x,
        right: s.value.x,
        top: s.value.y,
        bottom: s.value.y,
        ...s.value
      })
    })), r = x(0);
    function l() {
      window.clearTimeout(r.value);
    }
    function u(f) {
      s.value = { x: f.clientX, y: f.clientY }, n.onOpenChange(!0);
    }
    async function d(f) {
      e.value || (await Y(), f.defaultPrevented || (l(), u(f), f.preventDefault()));
    }
    async function c(f) {
      e.value || (await Y(), rn(f) && !f.defaultPrevented && (l(), r.value = window.setTimeout(() => u(f), 700)));
    }
    async function p(f) {
      e.value || (await Y(), rn(f) && !f.defaultPrevented && l());
    }
    return (f, m) => (h(), Q(re, null, [
      F(a(Mt), {
        as: "template",
        element: i.value
      }, null, 8, ["element"]),
      F(a(T), B({
        as: f.as,
        "as-child": f.asChild,
        "data-state": a(n).open.value ? "open" : "closed",
        "data-disabled": a(e) ? "" : void 0,
        style: {
          WebkitTouchCallout: "none"
        }
      }, f.$attrs, {
        onContextmenu: d,
        onPointerdown: c,
        onPointermove: p,
        onPointercancel: p,
        onPointerup: p
      }), {
        default: v(() => [
          y(f.$slots, "default")
        ]),
        _: 3
      }, 16, ["as", "as-child", "data-state", "data-disabled"])
    ], 64));
  }
}), Au = /* @__PURE__ */ g({
  __name: "ContextMenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Vo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Fu = /* @__PURE__ */ g({
  __name: "ContextMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    alignOffset: { default: 0 },
    avoidCollisions: { type: Boolean, default: !0 },
    collisionBoundary: { default: () => [] },
    collisionPadding: { default: 0 },
    sticky: { default: "partial" },
    hideWhenDetached: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = Un(), i = x(!1);
    return (r, l) => (h(), b(a(ko), B(e, {
      side: "right",
      "side-offset": 2,
      align: "start",
      style: {
        "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
      },
      onCloseAutoFocus: l[0] || (l[0] = (u) => {
        n("closeAutoFocus", u), !u.defaultPrevented && i.value && u.preventDefault(), i.value = !1;
      }),
      onInteractOutside: l[1] || (l[1] = (u) => {
        n("interactOutside", u), !u.defaultPrevented && !a(s).modal.value && (i.value = !0);
      })
    }), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["style"]));
  }
}), Mu = /* @__PURE__ */ g({
  __name: "ContextMenuArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(To), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ku = /* @__PURE__ */ g({
  __name: "ContextMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(mt), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ru = /* @__PURE__ */ g({
  __name: "ContextMenuGroup",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(kt), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Vu = /* @__PURE__ */ g({
  __name: "ContextMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ko), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ju = /* @__PURE__ */ g({
  __name: "ContextMenuCheckboxItem",
  props: {
    checked: { type: [Boolean, String] },
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select", "update:checked"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(Mo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Lu = /* @__PURE__ */ g({
  __name: "ContextMenuItemIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Fo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ku = /* @__PURE__ */ g({
  __name: "ContextMenuLabel",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ro), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Nu = /* @__PURE__ */ g({
  __name: "ContextMenuRadioGroup",
  props: {
    modelValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(jo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Hu = /* @__PURE__ */ g({
  __name: "ContextMenuRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(Lo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Wu = /* @__PURE__ */ g({
  __name: "ContextMenuSub",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "open", t, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    });
    return (i, r) => (h(), b(a(No), {
      open: a(s),
      "onUpdate:open": r[0] || (r[0] = (l) => ut(s) ? s.value = l : null)
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), zu = /* @__PURE__ */ g({
  __name: "ContextMenuSubContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t);
    return (i, r) => (h(), b(a(Ho), B(a(s), { style: {
      "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
    } }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["style"]));
  }
}), Uu = /* @__PURE__ */ g({
  __name: "ContextMenuSubTrigger",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Wo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [qn, Gi] = H("DropdownMenuRoot"), qu = /* @__PURE__ */ g({
  __name: "DropdownMenuRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "open", t, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    }), i = x(), { modal: r, dir: l } = z(e), u = de(l);
    return Gi({
      open: s,
      onOpenChange: (d) => {
        s.value = d;
      },
      onOpenToggle: () => {
        s.value = !s.value;
      },
      triggerId: oe(),
      triggerElement: i,
      contentId: oe(),
      modal: r,
      dir: u
    }), (d, c) => (h(), b(a(Do), {
      open: a(s),
      "onUpdate:open": c[0] || (c[0] = (p) => ut(s) ? s.value = p : null),
      dir: a(u),
      modal: a(r)
    }, {
      default: v(() => [
        y(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["open", "dir", "modal"]));
  }
}), Gu = /* @__PURE__ */ g({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = qn(), { primitiveElement: n, currentElement: s } = R();
    return U(() => {
      e.triggerElement = s;
    }), (i, r) => (h(), b(a(Mt), { "as-child": "" }, {
      default: v(() => [
        F(a(T), {
          id: a(e).triggerId,
          ref_key: "primitiveElement",
          ref: n,
          type: i.as === "button" ? "button" : void 0,
          "as-child": t.asChild,
          as: i.as,
          "aria-haspopup": "menu",
          "aria-expanded": a(e).open.value,
          "aria-controls": a(e).open.value ? a(e).contentId : void 0,
          "data-disabled": i.disabled ? "" : void 0,
          disabled: i.disabled,
          "data-state": a(e).open.value ? "open" : "closed",
          onPointerdown: r[0] || (r[0] = te(() => {
          }, ["prevent", "stop"])),
          onClick: r[1] || (r[1] = async (l) => {
            var u;
            !i.disabled && l.button === 0 && l.ctrlKey === !1 && ((u = a(e)) == null || u.onOpenToggle(), await Y(), a(e).open.value && l.preventDefault());
          }),
          onKeydown: r[2] || (r[2] = ie(
            (l) => {
              i.disabled || (["Enter", " "].includes(l.key) && a(e).onOpenToggle(), l.key === "ArrowDown" && a(e).onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(l.key) && l.preventDefault());
            },
            ["enter", "space", "arrow-down"]
          ))
        }, {
          default: v(() => [
            y(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as-child", "as", "aria-expanded", "aria-controls", "data-disabled", "disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), Yu = /* @__PURE__ */ g({
  __name: "DropdownMenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Vo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Xu = /* @__PURE__ */ g({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = pe(e, n), i = qn(), r = x(!1);
    function l(u) {
      n("closeAutoFocus", u), !u.defaultPrevented && (r.value || setTimeout(() => {
        var d;
        (d = i.triggerElement.value) == null || d.focus();
      }, 0), r.value = !1, u.preventDefault());
    }
    return (u, d) => {
      var c;
      return h(), b(a(ko), B(a(s), {
        id: a(i).contentId,
        "aria-labelledby": (c = a(i)) == null ? void 0 : c.triggerId,
        style: {
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        },
        onCloseAutoFocus: l,
        onInteractOutside: d[0] || (d[0] = (p) => {
          if (n("interactOutside", p), p.defaultPrevented)
            return;
          const f = p.detail.originalEvent, m = f.button === 0 && f.ctrlKey === !0, C = f.button === 2 || m;
          (!a(i).modal.value || C) && (r.value = !0);
        })
      }), {
        default: v(() => [
          y(u.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "aria-labelledby", "style"]);
    };
  }
}), Ju = /* @__PURE__ */ g({
  __name: "DropdownMenuArrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(To), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Zu = /* @__PURE__ */ g({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(mt), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Qu = /* @__PURE__ */ g({
  __name: "DropdownMenuGroup",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(kt), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ed = /* @__PURE__ */ g({
  __name: "DropdownMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ko), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), td = /* @__PURE__ */ g({
  __name: "DropdownMenuCheckboxItem",
  props: {
    checked: { type: [Boolean, String] },
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select", "update:checked"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(Mo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), od = /* @__PURE__ */ g({
  __name: "DropdownMenuItemIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Fo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), nd = /* @__PURE__ */ g({
  __name: "DropdownMenuLabel",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ro), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ad = /* @__PURE__ */ g({
  __name: "DropdownMenuRadioGroup",
  props: {
    modelValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(jo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), sd = /* @__PURE__ */ g({
  __name: "DropdownMenuRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, n = t;
    return (s, i) => (h(), b(a(Lo), k(K({ ...e, ...n })), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), id = /* @__PURE__ */ g({
  __name: "DropdownMenuSub",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "open", t, {
      passive: e.open === void 0,
      defaultValue: e.defaultOpen ?? !1
    });
    return (i, r) => (h(), b(a(No), {
      open: a(s),
      "onUpdate:open": r[0] || (r[0] = (l) => ut(s) ? s.value = l : null)
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), rd = /* @__PURE__ */ g({
  __name: "DropdownMenuSubContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t);
    return (i, r) => (h(), b(a(Ho), B(a(s), { style: {
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    } }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["style"]));
  }
}), ld = /* @__PURE__ */ g({
  __name: "DropdownMenuSubTrigger",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Wo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [zo, Yi] = H("HoverCardRoot"), ud = /* @__PURE__ */ g({
  __name: "HoverCardRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    openDelay: { default: 700 },
    closeDelay: { default: 300 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, { openDelay: s, closeDelay: i } = z(e), r = J(e, "open", n, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    }), l = x(0), u = x(0), d = x(!1), c = x(!1);
    function p() {
      clearTimeout(u.value), l.value = window.setTimeout(() => r.value = !0, s.value);
    }
    function f() {
      clearTimeout(l.value), !d.value && !c.value && (u.value = window.setTimeout(() => r.value = !1, i.value));
    }
    function m() {
      r.value = !1;
    }
    return Yi({
      open: r,
      onOpenChange(C) {
        r.value = C;
      },
      onOpen: p,
      onClose: f,
      onDismiss: m,
      hasSelectionRef: d,
      isPointerDownOnContentRef: c
    }), (C, w) => (h(), b(a(Ke), null, {
      default: v(() => [
        y(C.$slots, "default")
      ]),
      _: 3
    }));
  }
});
function Pt(o) {
  return (t) => t.pointerType === "touch" ? void 0 : o();
}
function Xi(o) {
  const t = [], e = document.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; e.nextNode(); )
    t.push(e.currentNode);
  return t;
}
const dd = /* @__PURE__ */ g({
  __name: "HoverCardTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "a" }
  },
  setup(o) {
    const t = zo();
    return (e, n) => (h(), b(a(Ne), { "as-child": "" }, {
      default: v(() => [
        F(a(T), {
          "as-child": e.asChild,
          as: e.as,
          "data-state": a(t).open.value ? "open" : "closed",
          onPointerenter: n[0] || (n[0] = (s) => a(Pt)(a(t).onOpen)(s)),
          onPointerleave: n[1] || (n[1] = (s) => a(Pt)(a(t).onClose)(s)),
          onFocus: n[2] || (n[2] = (s) => a(t).onOpen()),
          onBlur: a(t).onClose,
          onTouchstart: te(() => {
          }, ["prevent"])
        }, {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["as-child", "as", "data-state", "onBlur", "onTouchstart"])
      ]),
      _: 3
    }));
  }
}), cd = /* @__PURE__ */ g({
  __name: "HoverCardPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ji = /* @__PURE__ */ g({
  __name: "HoverCardContentImpl",
  props: {
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = It(e), { primitiveElement: i, currentElement: r } = R(), l = zo(), u = x(!1);
    let d;
    ee((p) => {
      if (u.value) {
        const f = document.body;
        d = f.style.userSelect || f.style.webkitUserSelect, f.style.userSelect = "none", f.style.webkitUserSelect = "none", p(() => {
          f.style.userSelect = d, f.style.webkitUserSelect = d;
        });
      }
    });
    function c() {
      u.value = !1, l.isPointerDownOnContentRef.value = !1, Y(() => {
        var f;
        ((f = document.getSelection()) == null ? void 0 : f.toString()) !== "" && (l.hasSelectionRef.value = !0);
      });
    }
    return U(() => {
      r.value && (document.addEventListener("pointerup", c), Xi(r.value).forEach((f) => f.setAttribute("tabindex", "-1")));
    }), fe(() => {
      document.removeEventListener("pointerup", c), l.hasSelectionRef.value = !1, l.isPointerDownOnContentRef.value = !1;
    }), (p, f) => (h(), b(a(Pe), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: f[1] || (f[1] = (m) => n("escapeKeyDown", m)),
      onPointerDownOutside: f[2] || (f[2] = (m) => n("pointerDownOutside", m)),
      onFocusOutside: f[3] || (f[3] = te((m) => n("focusOutside", m), ["prevent"])),
      onDismiss: a(l).onDismiss
    }, {
      default: v(() => [
        F(a(Ge), B({
          ref_key: "primitiveElement",
          ref: i
        }, { ...a(s), ...p.$attrs }, {
          "data-state": a(l).open.value ? "open" : "closed",
          style: {
            userSelect: u.value ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: u.value ? "text" : void 0,
            // re-namespace exposed content custom properties
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          },
          onPointerdown: f[0] || (f[0] = (m) => {
            m.currentTarget.contains(m.target) && (u.value = !0), a(l).hasSelectionRef.value = !1, a(l).isPointerDownOnContentRef.value = !0;
          })
        }), {
          default: v(() => [
            y(p.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "style"])
      ]),
      _: 3
    }, 8, ["onDismiss"]));
  }
}), pd = /* @__PURE__ */ g({
  __name: "HoverCardContent",
  props: {
    forceMount: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = zo();
    return (r, l) => (h(), b(a(se), {
      present: r.forceMount || a(i).open.value
    }, {
      default: v(() => [
        F(Ji, B(a(s), {
          onPointerenter: l[0] || (l[0] = (u) => a(Pt)(a(i).onOpen)(u)),
          onPointerleave: l[1] || (l[1] = (u) => a(Pt)(a(i).onClose)(u))
        }), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), fd = /* @__PURE__ */ g({
  __name: "HoverCardArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ye), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), vd = /* @__PURE__ */ g({
  __name: "Label",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "label" }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), B(t, {
      onMousedown: n[0] || (n[0] = (s) => {
        !s.defaultPrevented && s.detail > 1 && s.preventDefault();
      })
    }), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [Rt, Zi] = H("MenubarRoot"), md = /* @__PURE__ */ g({
  __name: "MenubarRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    dir: {},
    loop: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, n = t, { primitiveElement: s, currentElement: i } = R(), { createCollection: r } = le("menubar");
    r(i);
    const l = J(e, "modelValue", n, {
      defaultValue: e.defaultValue ?? "",
      passive: e.modelValue === void 0
    }), u = x(null), { dir: d, loop: c } = z(e), p = de(d);
    return Zi({
      modelValue: l,
      dir: p,
      loop: c,
      onMenuOpen: (f) => {
        l.value = f, u.value = f;
      },
      onMenuClose: () => {
        l.value = "";
      },
      onMenuToggle: (f) => {
        l.value = l.value ? "" : f, u.value = f;
      }
    }), (f, m) => (h(), b(a(Je), {
      "current-tab-stop-id": u.value,
      "onUpdate:currentTabStopId": m[0] || (m[0] = (C) => u.value = C),
      orientation: "horizontal",
      loop: a(c),
      dir: a(p),
      "as-child": ""
    }, {
      default: v(() => [
        F(a(T), {
          ref_key: "primitiveElement",
          ref: s,
          role: "menubar"
        }, {
          default: v(() => [
            y(f.$slots, "default")
          ]),
          _: 3
        }, 512)
      ]),
      _: 3
    }, 8, ["current-tab-stop-id", "loop", "dir"]));
  }
}), [Uo, Qi] = H("MenubarMenu"), hd = /* @__PURE__ */ g({
  __name: "MenubarMenu",
  props: {
    value: {}
  },
  setup(o) {
    const e = o.value ?? oe(), n = Rt(), s = x(), i = x(!1), r = P(() => n.modelValue.value === e);
    return X(r, () => {
      r.value || (i.value = !1);
    }), Qi({
      value: e,
      triggerElement: s,
      triggerId: e,
      contentId: oe(),
      wasKeyboardTriggerOpenRef: i
    }), (l, u) => (h(), b(a(Do), {
      open: r.value,
      modal: !1,
      dir: a(n).dir.value,
      "onUpdate:open": u[0] || (u[0] = (d) => {
        d || a(n).onMenuClose();
      })
    }, {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["open", "dir"]));
  }
}), yd = /* @__PURE__ */ g({
  __name: "MenubarTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = Rt(), e = Uo(), { primitiveElement: n, currentElement: s } = R(), i = x(!1), r = P(() => t.modelValue.value === e.value);
    return U(() => {
      e.triggerElement = s;
    }), (l, u) => (h(), b(a(Ze), {
      "as-child": "",
      focusable: !l.disabled,
      "tab-stop-id": a(e).value
    }, {
      default: v(() => [
        F(a(Mt), { "as-child": "" }, {
          default: v(() => [
            F(a(T), {
              id: a(e).triggerId,
              ref_key: "primitiveElement",
              ref: n,
              as: l.as,
              type: l.as === "button" ? "button" : void 0,
              role: "menuitem",
              "aria-haspopup": "menu",
              "aria-expanded": r.value,
              "aria-controls": r.value ? a(e).contentId : void 0,
              "data-highlighted": i.value ? "" : void 0,
              "data-state": r.value ? "open" : "closed",
              "data-disabled": l.disabled ? "" : void 0,
              disabled: l.disabled,
              "data-value": a(e).value,
              "data-radix-vue-collection-item": "",
              onPointerdown: u[0] || (u[0] = (d) => {
                !l.disabled && d.button === 0 && d.ctrlKey === !1 && (a(t).onMenuOpen(a(e).value), r.value || d.preventDefault());
              }),
              onPointerenter: u[1] || (u[1] = () => {
                var c;
                !!a(t).modelValue.value && !r.value && (a(t).onMenuOpen(a(e).value), (c = a(s)) == null || c.focus());
              }),
              onKeydown: u[2] || (u[2] = ie((d) => {
                l.disabled || (["Enter", " "].includes(d.key) && a(t).onMenuToggle(a(e).value), d.key === "ArrowDown" && a(t).onMenuOpen(a(e).value), ["Enter", " ", "ArrowDown"].includes(d.key) && (a(e).wasKeyboardTriggerOpenRef.value = !0, d.preventDefault()));
              }, ["enter", "space", "arrow-down"])),
              onFocus: u[3] || (u[3] = (d) => i.value = !0),
              onBlur: u[4] || (u[4] = (d) => i.value = !1)
            }, {
              default: v(() => [
                y(l.$slots, "default")
              ]),
              _: 3
            }, 8, ["id", "as", "type", "aria-expanded", "aria-controls", "data-highlighted", "data-state", "data-disabled", "disabled", "data-value"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["focusable", "tab-stop-id"]));
  }
}), gd = /* @__PURE__ */ g({
  __name: "MenubarPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Vo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), bd = /* @__PURE__ */ g({
  __name: "MenubarContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = Rt(), r = Uo(), { injectCollection: l } = le("menubar"), u = l(), d = x(!1);
    function c(p) {
      const m = p.target.hasAttribute(
        "data-radix-menubar-subtrigger"
      ), w = (i.dir.value === "rtl" ? "ArrowRight" : "ArrowLeft") === p.key;
      if (!w && m)
        return;
      let _ = u.value.map(($) => $.dataset.value);
      w && _.reverse();
      const S = _.indexOf(r.value);
      _ = i.loop.value ? wo(_, S + 1) : _.slice(S + 1);
      const [E] = _;
      E && i.onMenuOpen(E);
    }
    return (p, f) => (h(), b(a(ko), B({
      id: a(r).contentId,
      "aria-labelledby": a(r).triggerId,
      "data-radix-menubar-content": ""
    }, a(s), {
      style: {
        "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
        "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
        "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
      },
      onCloseAutoFocus: f[0] || (f[0] = (m) => {
        var w;
        !!!a(i).modelValue.value && !d.value && ((w = a(r).triggerElement.value) == null || w.focus()), d.value = !1, m.preventDefault();
      }),
      onFocusOutside: f[1] || (f[1] = (m) => {
        const C = m.target;
        a(u).some((O) => O.contains(C)) && m.preventDefault();
      }),
      onInteractOutside: f[2] || (f[2] = (m) => {
        d.value = !0;
      }),
      onEntryFocus: f[3] || (f[3] = (m) => {
        a(r).wasKeyboardTriggerOpenRef.value || m.preventDefault();
      }),
      onKeydown: ie(c, ["arrow-right", "arrow-left"])
    }), {
      default: v(() => [
        y(p.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "aria-labelledby", "style", "onKeydown"]));
  }
}), Cd = /* @__PURE__ */ g({
  __name: "MenubarArrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(To), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), _d = /* @__PURE__ */ g({
  __name: "MenubarItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(mt), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), wd = /* @__PURE__ */ g({
  __name: "MenubarGroup",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(kt), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Sd = /* @__PURE__ */ g({
  __name: "MenubarSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ko), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ed = /* @__PURE__ */ g({
  __name: "MenubarCheckboxItem",
  props: {
    checked: { type: [Boolean, String] },
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select", "update:checked"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(Mo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), xd = /* @__PURE__ */ g({
  __name: "MenubarItemIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Fo), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Od = /* @__PURE__ */ g({
  __name: "MenubarLabel",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ro), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), $d = /* @__PURE__ */ g({
  __name: "MenubarRadioGroup",
  props: {
    modelValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = ce(t);
    return (i, r) => (h(), b(a(jo), k(K({ ...e, ...a(s) })), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Pd = /* @__PURE__ */ g({
  __name: "MenubarRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, n = t;
    return (s, i) => (h(), b(a(Lo), k(K({ ...e, ...n })), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Bd = /* @__PURE__ */ g({
  __name: "MenubarSub",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "open", t, {
      defaultValue: e.defaultOpen ?? !1,
      passive: e.open === void 0
    });
    return (i, r) => (h(), b(a(No), {
      open: a(s),
      "onUpdate:open": r[0] || (r[0] = (l) => ut(s) ? s.value = l : null)
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), Td = /* @__PURE__ */ g({
  __name: "MenubarSubContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const s = pe(o, t), { injectCollection: i } = le("menubar"), r = Rt(), l = Uo(), u = i();
    function d(c) {
      if (c.target.hasAttribute(
        "data-radix-menubar-subtrigger"
      ))
        return;
      let m = u.value.map((O) => O.dataset.value);
      const C = m.indexOf(l.value);
      m = r.loop.value ? wo(m, C + 1) : m.slice(C + 1);
      const [w] = m;
      w && r.onMenuOpen(w);
    }
    return (c, p) => (h(), b(a(Ho), B(a(s), {
      "data-radix-menubar-content": "",
      style: {
        "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
        "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
        "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
      },
      onKeydown: ie(d, ["arrow-right"])
    }), {
      default: v(() => [
        y(c.$slots, "default")
      ]),
      _: 3
    }, 16, ["style", "onKeydown"]));
  }
}), Dd = /* @__PURE__ */ g({
  __name: "MenubarSubTrigger",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Wo), B({ "data-radix-menubar-subtrigger": "" }, t), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [Be, Gn] = H(["NavigationMenuRoot", "NavigationMenuSub"], "NavigationMenuContext"), Id = /* @__PURE__ */ g({
  __name: "NavigationMenuRoot",
  props: {
    modelValue: { default: void 0 },
    defaultValue: {},
    dir: {},
    orientation: { default: "horizontal" },
    delayDuration: { default: 200 },
    skipDelayDuration: { default: 300 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "nav" }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "modelValue", t, {
      defaultValue: e.defaultValue ?? "",
      passive: e.modelValue === void 0
    }), i = x(""), { primitiveElement: r, currentElement: l } = R(), u = x(), d = x(), { createCollection: c } = le("nav");
    c(u);
    const { delayDuration: p, skipDelayDuration: f, dir: m } = z(e), C = de(m), w = ho(!1, f), O = P(() => s.value !== "" || w.value ? 150 : p.value), _ = yo((S) => {
      i.value = s.value, s.value = S;
    }, O);
    return Gn({
      isRootMenu: !0,
      modelValue: s,
      previousValue: i,
      baseId: oe(),
      dir: C,
      orientation: e.orientation,
      rootNavigationMenu: l,
      indicatorTrack: u,
      onIndicatorTrackChange: (S) => {
        u.value = S;
      },
      viewport: d,
      onViewportChange: (S) => {
        d.value = S;
      },
      onTriggerEnter: (S) => {
        _(S);
      },
      onTriggerLeave: () => {
        w.value = !0, _("");
      },
      onContentEnter: (S) => {
        _(S);
      },
      onContentLeave: () => {
        _("");
      },
      onItemSelect: (S) => {
        i.value = s.value, s.value = S;
      },
      onItemDismiss: () => {
        i.value = s.value, s.value = "";
      }
    }), (S, E) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: r,
      "aria-label": "Main",
      as: S.as,
      "as-child": S.asChild,
      "data-orientation": S.orientation,
      dir: a(C)
    }, {
      default: v(() => [
        y(S.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "dir"]));
  }
});
function Vt(o) {
  return o ? "open" : "closed";
}
function Yn(o, t) {
  return `${o}-trigger-${t}`;
}
function qo(o, t) {
  return `${o}-content-${t}`;
}
const Ot = "navigationMenu.rootContentDismiss";
function io(o) {
  const t = [], e = document.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const s = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || s ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; e.nextNode(); )
    t.push(e.currentNode);
  return t;
}
function Xn(o) {
  const t = document.activeElement;
  return o.some((e) => e === t ? !0 : (e.focus(), document.activeElement !== t));
}
function er(o) {
  return o.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    o.forEach((t) => {
      const e = t.dataset.tabindex;
      t.setAttribute("tabindex", e);
    });
  };
}
const [Go, tr] = H("NavigationMenuItem"), Ad = /* @__PURE__ */ g({
  __name: "NavigationMenuItem",
  props: {
    value: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "li" }
  },
  setup(o) {
    const t = o, { injectCollection: e } = le("nav"), n = e(), s = Be(), i = t.value || oe(), r = x(), l = x(), u = qo(s.baseId, i);
    let d = () => ({});
    const c = x(!1);
    async function p(w = "start") {
      const O = document.getElementById(u);
      if (O) {
        d();
        const _ = io(O);
        _.length && Xn(w === "start" ? _ : _.reverse());
      }
    }
    function f() {
      const w = document.getElementById(u);
      if (w) {
        const O = io(w);
        O.length && (d = er(O));
      }
    }
    tr({
      value: i,
      contentId: u,
      triggerRef: r,
      focusProxyRef: l,
      wasEscapeCloseRef: c,
      onEntryKeyDown: p,
      onFocusProxyEnter: p,
      onContentFocusOutside: f,
      onRootContentClose: f
    });
    function m() {
      var w;
      s.onItemDismiss(), (w = r.value) == null || w.focus();
    }
    function C(w) {
      const O = document.activeElement;
      if (w.keyCode === 32 || w.key === "Enter")
        if (s.modelValue.value === i) {
          m(), w.preventDefault();
          return;
        } else {
          w.target.click(), w.preventDefault();
          return;
        }
      const _ = n.value.filter(
        (E) => {
          var $;
          return ($ = E.parentElement) == null ? void 0 : $.hasAttribute("data-menu-item");
        }
      ), S = qe(w, O, void 0, {
        itemsArray: _,
        loop: !1
      });
      S && (S == null || S.focus()), w.preventDefault(), w.stopPropagation();
    }
    return (w, O) => (h(), b(a(T), {
      "as-child": t.asChild,
      as: w.as,
      "data-menu-item": "",
      onKeydown: ie(C, ["up", "down", "left", "right", "home", "end", "space"])
    }, {
      default: v(() => [
        y(w.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "onKeydown"]));
  }
}), or = /* @__PURE__ */ g({
  __name: "NavigationMenuContentImpl",
  props: {
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const e = o, n = t, { injectCollection: s } = le("nav"), i = s(), { primitiveElement: r, currentElement: l } = R(), u = Be(), d = Go(), c = Yn(u.baseId, d.value), p = qo(u.baseId, d.value), f = x(null), m = P(() => {
      const $ = i.value.map((D) => D.id.split("trigger-")[1]);
      u.dir.value === "rtl" && $.reverse();
      const I = $.indexOf(u.modelValue.value), A = $.indexOf(u.previousValue.value), V = d.value === u.modelValue.value, M = A === $.indexOf(d.value);
      if (!V && !M)
        return f.value;
      const N = (() => {
        if (I !== A) {
          if (V && A !== -1)
            return I > A ? "from-end" : "from-start";
          if (M && I !== -1)
            return I > A ? "to-start" : "to-end";
        }
        return null;
      })();
      return f.value = N, N;
    });
    function C(E) {
      var $, I;
      if (n("focusOutside", E), n("interactOutside", E), !E.defaultPrevented) {
        d.onContentFocusOutside();
        const A = E.target;
        (I = ($ = u.rootNavigationMenu) == null ? void 0 : $.value) != null && I.contains(A) && E.preventDefault();
      }
    }
    function w(E) {
      var $;
      if (n("pointerDownOutside", E), !E.defaultPrevented) {
        const I = E.target, A = i.value.some(
          (M) => M.contains(I)
        ), V = u.isRootMenu && (($ = u.viewport.value) == null ? void 0 : $.contains(I));
        (A || V || !u.isRootMenu) && E.preventDefault();
      }
    }
    ee((E) => {
      const $ = l.value;
      if (u.isRootMenu && $) {
        const I = () => {
          var A;
          d.onRootContentClose(), $.contains(document.activeElement) && ((A = d.triggerRef.value) == null || A.focus());
        };
        $.addEventListener(Ot, I), E(
          () => $.removeEventListener(Ot, I)
        );
      }
    });
    function O(E) {
      var $, I;
      n("escapeKeyDown", E), E.defaultPrevented || (u.onItemDismiss(), (I = ($ = d.triggerRef) == null ? void 0 : $.value) == null || I.focus(), d.wasEscapeCloseRef.value = !0);
    }
    function _(E) {
      var M;
      const $ = E.altKey || E.ctrlKey || E.metaKey, I = E.key === "Tab" && !$, A = io(E.currentTarget);
      if (I) {
        const N = document.activeElement, D = A.findIndex(
          (Z) => Z === N
        ), W = E.shiftKey ? A.slice(0, D).reverse() : A.slice(D + 1, A.length);
        if (Xn(W))
          E.preventDefault();
        else {
          (M = d.focusProxyRef.value) == null || M.focus();
          return;
        }
      }
      const V = qe(
        E,
        document.activeElement,
        void 0,
        { itemsArray: A, loop: !1 }
      );
      V == null || V.focus(), !(E.key === "Enter" || E.key === "Escape") && (E.preventDefault(), E.stopPropagation());
    }
    function S() {
      var $;
      const E = new Event(Ot, {
        bubbles: !0,
        cancelable: !0
      });
      ($ = l.value) == null || $.dispatchEvent(E);
    }
    return (E, $) => (h(), b(a(Pe), B({
      id: a(p),
      ref_key: "primitiveElement",
      ref: r,
      "aria-labelledby": a(c),
      "data-motion": m.value,
      "data-state": a(Vt)(a(u).modelValue.value === a(d).value),
      "data-orientation": a(u).orientation
    }, e, {
      onKeydown: _,
      onEscapeKeyDown: O,
      onPointerDownOutside: w,
      onFocusOutside: C,
      onDismiss: S
    }), {
      default: v(() => [
        y(E.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "aria-labelledby", "data-motion", "data-state", "data-orientation"]));
  }
}), Fd = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "NavigationMenuContent",
  props: {
    forceMount: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = ce(n), i = Tt(), r = Be(), l = Go(), u = P(() => l.value === r.modelValue.value), d = P(() => !r.modelValue.value && r.previousValue.value ? r.previousValue.value === l.value : !1);
    function c(p) {
      n("pointerDownOutside", p), p.preventDefault || r.onContentLeave();
    }
    return (p, f) => a(i) ? (h(), b(Ue, {
      key: 0,
      to: a(r).viewport.value,
      disabled: !a(r).viewport.value
    }, [
      F(a(se), {
        present: p.forceMount || u.value || d.value
      }, {
        default: v(() => [
          F(or, B({
            "data-state": a(Vt)(u.value),
            style: {
              pointerEvents: !u.value && a(r).isRootMenu ? "none" : void 0
            }
          }, { ...p.$attrs, ...e, ...a(s) }, {
            onPointerenter: f[0] || (f[0] = (m) => a(r).onContentEnter(a(l).value)),
            onPointerleave: f[1] || (f[1] = (m) => a(r).onContentLeave()),
            onPointerdown: c,
            onFocusOutside: f[2] || (f[2] = (m) => n("focusOutside", m)),
            onInteractOutside: f[3] || (f[3] = (m) => n("interactOutside", m))
          }), {
            default: v(() => [
              y(p.$slots, "default")
            ]),
            _: 3
          }, 16, ["data-state", "style"])
        ]),
        _: 3
      }, 8, ["present"])
    ], 8, ["to", "disabled"])) : q("", !0);
  }
}), Md = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "NavigationMenuIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, { injectCollection: e } = le("nav"), n = e(), s = Be(), i = x(), r = P(() => s.orientation === "horizontal"), l = P(() => !!s.modelValue.value), u = x();
    function d() {
      u.value && (i.value = {
        size: r.value ? u.value.offsetWidth : u.value.offsetHeight,
        offset: r.value ? u.value.offsetLeft : u.value.offsetTop
      });
    }
    return ee(() => {
      if (!s.modelValue.value) {
        i.value = void 0;
        return;
      }
      const c = n.value;
      u.value = c.find(
        (p) => p.id.includes(s.modelValue.value)
      ), d();
    }), _e(u, d), _e(s.indicatorTrack, d), (c, p) => a(s).indicatorTrack.value ? (h(), b(Ue, {
      key: 0,
      to: a(s).indicatorTrack.value
    }, [
      F(a(se), {
        present: c.forceMount || l.value
      }, {
        default: v(() => {
          var f, m, C, w;
          return [
            F(a(T), B({
              "aria-hidden": "",
              "data-state": l.value ? "visible" : "hidden",
              "data-orientation": a(s).orientation,
              "as-child": t.asChild,
              as: c.as,
              style: {
                position: "absolute",
                ...r.value ? {
                  left: 0,
                  width: `${(f = i.value) == null ? void 0 : f.size}px`,
                  transform: `translateX(${(m = i.value) == null ? void 0 : m.offset}px)`
                } : {
                  top: 0,
                  height: `${(C = i.value) == null ? void 0 : C.size}px`,
                  transform: `translateY(${(w = i.value) == null ? void 0 : w.offset}px)`
                }
              }
            }, c.$attrs), {
              default: v(() => [
                y(c.$slots, "default")
              ]),
              _: 3
            }, 16, ["data-state", "data-orientation", "as-child", "as", "style"])
          ];
        }),
        _: 3
      }, 8, ["present"])
    ], 8, ["to"])) : q("", !0);
  }
}), kd = /* @__PURE__ */ g({
  __name: "NavigationMenuLink",
  props: {
    active: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "a" }
  },
  emits: ["select"],
  setup(o, { emit: t }) {
    const e = o, n = t;
    async function s(i) {
      var r;
      if (n("select", i), await Y(), !i.defaultPrevented && !i.metaKey) {
        const l = new CustomEvent(
          Ot,
          {
            bubbles: !0,
            cancelable: !0
          }
        );
        (r = i.target) == null || r.dispatchEvent(l);
      }
    }
    return (i, r) => (h(), b(a(T), {
      as: i.as,
      "data-active": i.active ? "" : void 0,
      "aria-current": i.active ? "page" : void 0,
      "as-child": e.asChild,
      "data-radix-vue-collection-item": "",
      onClick: s
    }, {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "data-active", "aria-current", "as-child"]));
  }
}), Rd = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "NavigationMenuList",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "ul" }
  },
  setup(o) {
    const t = o, e = Be(), { primitiveElement: n, currentElement: s } = R();
    return U(() => {
      e.onIndicatorTrackChange(s.value);
    }), (i, r) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: n,
      style: { position: "relative" }
    }, {
      default: v(() => [
        F(a(T), B(i.$attrs, {
          "as-child": t.asChild,
          as: i.as,
          "data-orientation": a(e).orientation
        }), {
          default: v(() => [
            y(i.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-orientation"])
      ]),
      _: 3
    }, 512));
  }
}), Vd = /* @__PURE__ */ g({
  __name: "NavigationMenuSub",
  props: {
    modelValue: {},
    defaultValue: {},
    orientation: { default: "horizontal" },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "modelValue", t, {
      defaultValue: e.defaultValue ?? "",
      passive: e.modelValue === void 0
    }), i = x(""), r = Be(), { primitiveElement: l, currentElement: u } = R(), d = x(), c = x(), { createCollection: p } = le("nav");
    return p(d), Gn({
      ...r,
      isRootMenu: !1,
      modelValue: s,
      previousValue: i,
      orientation: e.orientation,
      rootNavigationMenu: u,
      indicatorTrack: d,
      onIndicatorTrackChange: (f) => {
        d.value = f;
      },
      viewport: c,
      onViewportChange: (f) => {
        c.value = f;
      },
      onTriggerEnter: (f) => {
        s.value = f;
      },
      onTriggerLeave: () => {
      },
      onContentEnter: () => {
      },
      onContentLeave: () => {
      },
      onItemSelect: (f) => {
        s.value = f;
      },
      onItemDismiss: () => {
        s.value = "";
      }
    }), (f, m) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: l,
      "data-orientation": f.orientation,
      "as-child": e.asChild,
      as: f.as
    }, {
      default: v(() => [
        y(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-orientation", "as-child", "as"]));
  }
}), nr = ["aria-owns"], jd = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "NavigationMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Be(), n = Go(), { primitiveElement: s, currentElement: i } = R(), r = x(""), l = x(""), u = ho(!1, 300), d = x(!1), c = P(() => n.value === e.modelValue.value);
    U(() => {
      n.triggerRef = i, r.value = Yn(e.baseId, n.value), l.value = qo(e.baseId, n.value);
    });
    function p() {
      d.value = !1, n.wasEscapeCloseRef.value = !1;
    }
    function f(S) {
      if (S.pointerType === "mouse") {
        if (t.disabled || d.value || n.wasEscapeCloseRef.value || u.value)
          return;
        e.onTriggerEnter(n.value), u.value = !0;
      }
    }
    function m(S) {
      if (S.pointerType === "mouse") {
        if (t.disabled)
          return;
        e.onTriggerLeave(), u.value = !1;
      }
    }
    function C() {
      u.value || (c.value ? e.onItemSelect("") : e.onItemSelect(n.value), d.value = c.value);
    }
    function w(S) {
      const $ = { horizontal: "ArrowDown", vertical: e.dir.value === "rtl" ? "ArrowLeft" : "ArrowRight" }[e.orientation];
      c.value && S.key === $ && (n.onEntryKeyDown(), S.preventDefault(), S.stopPropagation());
    }
    function O(S) {
      n.focusProxyRef.value = ve(S);
    }
    function _(S) {
      const E = document.getElementById(n.contentId), $ = S.relatedTarget, I = $ === i.value, A = E == null ? void 0 : E.contains($);
      (I || !A) && n.onFocusProxyEnter(I ? "start" : "end");
    }
    return (S, E) => (h(), Q(re, null, [
      F(a(T), B({
        id: r.value,
        ref_key: "primitiveElement",
        ref: s,
        disabled: S.disabled,
        "data-disabled": S.disabled ? "" : void 0,
        "data-state": a(Vt)(c.value),
        "aria-expanded": c.value,
        "aria-controls": l.value,
        "as-child": t.asChild,
        as: S.as
      }, S.$attrs, {
        "data-radix-vue-collection-item": "",
        onPointerenter: p,
        onPointermove: f,
        onPointerleave: m,
        onClick: C,
        onKeydown: w
      }), {
        default: v(() => [
          y(S.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "disabled", "data-disabled", "data-state", "aria-expanded", "aria-controls", "as-child", "as"]),
      c.value ? (h(), Q(re, { key: 0 }, [
        F(a(Xe), {
          ref: O,
          "aria-hidden": "",
          tabindex: 0,
          onFocus: _
        }),
        a(e).viewport ? (h(), Q("span", {
          key: 0,
          "aria-owns": l.value
        }, null, 8, nr)) : q("", !0)
      ], 64)) : q("", !0)
    ], 64));
  }
}), Ld = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "NavigationMenuViewport",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const { primitiveElement: t, currentElement: e } = R(), n = Be(), s = x(), i = P(() => !!n.modelValue.value), r = P(() => n.modelValue.value);
    X(e, () => {
      e.value && n.onViewportChange(e.value);
    });
    const l = x();
    return X([r, i], async () => {
      var d, c;
      if (await Y(), !e.value)
        return;
      const u = (c = (d = e.value.querySelector("[data-state=open]")) == null ? void 0 : d.children) == null ? void 0 : c[0];
      l.value = u;
    }, { immediate: !0 }), _e(l, () => {
      l.value && (s.value = {
        width: l.value.offsetWidth,
        height: l.value.offsetHeight
      });
    }), (u, d) => (h(), b(a(se), {
      present: u.forceMount || i.value
    }, {
      default: v(() => {
        var c, p;
        return [
          F(a(T), B(u.$attrs, {
            ref_key: "primitiveElement",
            ref: t,
            as: u.as,
            "as-child": u.asChild,
            "data-state": a(Vt)(i.value),
            "data-orientation": a(n).orientation,
            style: {
              // Prevent interaction when animating out
              pointerEvents: !i.value && a(n).isRootMenu ? "none" : void 0,
              "--radix-navigation-menu-viewport-width": s.value ? `${(c = s.value) == null ? void 0 : c.width}px` : void 0,
              "--radix-navigation-menu-viewport-height": s.value ? `${(p = s.value) == null ? void 0 : p.height}px` : void 0
            },
            onPointerenter: d[0] || (d[0] = (f) => a(n).onContentEnter(a(n).modelValue.value)),
            onPointerleave: d[1] || (d[1] = (f) => a(n).onContentLeave())
          }), {
            default: v(() => [
              y(u.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child", "data-state", "data-orientation", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
}), [Qe, ar] = H("PaginationRoot"), Kd = /* @__PURE__ */ g({
  __name: "PaginationRoot",
  props: {
    page: {},
    defaultPage: { default: 1 },
    itemsPerPage: { default: 10 },
    total: { default: 0 },
    siblingCount: { default: 2 },
    disabled: { type: Boolean },
    showEdges: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "nav" }
  },
  emits: ["update:page"],
  setup(o, { emit: t }) {
    const e = o, n = t, { siblingCount: s, disabled: i, showEdges: r } = z(e), l = J(e, "page", n, {
      defaultValue: e.defaultPage,
      passive: e.page === void 0
    }), u = P(() => Math.ceil(e.total / e.itemsPerPage));
    return ar({
      page: l,
      onPageChange(d) {
        l.value = d;
      },
      pageCount: u,
      siblingCount: s,
      disabled: i,
      showEdges: r
    }), (d, c) => (h(), b(a(T), {
      as: d.as,
      "as-child": d.asChild
    }, {
      default: v(() => [
        y(d.$slots, "default", { page: a(l) })
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), Nd = /* @__PURE__ */ g({
  __name: "PaginationEllipsis",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), B({ "data-type": "ellipsis" }, t), {
      default: v(() => [
        y(e.$slots, "default", {}, () => [
          ue("…")
        ])
      ]),
      _: 3
    }, 16));
  }
}), Hd = /* @__PURE__ */ g({
  __name: "PaginationFirst",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Qe();
    return (n, s) => (h(), b(a(T), B(t, {
      "aria-label": "First Page",
      type: n.as === "button" ? "button" : void 0,
      disabled: a(e).page.value === 1 || a(e).disabled.value,
      onClick: s[0] || (s[0] = (i) => a(e).onPageChange(1))
    }), {
      default: v(() => [
        y(n.$slots, "default", {}, () => [
          ue("First page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), Wd = /* @__PURE__ */ g({
  __name: "PaginationLast",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Qe();
    return (n, s) => (h(), b(a(T), B(t, {
      "aria-label": "Last Page",
      type: n.as === "button" ? "button" : void 0,
      disabled: a(e).page.value === a(e).pageCount.value || a(e).disabled.value,
      onClick: s[0] || (s[0] = (i) => a(e).onPageChange(a(e).pageCount.value))
    }), {
      default: v(() => [
        y(n.$slots, "default", {}, () => [
          ue("Last page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
});
function Me(o, t) {
  const e = t - o + 1;
  return Array.from({ length: e }, (n, s) => s + o);
}
function sr(o) {
  return o.map((t) => typeof t == "number" ? { type: "page", value: t } : { type: "ellipsis" });
}
const wt = "ellipsis";
function ir(o, t, e, n) {
  const i = t, r = Math.max(o - e, 1), l = Math.min(o + e, i), u = r > 1 + 1, d = l < i - 1;
  if (n) {
    const p = Math.min(2 * e + 5, t) - 2;
    if (!u && d)
      return [...Me(1, p), wt, i];
    if (u && !d) {
      const m = Me(i - p + 1, i);
      return [1, wt, ...m];
    }
    if (u && d) {
      const m = Me(r, l);
      return [1, wt, ...m, wt, i];
    }
    return Me(1, i);
  } else {
    const c = e * 2 + 1;
    return o <= e + 1 ? Me(1, c) : t - o <= e ? Me(t - c + 1, i) : Me(r, l);
  }
}
const zd = /* @__PURE__ */ g({
  __name: "PaginationList",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = Qe(), n = P(() => sr(
      ir(
        e.page.value,
        e.pageCount.value,
        e.siblingCount.value,
        e.showEdges.value
      )
    ));
    return (s, i) => (h(), b(a(T), k(K(t)), {
      default: v(() => [
        y(s.$slots, "default", { items: n.value })
      ]),
      _: 3
    }, 16));
  }
}), Ud = /* @__PURE__ */ g({
  __name: "PaginationListItem",
  props: {
    value: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Qe(), n = P(() => e.page.value === t.value);
    return (s, i) => (h(), b(a(T), B(t, {
      "data-type": "page",
      "aria-label": `Page ${s.value}`,
      "aria-current": n.value ? "page" : void 0,
      "data-selected": n.value ? "true" : void 0,
      disabled: a(e).disabled.value,
      type: s.as === "button" ? "button" : void 0,
      onClick: i[0] || (i[0] = (r) => a(e).onPageChange(s.value))
    }), {
      default: v(() => [
        y(s.$slots, "default", {}, () => [
          ue(je(s.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-current", "data-selected", "disabled", "type"]));
  }
}), qd = /* @__PURE__ */ g({
  __name: "PaginationNext",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Qe();
    return (n, s) => (h(), b(a(T), B(t, {
      "aria-label": "Next Page",
      type: n.as === "button" ? "button" : void 0,
      disabled: a(e).page.value === a(e).pageCount.value || a(e).disabled.value,
      onClick: s[0] || (s[0] = (i) => a(e).onPageChange(a(e).page.value + 1))
    }), {
      default: v(() => [
        y(n.$slots, "default", {}, () => [
          ue("Next page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), Gd = /* @__PURE__ */ g({
  __name: "PaginationPrev",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Qe();
    return (n, s) => {
      var i;
      return h(), b(a(T), B(t, {
        "aria-label": "Previous Page",
        type: n.as === "button" ? "button" : void 0,
        disabled: a(e).page.value === 1 || ((i = a(e).disabled) == null ? void 0 : i.value),
        onClick: s[0] || (s[0] = (r) => a(e).onPageChange(a(e).page.value - 1))
      }), {
        default: v(() => [
          y(n.$slots, "default", {}, () => [
            ue("Prev page")
          ])
        ]),
        _: 3
      }, 16, ["type", "disabled"]);
    };
  }
}), rr = ["id", "value", "name", "disabled", "required"], [lr, ur] = H("PinInputRoot"), Yd = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "PinInputRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    placeholder: { default: "" },
    mask: { type: Boolean },
    otp: { type: Boolean },
    type: { default: "text" },
    dir: {},
    name: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    id: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "complete"],
  setup(o, { emit: t }) {
    const e = o, n = t, { mask: s, otp: i, placeholder: r, type: l, disabled: u, dir: d } = z(e), c = de(d), p = J(e, "modelValue", n, {
      defaultValue: e.defaultValue ?? [],
      passive: e.modelValue === void 0
    }), f = x(/* @__PURE__ */ new Set());
    function m(w) {
      f.value.add(w);
    }
    const C = P(() => p.value.filter((O) => !!O).length === f.value.size);
    return X(p, () => {
      C.value && n("complete", p.value);
    }, { deep: !0 }), ur({
      modelValue: p,
      mask: s,
      otp: i,
      placeholder: r,
      type: l,
      dir: c,
      disabled: u,
      isCompleted: C,
      inputElements: f,
      onInputElementChange: m
    }), (w, O) => (h(), Q(re, null, [
      F(a(T), B(w.$attrs, {
        dir: a(c),
        "data-complete": C.value ? "" : void 0,
        "data-disabled": a(u) ? "" : void 0
      }), {
        default: v(() => [
          y(w.$slots, "default", { modelValue: a(p) })
        ]),
        _: 3
      }, 16, ["dir", "data-complete", "data-disabled"]),
      lt("input", {
        id: w.id,
        type: "text",
        tabindex: "-1",
        "aria-hidden": "",
        value: a(p).join(""),
        name: w.name,
        disabled: a(u),
        required: w.required,
        style: ae({
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }),
        onFocus: O[0] || (O[0] = (_) => {
          var S, E;
          return (E = (S = Array.from(f.value)) == null ? void 0 : S[0]) == null ? void 0 : E.focus();
        })
      }, null, 44, rr)
    ], 64));
  }
}), dr = ["autocomplete", "type", "inputmode", "pattern", "placeholder", "value", "disabled", "data-disabled", "data-complete", "aria-label", "onKeydown"], Xd = /* @__PURE__ */ g({
  __name: "PinInputInput",
  props: {
    index: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "input" }
  },
  setup(o) {
    const t = o, e = lr(), n = P(() => Array.from(e.inputElements.value)), s = P(() => t.disabled || e.disabled.value), i = P(() => e.otp.value), r = P(() => e.type.value === "number"), l = P(() => e.mask.value), u = x();
    function d(_) {
      const S = _.target;
      if (r.value && !/^[0-9]*$/.test(S.value)) {
        S.value = S.value.replace(/\D/g, "");
        return;
      }
      S.value = S.value.slice(-1), O(t.index, S.value);
      const E = n.value[t.index + 1];
      E && E.focus();
    }
    function c(_) {
      qe(_, document.activeElement, void 0, {
        itemsArray: n.value,
        focus: !0,
        loop: !1,
        arrowKeyOptions: "horizontal",
        dir: e.dir.value
      });
    }
    function p(_) {
      if (_.preventDefault(), _.target.value)
        O(t.index, "");
      else {
        const $ = n.value[t.index - 1];
        $ && ($.focus(), O(t.index - 1, ""));
      }
    }
    function f(_) {
      _.preventDefault(), O(t.index, "");
    }
    function m(_) {
      const S = _.target;
      S.setSelectionRange(1, 1), S.value || (S.placeholder = "");
    }
    function C(_) {
      const S = _.target;
      Y(() => {
        S.value || (S.placeholder = e.placeholder.value);
      });
    }
    function w(_) {
      var A;
      _.preventDefault();
      const S = _.clipboardData;
      if (!S)
        return;
      const E = S.getData("text"), $ = E.length >= n.value.length ? 0 : t.index, I = Math.min($ + E.length, n.value.length);
      for (let V = $; V < I; V++) {
        const M = n.value[V], N = E[V - $];
        r.value && !/^[0-9]*$/.test(N) || (M.value = N, O(V, N), M.focus());
      }
      (A = n.value[I]) == null || A.focus();
    }
    function O(_, S) {
      const E = [...e.modelValue.value];
      E[_] = S, e.modelValue.value = E;
    }
    return U(() => {
      e.onInputElementChange(u.value);
    }), fe(() => {
      var _;
      (_ = e.inputElements) == null || _.value.delete(u.value);
    }), (_, S) => (h(), Q("input", {
      ref_key: "inputRef",
      ref: u,
      autocapitalize: "none",
      autocomplete: i.value ? "one-time-code" : "false",
      type: l.value ? "password" : "text",
      inputmode: r.value ? "numeric" : "text",
      pattern: r.value ? "[0-9]*" : void 0,
      placeholder: a(e).placeholder.value,
      value: a(e).modelValue.value.at(_.index),
      disabled: s.value,
      "data-disabled": s.value ? "" : void 0,
      "data-complete": a(e).isCompleted.value ? "" : void 0,
      "aria-label": `pin input ${_.index + 1} of ${n.value.length}`,
      onInput: d,
      onKeydown: [
        ie(c, ["left", "right", "up", "down", "home", "end"]),
        ie(p, ["backspace"]),
        ie(f, ["delete"])
      ],
      onFocus: m,
      onBlur: C,
      onPaste: w
    }, null, 40, dr));
  }
}), [We, cr] = H("PopoverRoot"), Jd = /* @__PURE__ */ g({
  __name: "PopoverRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    modal: { type: Boolean, default: !1 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, { modal: s } = z(e), i = J(e, "open", n, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    }), r = x(), l = x(!1);
    return cr({
      contentId: oe(),
      modal: s,
      open: i,
      onOpenChange: (u) => {
        i.value = u;
      },
      onOpenToggle: () => {
        i.value = !i.value;
      },
      triggerElement: r,
      hasCustomAnchor: l
    }), (u, d) => (h(), b(a(Ke), null, {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Zd = /* @__PURE__ */ g({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o, { expose: t }) {
    const e = o, n = We(), { primitiveElement: s, currentElement: i } = R();
    return U(() => {
      n.triggerElement.value = i.value;
    }), t({ $el: i }), (r, l) => (h(), b(xe(a(n).hasCustomAnchor.value ? a(T) : a(Ne)), { "as-child": "" }, {
      default: v(() => [
        F(a(T), {
          ref_key: "primitiveElement",
          ref: s,
          type: r.as === "button" ? "button" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": a(n).open.value,
          "aria-controls": a(n).contentId,
          "data-state": a(n).open.value ? "open" : "closed",
          as: r.as,
          "as-child": e.asChild,
          onClick: a(n).onOpenToggle
        }, {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["type", "aria-expanded", "aria-controls", "data-state", "as", "as-child", "onClick"])
      ]),
      _: 3
    }));
  }
}), Qd = /* @__PURE__ */ g({
  __name: "PopoverPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Jn = /* @__PURE__ */ g({
  __name: "PopoverContentImpl",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = It(e), i = We();
    return Co(), (r, l) => (h(), b(a(Ft), {
      "as-child": "",
      loop: "",
      trapped: r.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (u) => n("openAutoFocus", u)),
      onUnmountAutoFocus: l[6] || (l[6] = (u) => n("closeAutoFocus", u))
    }, {
      default: v(() => [
        F(a(Pe), {
          "as-child": "",
          "disable-outside-pointer-events": r.disableOutsidePointerEvents,
          onPointerDownOutside: l[0] || (l[0] = (u) => n("pointerDownOutside", u)),
          onInteractOutside: l[1] || (l[1] = (u) => n("interactOutside", u)),
          onEscapeKeyDown: l[2] || (l[2] = (u) => n("escapeKeyDown", u)),
          onFocusOutside: l[3] || (l[3] = (u) => n("focusOutside", u)),
          onDismiss: l[4] || (l[4] = (u) => a(i).onOpenChange(!1))
        }, {
          default: v(() => [
            F(a(Ge), B(a(s), {
              id: a(i).contentId,
              "data-state": a(i).open.value ? "open" : "closed",
              role: "dialog",
              style: {
                "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
              }
            }), {
              default: v(() => [
                y(r.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), pr = /* @__PURE__ */ g({
  __name: "PopoverContentModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = We(), i = x(!1);
    pt(!0);
    const r = pe(e, n), { primitiveElement: l, currentElement: u } = R();
    return ft(u), (d, c) => (h(), b(Jn, B({
      ref_key: "primitiveElement",
      ref: l
    }, a(r), {
      "trap-focus": a(s).open.value,
      "disable-outside-pointer-events": "",
      onCloseAutoFocus: c[0] || (c[0] = te(
        (p) => {
          var f;
          n("closeAutoFocus", p), i.value || (f = a(s).triggerElement.value) == null || f.focus();
        },
        ["prevent"]
      )),
      onPointerDownOutside: c[1] || (c[1] = (p) => {
        n("pointerDownOutside", p);
        const f = p.detail.originalEvent, m = f.button === 0 && f.ctrlKey === !0, C = f.button === 2 || m;
        i.value = C;
      }),
      onFocusOutside: c[2] || (c[2] = te(() => {
      }, ["prevent"]))
    }), {
      default: v(() => [
        y(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), fr = /* @__PURE__ */ g({
  __name: "PopoverContentNonModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = We(), i = x(!1), r = x(!1), l = pe(e, n);
    return (u, d) => (h(), b(Jn, B(a(l), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: d[0] || (d[0] = (c) => {
        var p;
        n("closeAutoFocus", c), c.defaultPrevented || (i.value || (p = a(s).triggerElement.value) == null || p.focus(), c.preventDefault()), i.value = !1, r.value = !1;
      }),
      onInteractOutside: d[1] || (d[1] = async (c) => {
        var m;
        n("interactOutside", c), c.defaultPrevented || (i.value = !0, c.detail.originalEvent.type === "pointerdown" && (r.value = !0));
        const p = c.target;
        ((m = a(s).triggerElement.value) == null ? void 0 : m.contains(p)) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && r.value && c.preventDefault();
      })
    }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ec = /* @__PURE__ */ g({
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss", "openAutoFocus", "closeAutoFocus"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = We(), i = pe(e, n);
    return (r, l) => (h(), b(a(se), {
      present: r.forceMount || a(s).open.value
    }, {
      default: v(() => [
        a(s).modal.value ? (h(), b(pr, k(B({ key: 0 }, a(i))), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16)) : (h(), b(fr, k(B({ key: 1 }, a(i))), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), tc = /* @__PURE__ */ g({
  __name: "PopoverArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ye), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), oc = /* @__PURE__ */ g({
  __name: "PopoverClose",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = We();
    return (n, s) => (h(), b(a(T), {
      type: n.as === "button" ? "button" : void 0,
      as: n.as,
      "as-child": t.asChild,
      onClick: s[0] || (s[0] = (i) => a(e).onOpenChange(!1))
    }, {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["type", "as", "as-child"]));
  }
}), nc = /* @__PURE__ */ g({
  __name: "PopoverAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = We();
    return bn(() => {
      e.hasCustomAnchor.value = !0;
    }), fe(() => {
      e.hasCustomAnchor.value = !1;
    }), (n, s) => (h(), b(a(Ne), k(K(t)), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), it = 100, [vr, mr] = H("ProgressRoot"), Yo = (o) => typeof o == "number";
function hr(o, t) {
  return o === null || Yo(o) && !Number.isNaN(o) && o <= t && o >= 0 ? o : (console.error(`Invalid prop \`value\` of value \`${o}\` supplied to \`ProgressRoot\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${it} if no \`max\` prop is set)
  - \`null\` if the progress is indeterminate.

Defaulting to \`null\`.`), null);
}
function yr(o) {
  return Yo(o) && !Number.isNaN(o) && o > 0 ? o : (console.error(
    `Invalid prop \`max\` of value \`${o}\` supplied to \`ProgressRoot\`. Only numbers greater than 0 are valid max values. Defaulting to \`${it}\`.`
  ), it);
}
const ac = /* @__PURE__ */ g({
  __name: "ProgressRoot",
  props: {
    modelValue: {},
    max: { default: it },
    getValueLabel: { type: Function, default: (o, t) => `${Math.round(o / t * it)}%` },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:max"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = J(e, "modelValue", n, {
      passive: e.modelValue === void 0
    }), i = J(e, "max", n, {
      passive: e.max === void 0
    });
    X(
      () => s.value,
      async (l) => {
        const u = hr(l, e.max);
        u !== l && (await Y(), s.value = u);
      },
      { immediate: !0 }
    ), X(
      () => e.max,
      (l) => {
        const u = yr(e.max);
        u !== l && (i.value = u);
      },
      { immediate: !0 }
    );
    const r = P(() => s.value ? s.value === i.value ? "complete" : "loading" : "indeterminate");
    return mr({
      modelValue: s,
      max: i,
      progressState: r
    }), (l, u) => (h(), b(a(T), {
      "as-child": e.asChild,
      as: l.as,
      "aria-valuemax": a(i),
      "aria-valuemin": 0,
      "aria-valuenow": Yo(a(s)) ? a(s) : void 0,
      "aria-valuetext": l.getValueLabel(a(s), a(i)),
      "aria-label": l.getValueLabel(a(s), a(i)),
      role: "progressbar",
      "data-state": r.value,
      "data-value": a(s) ?? void 0,
      "data-max": a(i)
    }, {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "aria-valuemax", "aria-valuenow", "aria-valuetext", "aria-label", "data-state", "data-value", "data-max"]));
  }
}), sc = /* @__PURE__ */ g({
  __name: "ProgressIndicator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = vr();
    return (n, s) => {
      var i;
      return h(), b(a(T), B(t, {
        "data-state": a(e).progressState.value,
        "data-value": ((i = a(e).modelValue) == null ? void 0 : i.value) ?? void 0,
        "data-max": a(e).max.value
      }), {
        default: v(() => [
          y(n.$slots, "default")
        ]),
        _: 3
      }, 16, ["data-state", "data-value", "data-max"]);
    };
  }
}), [gr, br] = H("RadioGroupRoot"), ic = /* @__PURE__ */ g({
  __name: "RadioGroupRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    disabled: { type: Boolean, default: !1 },
    name: {},
    required: { type: Boolean, default: !1 },
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "modelValue", t, {
      defaultValue: e.defaultValue,
      passive: e.modelValue === void 0
    }), { disabled: i, loop: r, orientation: l, name: u, required: d, dir: c } = z(e), p = de(c);
    return br({
      modelValue: s,
      changeModelValue: (f) => {
        s.value = f;
      },
      disabled: i,
      loop: r,
      orientation: l,
      name: u == null ? void 0 : u.value,
      required: d
    }), (f, m) => (h(), b(a(Je), {
      "as-child": "",
      orientation: a(l),
      dir: a(p),
      loop: a(r)
    }, {
      default: v(() => [
        F(a(T), {
          role: "radiogroup",
          "data-disabled": a(i) ? "" : void 0,
          "as-child": f.asChild,
          as: f.as,
          required: a(d),
          "aria-orientation": a(l),
          "aria-required": a(d),
          dir: a(p),
          name: a(u)
        }, {
          default: v(() => [
            y(f.$slots, "default")
          ]),
          _: 3
        }, 8, ["data-disabled", "as-child", "as", "required", "aria-orientation", "aria-required", "dir", "name"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
}), Cr = ["value", "checked", "name", "disabled", "required"], _r = /* @__PURE__ */ g({
  __name: "Radio",
  props: {
    id: {},
    value: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean },
    checked: { type: Boolean, default: void 0 },
    name: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  emits: ["update:checked"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "checked", t, {
      passive: e.checked === void 0
    }), { value: i } = z(e), { primitiveElement: r, currentElement: l } = R(), u = Le(l), d = P(() => {
      var p;
      return e.id && l.value ? ((p = document.querySelector(`[for="${e.id}"]`)) == null ? void 0 : p.innerText) ?? e.value : void 0;
    });
    function c(p) {
      s.value = !0, u.value && p.stopPropagation();
    }
    return (p, f) => (h(), b(a(T), B(p.$attrs, {
      id: p.id,
      ref_key: "primitiveElement",
      ref: r,
      role: "radio",
      type: p.as === "button" ? "button" : void 0,
      as: p.as,
      "aria-checked": a(s),
      "aria-label": d.value,
      "as-child": p.asChild,
      disabled: p.disabled ? !0 : void 0,
      "data-state": a(s) ? "checked" : "unchecked",
      "data-disabled": p.disabled ? "" : void 0,
      value: a(i),
      required: p.required,
      name: p.name,
      onClick: te(c, ["stop"])
    }), {
      default: v(() => [
        y(p.$slots, "default"),
        a(u) ? (h(), Q("input", {
          key: 0,
          type: "radio",
          tabindex: "-1",
          "aria-hidden": "",
          value: a(i),
          checked: !!a(s),
          name: p.name,
          disabled: p.disabled,
          required: p.required,
          style: ae({
            transform: "translateX(-100%)",
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
          })
        }, null, 12, Cr)) : q("", !0)
      ]),
      _: 3
    }, 16, ["id", "type", "as", "aria-checked", "aria-label", "as-child", "disabled", "data-state", "data-disabled", "value", "required", "name", "onClick"]));
  }
}), [wr, Sr] = H("RadioGroupItem"), rc = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "RadioGroupItem",
  props: {
    id: {},
    value: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean },
    name: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, { primitiveElement: e, currentElement: n } = R(), s = gr(), i = P(() => s.disabled.value || t.disabled), r = P(() => s.required.value || t.required), l = P(() => {
      var p;
      return ((p = s.modelValue) == null ? void 0 : p.value) === t.value;
    });
    Sr({ disabled: i, checked: l });
    const u = x(!1), d = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
    Re("keydown", (p) => {
      d.includes(p.key) && (u.value = !0);
    }), Re("keyup", () => {
      u.value = !1;
    });
    function c() {
      setTimeout(() => {
        var p;
        u.value && ((p = n.value) == null || p.click());
      }, 0);
    }
    return (p, f) => (h(), b(a(Ze), {
      checked: l.value,
      disabled: i.value,
      "as-child": "",
      focusable: !i.value,
      active: l.value
    }, {
      default: v(() => [
        F(_r, B({
          ref_key: "primitiveElement",
          ref: e
        }, { ...p.$attrs, ...t }, {
          checked: l.value,
          required: r.value,
          "onUpdate:checked": f[0] || (f[0] = (m) => a(s).changeModelValue(p.value)),
          onKeydown: f[1] || (f[1] = ie(te(() => {
          }, ["prevent"]), ["enter"])),
          onFocus: c
        }), {
          default: v(() => [
            y(p.$slots, "default")
          ]),
          _: 3
        }, 16, ["checked", "required"])
      ]),
      _: 3
    }, 8, ["checked", "disabled", "focusable", "active"]));
  }
}), lc = /* @__PURE__ */ g({
  __name: "RadioGroupIndicator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = wr();
    return (e, n) => a(t).checked.value ? (h(), b(a(T), {
      key: 0,
      "data-state": a(t).checked.value ? "checked" : "unchecked",
      "data-disabled": a(t).disabled.value ? "" : void 0,
      "as-child": e.asChild,
      as: e.as
    }, {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-state", "data-disabled", "as-child", "as"])) : q("", !0);
  }
}), [me, Er] = H("ScrollAreaRoot"), uc = /* @__PURE__ */ g({
  __name: "ScrollAreaRoot",
  props: {
    type: { default: "hover" },
    dir: {},
    scrollHideDelay: { default: 600 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o, { primitiveElement: e, currentElement: n } = R(), s = x(0), i = x(0), r = x(), l = x(), u = x(), d = x(), c = x(!1), p = x(!1), { type: f, dir: m, scrollHideDelay: C } = z(t), w = de(m);
    return Er({
      type: f,
      dir: w,
      scrollHideDelay: C,
      scrollArea: n,
      viewport: r,
      onViewportChange: (O) => {
        r.value = O || void 0;
      },
      content: l,
      onContentChange: (O) => {
        l.value = O;
      },
      scrollbarX: u,
      scrollbarXEnabled: c,
      scrollbarY: d,
      scrollbarYEnabled: p,
      onScrollbarXChange: (O) => {
        u.value = O || void 0;
      },
      onScrollbarYChange: (O) => {
        d.value = O || void 0;
      },
      onScrollbarXEnabledChange: (O) => {
        c.value = O;
      },
      onScrollbarYEnabledChange: (O) => {
        p.value = O;
      },
      onCornerWidthChange: (O) => {
        s.value = O;
      },
      onCornerHeightChange: (O) => {
        i.value = O;
      }
    }), (O, _) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: e,
      "as-child": t.asChild,
      as: O.as,
      dir: a(w),
      style: ae({
        position: "relative",
        // Pass corner sizes as CSS vars to reduce re-renders of context consumers
        "--radix-scroll-area-corner-width": `${s.value}px`,
        "--radix-scroll-area-corner-height": `${i.value}px`
      })
    }, {
      default: v(() => [
        y(O.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "dir", "style"]));
  }
}), dc = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "ScrollAreaViewport",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = me(), { primitiveElement: n, currentElement: s } = R(), i = x();
    return U(() => {
      e.onViewportChange(i.value), e.onContentChange(s.value);
    }), (r, l) => (h(), Q(re, null, [
      F(a(T), { as: "style" }, {
        default: v(() => [
          ue(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-radix-scroll-area-viewport] { scrollbar-width:none; -ms-overflow-style:none; -webkit-overflow-scrolling:touch; } [data-radix-scroll-area-viewport]::-webkit-scrollbar { display:none; } ")
        ]),
        _: 1
      }),
      lt("div", B({
        ref_key: "viewportElement",
        ref: i,
        "data-radix-scroll-area-viewport": "",
        style: {
          /**
           * We don't support `visible` because the intention is to have at least one scrollbar
           * if this component is used and `visible` will behave like `auto` in that case
           * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
           *
           * We don't handle `auto` because the intention is for the native implementation
           * to be hidden if using this component. We just want to ensure the node is scrollable
           * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
           * the browser from having to work out whether to render native scrollbars or not,
           * we tell it to with the intention of hiding them in CSS.
           */
          overflowX: a(e).scrollbarXEnabled.value ? "scroll" : "hidden",
          overflowY: a(e).scrollbarYEnabled.value ? "scroll" : "hidden"
        }
      }, r.$attrs, { tabindex: 0 }), [
        F(a(T), {
          ref_key: "primitiveElement",
          ref: n,
          style: { minWidth: "100%", display: "table" },
          "as-child": t.asChild,
          as: r.as
        }, {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["as-child", "as"])
      ], 16)
    ], 64));
  }
});
function xr(o, [t, e]) {
  return Math.min(e, Math.max(t, o));
}
function Zn(o, t) {
  return (e) => {
    if (o[0] === o[1] || t[0] === t[1])
      return t[0];
    const n = (t[1] - t[0]) / (o[1] - o[0]);
    return t[0] + n * (e - o[0]);
  };
}
function jt(o) {
  const t = Qn(o.viewport, o.content), e = o.scrollbar.paddingStart + o.scrollbar.paddingEnd, n = (o.scrollbar.size - e) * t;
  return Math.max(n, 18);
}
function Qn(o, t) {
  const e = o / t;
  return Number.isNaN(e) ? 0 : e;
}
function Or(o, t = () => {
}) {
  let e = { left: o.scrollLeft, top: o.scrollTop }, n = 0;
  return function s() {
    const i = { left: o.scrollLeft, top: o.scrollTop }, r = e.left !== i.left, l = e.top !== i.top;
    (r || l) && t(), e = i, n = window.requestAnimationFrame(s);
  }(), () => window.cancelAnimationFrame(n);
}
function ln(o, t, e = "ltr") {
  const n = jt(t), s = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - s, r = t.content - t.viewport, l = i - n, u = e === "ltr" ? [0, r] : [r * -1, 0], d = xr(
    o,
    u
  );
  return Zn([0, r], [0, l])(d);
}
function St(o) {
  return o ? Number.parseInt(o, 10) : 0;
}
function $r(o, t, e, n = "ltr") {
  const s = jt(e), i = s / 2, r = t || i, l = s - r, u = e.scrollbar.paddingStart + r, d = e.scrollbar.size - e.scrollbar.paddingEnd - l, c = e.content - e.viewport, p = n === "ltr" ? [0, c] : [c * -1, 0];
  return Zn(
    [u, d],
    p
  )(o);
}
function un(o, t) {
  return o > 0 && o < t;
}
const ea = /* @__PURE__ */ g({
  __name: "ScrollAreaScrollbarImpl",
  props: {
    isHorizontal: { type: Boolean }
  },
  emits: ["onDragScroll", "onWheelScroll", "onThumbPointerDown"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = me(), i = Lt(), r = Kt(), { primitiveElement: l, currentElement: u } = R(), d = be(), c = x(""), p = x();
    function f(S) {
      var E, $;
      if (p.value) {
        const I = S.clientX - ((E = p.value) == null ? void 0 : E.left), A = S.clientY - (($ = p.value) == null ? void 0 : $.top);
        n("onDragScroll", { x: I, y: A });
      }
    }
    function m(S) {
      S.button === 0 && (S.target.setPointerCapture(S.pointerId), p.value = u.value.getBoundingClientRect(), c.value = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", s.viewport && (s.viewport.value.style.scrollBehavior = "auto"), f(S));
    }
    function C(S) {
      f(S);
    }
    function w(S) {
      const E = S.target;
      E.hasPointerCapture(S.pointerId) && E.releasePointerCapture(S.pointerId), document.body.style.webkitUserSelect = c.value, s.viewport && (s.viewport.value.style.scrollBehavior = ""), p.value = void 0;
    }
    function O(S) {
      var A;
      const E = S.target, $ = (A = u.value) == null ? void 0 : A.contains(E), I = i.sizes.value.content - i.sizes.value.viewport;
      $ && i.handleWheelScroll(S, I);
    }
    U(() => {
      document.addEventListener("wheel", O, { passive: !1 });
    }), fe(() => {
      document.removeEventListener("wheel", O);
    });
    function _() {
      var S, E, $, I, A;
      u.value && (e.isHorizontal ? i.handleSizeChange({
        content: ((S = s.viewport.value) == null ? void 0 : S.scrollWidth) ?? 0,
        viewport: ((E = s.viewport.value) == null ? void 0 : E.offsetWidth) ?? 0,
        scrollbar: {
          size: u.value.clientWidth ?? 0,
          paddingStart: St(getComputedStyle(u.value).paddingLeft),
          paddingEnd: St(getComputedStyle(u.value).paddingRight)
        }
      }) : i.handleSizeChange({
        content: (($ = s.viewport.value) == null ? void 0 : $.scrollHeight) ?? 0,
        viewport: ((I = s.viewport.value) == null ? void 0 : I.offsetHeight) ?? 0,
        scrollbar: {
          size: ((A = u.value) == null ? void 0 : A.clientHeight) ?? 0,
          paddingStart: St(getComputedStyle(u.value).paddingLeft),
          paddingEnd: St(getComputedStyle(u.value).paddingRight)
        }
      }));
    }
    return _e(u, _), _e(s.content, _), (S, E) => (h(), b(a(T), {
      ref: ($) => {
        a(d)($), l.value = $;
      },
      style: { position: "absolute" },
      "data-scrollbarimpl": "",
      as: a(r).as.value,
      "as-child": a(r).asChild.value,
      onPointerdown: m,
      onPointermove: C,
      onPointerup: w
    }, {
      default: v(() => [
        y(S.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), Pr = /* @__PURE__ */ g({
  __name: "ScrollAreaScrollbarX",
  setup(o) {
    const t = me(), e = Lt(), { primitiveElement: n, currentElement: s } = R(), i = be();
    U(() => {
      s.value && t.onScrollbarXChange(s.value);
    });
    const r = P(() => e.sizes.value);
    return (l, u) => (h(), b(ea, {
      ref: (d) => {
        a(i)(d), n.value = d;
      },
      "is-horizontal": !0,
      "data-orientation": "horizontal",
      style: ae({
        bottom: 0,
        left: a(t).dir.value === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a(t).dir.value === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": r.value ? `${a(jt)(r.value)}px` : void 0
      }),
      onOnDragScroll: u[0] || (u[0] = (d) => a(e).onDragScroll(d.x))
    }, {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), Br = /* @__PURE__ */ g({
  __name: "ScrollAreaScrollbarY",
  setup(o) {
    const t = me(), e = Lt(), { primitiveElement: n, currentElement: s } = R(), i = be();
    U(() => {
      s.value && t.onScrollbarYChange(s.value);
    });
    const r = P(() => e.sizes.value);
    return (l, u) => (h(), b(ea, {
      ref: (d) => {
        a(i)(d), n.value = d;
      },
      "is-horizontal": !1,
      "data-orientation": "vertical",
      style: ae({
        top: 0,
        right: a(t).dir.value === "ltr" ? 0 : void 0,
        left: a(t).dir.value === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": r.value ? `${a(jt)(r.value)}px` : void 0
      }),
      onOnDragScroll: u[0] || (u[0] = (d) => a(e).onDragScroll(d.y))
    }, {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), [Lt, Tr] = H("ScrollAreaScrollbarVisible"), Xo = /* @__PURE__ */ g({
  __name: "ScrollAreaScrollbarVisible",
  setup(o) {
    const t = me(), e = Kt(), n = be(), s = x({
      content: 0,
      viewport: 0,
      scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
    }), i = P(() => {
      const _ = Qn(s.value.viewport, s.value.content);
      return _ > 0 && _ < 1;
    }), r = x(), l = x(0);
    function u(_, S) {
      if (m.value) {
        const E = t.viewport.value.scrollLeft + _.deltaY;
        t.viewport.value.scrollLeft = E, un(E, S) && _.preventDefault();
      } else {
        const E = t.viewport.value.scrollTop + _.deltaY;
        t.viewport.value.scrollTop = E, un(E, S) && _.preventDefault();
      }
    }
    function d(_, S) {
      m.value ? l.value = S.x : l.value = S.y;
    }
    function c(_) {
      l.value = 0;
    }
    function p(_) {
      s.value = _;
    }
    function f(_, S) {
      return $r(
        _,
        l.value,
        s.value,
        S
      );
    }
    const m = P(
      () => e.isHorizontal.value
    );
    function C(_) {
      m.value ? t.viewport.value.scrollLeft = f(
        _,
        t.dir.value
      ) : t.viewport.value.scrollTop = f(_);
    }
    function w() {
      if (m.value) {
        if (t.viewport.value && r.value) {
          const _ = t.viewport.value.scrollLeft, S = ln(
            _,
            s.value,
            t.dir.value
          );
          r.value.style.transform = `translate3d(${S}px, 0, 0)`;
        }
      } else if (t.viewport.value && r.value) {
        const _ = t.viewport.value.scrollTop, S = ln(_, s.value);
        r.value.style.transform = `translate3d(0, ${S}px, 0)`;
      }
    }
    function O(_) {
      r.value = _;
    }
    return Tr({
      sizes: s,
      hasThumb: i,
      handleWheelScroll: u,
      handleThumbDown: d,
      handleThumbUp: c,
      handleSizeChange: p,
      onThumbPositionChange: w,
      onThumbChange: O,
      onDragScroll: C
    }), (_, S) => m.value ? (h(), b(Pr, B({ key: 0 }, _.$attrs, {
      ref_key: "forwardRef",
      ref: n
    }), {
      default: v(() => [
        y(_.$slots, "default")
      ]),
      _: 3
    }, 16)) : (h(), b(Br, B({ key: 1 }, _.$attrs, {
      ref_key: "forwardRef",
      ref: n
    }), {
      default: v(() => [
        y(_.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ta = /* @__PURE__ */ g({
  __name: "ScrollAreaScrollbarAuto",
  props: {
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = me(), e = Kt(), n = be(), s = x(!1), i = yo(() => {
      if (t.viewport.value) {
        const r = t.viewport.value.offsetWidth < t.viewport.value.scrollWidth, l = t.viewport.value.offsetHeight < t.viewport.value.scrollHeight;
        s.value = e.isHorizontal.value ? r : l;
      }
    }, 10);
    return U(() => i()), _e(t.viewport, i), _e(t.content, i), (r, l) => (h(), b(a(se), {
      present: r.forceMount || s.value
    }, {
      default: v(() => [
        F(Xo, B(r.$attrs, {
          ref_key: "forwardRef",
          ref: n,
          "data-state": s.value ? "visible" : "hidden"
        }), {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Dr = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "ScrollAreaScrollbarHover",
  props: {
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = me(), e = be();
    let n;
    const s = x(!1);
    function i() {
      window.clearTimeout(n), s.value = !0;
    }
    function r() {
      n = window.setTimeout(() => {
        s.value = !1;
      }, t.scrollHideDelay.value);
    }
    return U(() => {
      const l = t.scrollArea.value;
      l && (l.addEventListener("pointerenter", i), l.addEventListener("pointerleave", r));
    }), fe(() => {
      const l = t.scrollArea.value;
      l && (window.clearTimeout(n), l.removeEventListener("pointerenter", i), l.removeEventListener("pointerleave", r));
    }), (l, u) => (h(), b(a(se), {
      present: l.forceMount || s.value
    }, {
      default: v(() => [
        F(ta, B(l.$attrs, {
          ref_key: "forwardRef",
          ref: e,
          "data-state": s.value ? "visible" : "hidden"
        }), {
          default: v(() => [
            y(l.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Ir = /* @__PURE__ */ g({
  __name: "ScrollAreaScrollbarScroll",
  props: {
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = me(), e = Kt(), n = be(), { state: s, dispatch: i } = xn("hidden", {
      hidden: {
        SCROLL: "scrolling"
      },
      scrolling: {
        SCROLL_END: "idle",
        POINTER_ENTER: "interacting"
      },
      interacting: {
        SCROLL: "interacting",
        POINTER_LEAVE: "idle"
      },
      idle: {
        HIDE: "hidden",
        SCROLL: "scrolling",
        POINTER_ENTER: "interacting"
      }
    });
    ee(() => {
      s.value === "idle" && window.setTimeout(
        () => i("HIDE"),
        t.scrollHideDelay.value
      );
    });
    const r = yo(() => i("SCROLL_END"), 100);
    return ee(() => {
      const l = t.viewport.value, u = e.isHorizontal.value ? "scrollLeft" : "scrollTop";
      if (l) {
        let d = l[u];
        const c = () => {
          const p = l[u];
          d !== p && (i("SCROLL"), r()), d = p;
        };
        l.addEventListener("scroll", c);
      }
    }), (l, u) => (h(), b(a(se), {
      present: l.forceMount || a(s) !== "hidden"
    }, {
      default: v(() => [
        F(Xo, B(l.$attrs, {
          ref_key: "forwardRef",
          ref: n
        }), {
          default: v(() => [
            y(l.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), [Kt, Ar] = H("ScrollAreaScrollbar"), cc = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "ScrollAreaScrollbar",
  props: {
    orientation: { default: "vertical" },
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "div" }
  },
  setup(o) {
    const t = o, e = me(), n = P(() => t.orientation === "horizontal");
    X(
      n,
      () => {
        n.value ? e.onScrollbarXEnabledChange(!0) : e.onScrollbarYEnabledChange(!0);
      },
      { immediate: !0 }
    ), fe(() => {
      e.onScrollbarXEnabledChange(!1), e.onScrollbarYEnabledChange(!1);
    });
    const { orientation: s, forceMount: i, asChild: r, as: l } = z(t);
    return Ar({
      orientation: s,
      forceMount: i,
      isHorizontal: n,
      as: l,
      asChild: r
    }), (u, d) => a(e).type.value === "hover" ? (h(), b(Dr, B({ key: 0 }, u.$attrs, { "force-mount": a(i) }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["force-mount"])) : a(e).type.value === "scroll" ? (h(), b(Ir, B({ key: 1 }, u.$attrs, { "force-mount": a(i) }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["force-mount"])) : a(e).type.value === "auto" ? (h(), b(ta, B({ key: 2 }, u.$attrs, { "force-mount": a(i) }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["force-mount"])) : a(e).type.value === "always" ? (h(), b(Xo, B({ key: 3 }, u.$attrs, { "data-state": "visible" }), {
      default: v(() => [
        y(u.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), pc = /* @__PURE__ */ g({
  __name: "ScrollAreaThumb",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = me(), n = Lt();
    function s(f) {
      const C = f.target.getBoundingClientRect(), w = f.clientX - C.left, O = f.clientY - C.top;
      n.handleThumbDown(f, { x: w, y: O });
    }
    function i(f) {
      n.handleThumbUp(f);
    }
    const { primitiveElement: r, currentElement: l } = R(), u = x(), d = P(() => e.viewport.value);
    function c() {
      if (!u.value) {
        const f = Or(
          d.value,
          n.onThumbPositionChange
        );
        u.value = f, n.onThumbPositionChange();
      }
    }
    const p = P(() => n.sizes.value);
    return Qa(p, () => {
      n.onThumbChange(l.value), d.value && (n.onThumbPositionChange(), d.value.addEventListener("scroll", c));
    }), fe(() => {
      var f;
      d.value.removeEventListener("scroll", c), (f = e.viewport.value) == null || f.removeEventListener("scroll", c);
    }), (f, m) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: r,
      "data-state": a(n).hasThumb ? "visible" : "hidden",
      style: ae({
        width: "var(--radix-scroll-area-thumb-width)",
        height: "var(--radix-scroll-area-thumb-height)"
      }),
      "as-child": t.asChild,
      as: f.as,
      onPointerdown: s,
      onPointerup: i
    }, {
      default: v(() => [
        y(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-state", "style", "as-child", "as"]));
  }
}), Fr = /* @__PURE__ */ g({
  __name: "ScrollAreaCornerImpl",
  setup(o) {
    const t = me(), e = x(0), n = x(0), s = P(() => !!e.value && !!n.value);
    function i() {
      var u;
      const l = ((u = t.scrollbarX.value) == null ? void 0 : u.offsetHeight) || 0;
      t.onCornerHeightChange(l), n.value = l;
    }
    function r() {
      var u;
      const l = ((u = t.scrollbarY.value) == null ? void 0 : u.offsetWidth) || 0;
      t.onCornerWidthChange(l), e.value = l;
    }
    return _e(t.scrollbarX.value, i), _e(t.scrollbarY.value, r), X(() => t.scrollbarX.value, i), X(() => t.scrollbarY.value, r), (l, u) => {
      var d;
      return s.value ? (h(), b(a(T), B({
        key: 0,
        style: {
          width: `${e.value}px`,
          height: `${n.value}px`,
          position: "absolute",
          right: a(t).dir.value === "ltr" ? 0 : void 0,
          left: a(t).dir.value === "rtl" ? 0 : void 0,
          bottom: 0
        }
      }, (d = l.$parent) == null ? void 0 : d.$props), {
        default: v(() => [
          y(l.$slots, "default")
        ]),
        _: 3
      }, 16, ["style"])) : q("", !0);
    };
  }
}), fc = /* @__PURE__ */ g({
  __name: "ScrollAreaCorner",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = me(), n = P(
      () => !!e.scrollbarX.value && !!e.scrollbarY.value
    ), s = P(
      () => e.type.value !== "scroll" && n.value
    );
    return (i, r) => s.value ? (h(), b(Fr, k(B({ key: 0 }, t)), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), Mr = ["default-value"], kr = /* @__PURE__ */ g({
  __name: "BubbleSelect",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    form: {},
    multiple: { type: Boolean },
    name: {},
    required: { type: Boolean },
    size: {},
    value: {}
  },
  setup(o) {
    const t = o, { value: e } = z(t);
    is(e);
    const n = x();
    return (s, i) => (h(), b(a(Xe), { "as-child": "" }, {
      default: v(() => [
        fo(lt("select", B({
          ref_key: "selectElement",
          ref: n
        }, t, {
          "onUpdate:modelValue": i[0] || (i[0] = (r) => ut(e) ? e.value = r : null),
          "default-value": a(e)
        }), [
          y(s.$slots, "default")
        ], 16, Mr), [
          [Ma, a(e)]
        ])
      ]),
      _: 3
    }));
  }
}), Rr = {
  key: 0,
  value: ""
}, [Te, oa] = H("SelectRoot"), [Vr, jr] = H("SelectRoot"), vc = /* @__PURE__ */ g({
  __name: "SelectRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    defaultValue: { default: "" },
    modelValue: { default: void 0 },
    orientation: { default: "vertical" },
    dir: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean },
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = J(e, "modelValue", n, {
      defaultValue: e.defaultValue,
      passive: e.modelValue === void 0
    }), i = J(e, "open", n, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    }), r = x(), l = x(), u = x({
      x: 0,
      y: 0
    }), d = x(!1), { required: c, disabled: p, dir: f } = z(e), m = de(f);
    oa({
      triggerElement: r,
      onTriggerChange: (_) => {
        r.value = _;
      },
      valueElement: l,
      onValueElementChange: (_) => {
        l.value = _;
      },
      valueElementHasChildren: d,
      onValueElementHasChildrenChange: (_) => {
        d.value = _;
      },
      contentId: oe(),
      modelValue: s,
      onValueChange: (_) => {
        s.value = _;
      },
      open: i,
      required: c,
      onOpenChange: (_) => {
        i.value = _;
      },
      dir: m,
      triggerPointerDownPosRef: u,
      disabled: p
    });
    const C = Le(r), w = x(/* @__PURE__ */ new Set()), O = P(() => Array.from(w.value).map((_) => {
      var S;
      return (S = _.props) == null ? void 0 : S.value;
    }).join(";"));
    return jr({
      onNativeOptionAdd: (_) => {
        w.value.add(_);
      },
      onNativeOptionRemove: (_) => {
        w.value.delete(_);
      }
    }), (_, S) => (h(), b(a(Ke), null, {
      default: v(() => [
        y(_.$slots, "default"),
        a(C) ? (h(), b(kr, B({ key: O.value }, _.$attrs, {
          "aria-hidden": "",
          tabindex: "-1",
          required: a(c),
          name: _.name,
          autocomplete: _.autocomplete,
          disabled: a(p),
          value: a(s),
          onChange: S[0] || (S[0] = (E) => s.value = E.target.value)
        }), {
          default: v(() => [
            a(s) === void 0 ? (h(), Q("option", Rr)) : q("", !0),
            (h(!0), Q(re, null, po(Array.from(w.value), (E) => (h(), b(xe(E), B(E.props, {
              key: E.key ?? ""
            }), null, 16))), 128))
          ]),
          _: 1
        }, 16, ["required", "name", "autocomplete", "disabled", "value"])) : q("", !0)
      ]),
      _: 3
    }));
  }
}), Lr = [" ", "Enter", "ArrowUp", "ArrowDown"], Kr = [" ", "Enter"], Ce = 10;
function na(o) {
  return o === "" || o === void 0;
}
const mc = /* @__PURE__ */ g({
  __name: "SelectTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Te(), n = P(() => {
      var f;
      return ((f = e.disabled) == null ? void 0 : f.value) || t.disabled;
    }), { primitiveElement: s, currentElement: i } = R();
    U(() => {
      e.triggerElement = i;
    });
    const { injectCollection: r } = le(), l = r(), { search: u, handleTypeaheadSearch: d, resetTypeahead: c } = _o(l);
    function p() {
      n.value || (e.onOpenChange(!0), c());
    }
    return (f, m) => (h(), b(a(Ne), { "as-child": "" }, {
      default: v(() => {
        var C, w, O, _;
        return [
          F(a(T), {
            ref_key: "primitiveElement",
            ref: s,
            role: "combobox",
            type: f.as === "button" ? "button" : void 0,
            "aria-controls": a(e).contentId,
            "aria-expanded": a(e).open.value || !1,
            "aria-required": (C = a(e).required) == null ? void 0 : C.value,
            "aria-autocomplete": "none",
            disabled: f.disabled,
            dir: (w = a(e)) == null ? void 0 : w.dir.value,
            "data-state": (O = a(e)) != null && O.open.value ? "open" : "closed",
            "data-disabled": n.value ? "" : void 0,
            "data-placeholder": a(na)((_ = a(e).modelValue) == null ? void 0 : _.value) ? "" : void 0,
            "as-child": f.asChild,
            as: f.as,
            onClick: m[0] || (m[0] = (S) => {
              var E;
              (E = S == null ? void 0 : S.currentTarget) == null || E.focus();
            }),
            onPointerdown: m[1] || (m[1] = (S) => {
              const E = S.target;
              E.hasPointerCapture(S.pointerId) && E.releasePointerCapture(S.pointerId), S.button === 0 && S.ctrlKey === !1 && (p(), a(e).triggerPointerDownPosRef.value = {
                x: Math.round(S.pageX),
                y: Math.round(S.pageY)
              }, S.preventDefault());
            }),
            onPointerup: m[2] || (m[2] = te(() => {
            }, ["prevent"])),
            onKeydown: m[3] || (m[3] = (S) => {
              const E = a(u) !== "";
              !(S.ctrlKey || S.altKey || S.metaKey) && S.key.length === 1 && E && S.key === " " || (a(d)(S.key), a(Lr).includes(S.key) && (p(), S.preventDefault()));
            })
          }, {
            default: v(() => [
              y(f.$slots, "default")
            ]),
            _: 3
          }, 8, ["type", "aria-controls", "aria-expanded", "aria-required", "disabled", "dir", "data-state", "data-disabled", "data-placeholder", "as-child", "as"])
        ];
      }),
      _: 3
    }));
  }
}), hc = /* @__PURE__ */ g({
  __name: "SelectPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [Jo, Nr] = H("SelectItemAlignedPosition"), Hr = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "SelectItemAlignedPosition",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["placed"],
  setup(o, { emit: t }) {
    const e = o, n = t, { injectCollection: s } = le(), i = Te(), r = De(), l = s(), u = x(!1), d = x(!0), c = x(), { primitiveElement: p, currentElement: f } = R(), { viewport: m, selectedItem: C, selectedItemText: w, focusSelectedItem: O } = r;
    function _() {
      if (i.triggerElement.value && i.valueElement.value && c.value && f.value && (m != null && m.value) && (C != null && C.value) && (w != null && w.value)) {
        const $ = i.triggerElement.value.getBoundingClientRect(), I = f.value.getBoundingClientRect(), A = i.valueElement.value.getBoundingClientRect(), V = w.value.getBoundingClientRect();
        if (i.dir.value !== "rtl") {
          const Ie = V.left - I.left, Se = A.left - Ie, Ae = $.left - Se, Fe = $.width + Ae, Gt = Math.max(Fe, I.width), Yt = window.innerWidth - Ce, Xt = tn(Se, Ce, Yt - Gt);
          c.value.style.minWidth = `${Fe}px`, c.value.style.left = `${Xt}px`;
        } else {
          const Ie = I.right - V.right, Se = window.innerWidth - A.right - Ie, Ae = window.innerWidth - $.right - Se, Fe = $.width + Ae, Gt = Math.max(Fe, I.width), Yt = window.innerWidth - Ce, Xt = tn(
            Se,
            Ce,
            Yt - Gt
          );
          c.value.style.minWidth = `${Fe}px`, c.value.style.right = `${Xt}px`;
        }
        const M = l.value, N = window.innerHeight - Ce * 2, D = m.value.scrollHeight, L = window.getComputedStyle(f.value), W = Number.parseInt(
          L.borderTopWidth,
          10
        ), Z = Number.parseInt(L.paddingTop, 10), j = Number.parseInt(
          L.borderBottomWidth,
          10
        ), G = Number.parseInt(
          L.paddingBottom,
          10
        ), ne = W + Z + D + G + j, tt = Math.min(
          C.value.offsetHeight * 5,
          ne
        ), ot = window.getComputedStyle(m.value), ht = Number.parseInt(ot.paddingTop, 10), Sa = Number.parseInt(
          ot.paddingBottom,
          10
        ), yt = $.top + $.height / 2 - Ce, Ea = N - yt, qt = C.value.offsetHeight / 2, xa = C.value.offsetTop + qt, gt = W + Z + xa, Oa = ne - gt;
        if (gt <= yt) {
          const Ie = C.value === M[M.length - 1];
          c.value.style.bottom = "0px";
          const Se = f.value.clientHeight - m.value.offsetTop - m.value.offsetHeight, Ae = Math.max(
            Ea,
            qt + (Ie ? Sa : 0) + Se + j
          ), Fe = gt + Ae;
          c.value.style.height = `${Fe}px`;
        } else {
          const Ie = C.value === M[0];
          c.value.style.top = "0px";
          const Ae = Math.max(
            yt,
            W + m.value.offsetTop + (Ie ? ht : 0) + qt
          ) + Oa;
          c.value.style.height = `${Ae}px`, m.value.scrollTop = gt - yt + m.value.offsetTop;
        }
        c.value.style.margin = `${Ce}px 0`, c.value.style.minHeight = `${tt}px`, c.value.style.maxHeight = `${N}px`, n("placed"), requestAnimationFrame(() => u.value = !0);
      }
    }
    const S = x("");
    U(async () => {
      await Y(), _(), f.value && (S.value = window.getComputedStyle(f.value).zIndex);
    });
    function E($) {
      $ && d.value === !0 && (_(), O == null || O(), d.value = !1);
    }
    return Nr({
      contentWrapper: c,
      shouldExpandOnScrollRef: u,
      onScrollButtonChange: E
    }), ($, I) => (h(), Q("div", {
      ref_key: "contentWrapperElement",
      ref: c,
      style: ae({
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        zIndex: S.value
      })
    }, [
      F(a(T), B({
        ref_key: "primitiveElement",
        ref: p,
        style: {
          // When we get the height of the content, it includes borders. If we were to set
          // the height without having `boxSizing: 'border-box'` it would be too big.
          boxSizing: "border-box",
          // We need to ensure the content doesn't get taller than the wrapper
          maxHeight: "100%"
        }
      }, { ...$.$attrs, ...e }), {
        default: v(() => [
          y($.$slots, "default")
        ]),
        _: 3
      }, 16, ["style"])
    ], 4));
  }
}), Wr = /* @__PURE__ */ g({
  __name: "SelectPopperPosition",
  props: {
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: { default: Ce },
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const e = It(o);
    return (n, s) => (h(), b(a(Ge), B(a(e), { style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    } }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["style"]));
  }
}), et = {
  onViewportChange: () => {
  },
  itemTextRefCallback: () => {
  },
  itemRefCallback: () => {
  }
}, [De, zr] = H("SelectContent"), Ur = /* @__PURE__ */ g({
  __name: "SelectContentImpl",
  props: {
    position: {},
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: { type: Function },
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = Te();
    Co(), pt(!0);
    const { createCollection: i } = le(), r = x();
    ft(r);
    const l = i(r), { search: u, handleTypeaheadSearch: d } = _o(l), c = x(), p = x(), f = x(), m = x(!1), C = x(!1);
    function w() {
      p.value && r.value && ao([p.value, r.value]);
    }
    X(m, () => {
      w();
    });
    const { onOpenChange: O, triggerPointerDownPosRef: _ } = s;
    ee(($) => {
      if (!r.value)
        return;
      let I = { x: 0, y: 0 };
      const A = (M) => {
        var N, D;
        I = {
          x: Math.abs(
            Math.round(M.pageX) - (((N = _.value) == null ? void 0 : N.x) ?? 0)
          ),
          y: Math.abs(
            Math.round(M.pageY) - (((D = _.value) == null ? void 0 : D.y) ?? 0)
          )
        };
      }, V = (M) => {
        var N;
        I.x <= 10 && I.y <= 10 ? M.preventDefault() : (N = r.value) != null && N.contains(M.target) || O(!1), document.removeEventListener("pointermove", A), _.value = null;
      };
      _.value !== null && (document.addEventListener("pointermove", A), document.addEventListener("pointerup", V, {
        capture: !0,
        once: !0
      })), $(() => {
        document.removeEventListener("pointermove", A), document.removeEventListener("pointerup", V, {
          capture: !0
        });
      });
    });
    function S($) {
      const I = $.ctrlKey || $.altKey || $.metaKey;
      if ($.key === "Tab" && $.preventDefault(), !I && $.key.length === 1 && d($.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes($.key)) {
        let A = l.value;
        if (["ArrowUp", "End"].includes($.key) && (A = A.slice().reverse()), ["ArrowUp", "ArrowDown"].includes($.key)) {
          const V = $.target, M = A.indexOf(V);
          A = A.slice(M + 1);
        }
        setTimeout(() => ao(A)), $.preventDefault();
      }
    }
    const E = P(() => e.position === "popper" ? e : {});
    return zr({
      content: r,
      viewport: c,
      onViewportChange: ($) => {
        c.value = $;
      },
      itemRefCallback: ($, I, A) => {
        var N, D;
        const V = !C.value && !A;
        (((N = s.modelValue) == null ? void 0 : N.value) !== void 0 && ((D = s.modelValue) == null ? void 0 : D.value) === I || V) && (p.value = $, V && (C.value = !0));
      },
      selectedItem: p,
      selectedItemText: f,
      onItemLeave: () => {
        var $;
        ($ = r.value) == null || $.focus();
      },
      itemTextRefCallback: ($, I, A) => {
        var N, D;
        const V = !C.value && !A;
        (((N = s.modelValue) == null ? void 0 : N.value) !== void 0 && ((D = s.modelValue) == null ? void 0 : D.value) === I || V) && (f.value = $);
      },
      focusSelectedItem: w,
      position: e.position,
      isPositioned: m,
      searchRef: u
    }), ($, I) => (h(), b(a(Ft), {
      "as-child": "",
      onMountAutoFocus: I[6] || (I[6] = te(() => {
      }, ["prevent"])),
      onUnmountAutoFocus: I[7] || (I[7] = (A) => {
        var V;
        n("closeAutoFocus", A), !A.defaultPrevented && ((V = a(s).triggerElement.value) == null || V.focus({ preventScroll: !0 }), A.preventDefault());
      })
    }, {
      default: v(() => [
        F(a(Pe), {
          "as-child": "",
          "disable-outside-pointer-events": "",
          onFocusOutside: I[2] || (I[2] = te(() => {
          }, ["prevent"])),
          onDismiss: I[3] || (I[3] = (A) => a(s).onOpenChange(!1)),
          onEscapeKeyDown: I[4] || (I[4] = (A) => n("escapeKeyDown", A)),
          onPointerDownOutside: I[5] || (I[5] = (A) => n("pointerDownOutside", A))
        }, {
          default: v(() => [
            (h(), b(xe(
              $.position === "popper" ? Wr : Hr
            ), B({ ...$.$attrs, ...E.value }, {
              id: a(s).contentId,
              ref: (A) => {
                r.value = a(ve)(A);
              },
              role: "listbox",
              "data-state": a(s).open.value ? "open" : "closed",
              dir: a(s).dir.value,
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none"
              },
              onContextmenu: I[0] || (I[0] = te(() => {
              }, ["prevent"])),
              onPlaced: I[1] || (I[1] = (A) => m.value = !0),
              onKeydown: S
            }), {
              default: v(() => [
                y($.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "dir", "onKeydown"]))
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), qr = /* @__PURE__ */ g({
  __name: "SelectProvider",
  props: {
    context: {}
  },
  setup(o) {
    return oa(o.context), (e, n) => y(e.$slots, "default");
  }
}), yc = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "SelectContent",
  props: {
    forceMount: { type: Boolean },
    position: { default: "item-aligned" },
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    onPlaced: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(o, { emit: t }) {
    const s = pe(o, t), i = Te(), r = x();
    U(() => {
      r.value = new DocumentFragment();
    });
    const l = x();
    return (u, d) => {
      var c;
      return h(), Q(re, null, [
        F(a(se), {
          ref_key: "presenceRef",
          ref: l,
          present: u.forceMount || a(i).open.value
        }, {
          default: v(() => [
            F(Ur, k(K({ ...a(s), ...u.$attrs })), {
              default: v(() => [
                y(u.$slots, "default")
              ]),
              _: 3
            }, 16)
          ]),
          _: 3
        }, 8, ["present"]),
        !((c = l.value) != null && c.present) && r.value ? (h(), b(Ue, {
          key: 0,
          to: r.value
        }, [
          F(qr, { context: a(i) }, {
            default: v(() => [
              lt("div", null, [
                y(u.$slots, "default")
              ])
            ]),
            _: 3
          }, 8, ["context"])
        ], 8, ["to"])) : q("", !0)
      ], 64);
    };
  }
}), gc = /* @__PURE__ */ g({
  __name: "SelectArrow",
  props: {
    width: {},
    height: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = Te(), n = De();
    return (s, i) => a(e).open.value && a(n).position === "popper" ? (h(), b(a(Ye), k(B({ key: 0 }, t)), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), bc = /* @__PURE__ */ g({
  __name: "SelectSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), B({ "aria-hidden": "" }, t), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [aa, Gr] = H("SelectItem"), Cc = /* @__PURE__ */ g({
  __name: "SelectItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, { disabled: e } = z(t), n = Te(), s = De(et), { primitiveElement: i, currentElement: r } = R(), l = P(() => {
      var w;
      return ((w = n.modelValue) == null ? void 0 : w.value) === t.value;
    }), u = x(!1), d = x(t.textValue ?? ""), c = oe();
    async function p(w) {
      await Y(), !(w != null && w.defaultPrevented) && (e.value || (n.onValueChange(t.value), n.onOpenChange(!1)));
    }
    async function f(w) {
      var O;
      await Y(), !w.defaultPrevented && (e.value ? (O = s.onItemLeave) == null || O.call(s) : w.currentTarget.focus({ preventScroll: !0 }));
    }
    async function m(w) {
      var O;
      await Y(), !w.defaultPrevented && w.currentTarget === document.activeElement && ((O = s.onItemLeave) == null || O.call(s));
    }
    async function C(w) {
      var _;
      await Y(), !(w.defaultPrevented || ((_ = s.searchRef) == null ? void 0 : _.value) !== "" && w.key === " ") && (Kr.includes(w.key) && p(), w.key === " " && w.preventDefault());
    }
    if (t.value === "")
      throw new Error(
        "A <SelectItem /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return U(() => {
      r.value && s.itemRefCallback(
        r.value,
        t.value,
        t.disabled
      );
    }), Gr({
      value: t.value,
      disabled: e,
      textId: c,
      isSelected: l,
      onItemTextChange: (w) => {
        d.value = ((d.value || (w == null ? void 0 : w.textContent)) ?? "").trim();
      }
    }), (w, O) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: i,
      role: "option",
      "data-radix-vue-collection-item": "",
      "aria-labelledby": a(c),
      "data-highlighted": u.value ? "" : void 0,
      "aria-selected": l.value && u.value,
      "data-state": l.value ? "checked" : "unchecked",
      "aria-disabled": a(e) || void 0,
      "data-disabled": a(e) ? "" : void 0,
      tabindex: a(e) ? void 0 : -1,
      as: w.as,
      "as-child": w.asChild,
      onFocus: O[0] || (O[0] = (_) => u.value = !0),
      onBlur: O[1] || (O[1] = (_) => u.value = !1),
      onPointerup: p,
      onTouchend: O[2] || (O[2] = te(() => {
      }, ["prevent", "stop"])),
      onPointermove: f,
      onPointerleave: m,
      onKeydown: C
    }, {
      default: v(() => [
        y(w.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "tabindex", "as", "as-child"]));
  }
}), _c = /* @__PURE__ */ g({
  __name: "SelectItemIndicator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = aa();
    return (n, s) => a(e).isSelected.value ? (h(), b(a(T), B({
      key: 0,
      "aria-hidden": ""
    }, t), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), [Yr, Xr] = H("SelectGroup"), wc = /* @__PURE__ */ g({
  __name: "SelectGroup",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = oe();
    return Xr({ id: e }), (n, s) => (h(), b(a(T), B({ role: "group" }, t, { "aria-labelledby": a(e) }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"]));
  }
}), Sc = /* @__PURE__ */ g({
  __name: "SelectLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "div" }
  },
  setup(o) {
    const t = o, e = Yr({ id: "" });
    return (n, s) => (h(), b(a(T), B(t, {
      id: a(e).id
    }), {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), Ec = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "SelectItemText",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = Te(), n = De(et), s = Vr(), i = aa(), { primitiveElement: r, currentElement: l } = R(), u = P(() => {
      var d;
      return ke("option", {
        key: i.value,
        value: i.value,
        disabled: i.disabled.value,
        innerHTML: (d = l.value) == null ? void 0 : d.textContent
      });
    });
    return U(() => {
      l.value && (i.onItemTextChange(l.value), n.itemTextRefCallback(
        l.value,
        i.value,
        i.disabled.value
      ), s.onNativeOptionAdd(u.value));
    }), co(() => {
      s.onNativeOptionRemove(u.value);
    }), (d, c) => (h(), Q(re, null, [
      F(a(T), B({
        id: a(i).textId,
        ref_key: "primitiveElement",
        ref: r
      }, { ...t, ...d.$attrs }), {
        default: v(() => [
          y(d.$slots, "default")
        ]),
        _: 3
      }, 16, ["id"]),
      a(i).isSelected.value && a(e).valueElement.value && !a(e).valueElementHasChildren.value ? (h(), b(Ue, {
        key: 0,
        to: a(e).valueElement.value
      }, [
        y(d.$slots, "default")
      ], 8, ["to"])) : q("", !0)
    ], 64));
  }
}), xc = /* @__PURE__ */ g({
  __name: "SelectViewport",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = De(et), n = e.position === "item-aligned" ? Jo() : void 0, { primitiveElement: s, currentElement: i } = R();
    U(() => {
      e == null || e.onViewportChange(i.value);
    });
    const r = x(0);
    function l(u) {
      const d = u.currentTarget, { shouldExpandOnScrollRef: c, contentWrapper: p } = n ?? {};
      if (c != null && c.value && (p != null && p.value)) {
        const f = Math.abs(r.value - d.scrollTop);
        if (f > 0) {
          const m = window.innerHeight - Ce * 2, C = Number.parseFloat(
            p.value.style.minHeight
          ), w = Number.parseFloat(p.value.style.height), O = Math.max(C, w);
          if (O < m) {
            const _ = O + f, S = Math.min(m, _), E = _ - S;
            p.value.style.height = `${S}px`, p.value.style.bottom === "0px" && (d.scrollTop = E > 0 ? E : 0, p.value.style.justifyContent = "flex-end");
          }
        }
      }
      r.value = d.scrollTop;
    }
    return (u, d) => (h(), Q(re, null, [
      F(a(T), { as: "style" }, {
        default: v(() => [
          ue(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-radix-select-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-radix-select-viewport]::-webkit-scrollbar { display: none; } ")
        ]),
        _: 1
      }),
      F(a(T), B({
        ref_key: "primitiveElement",
        ref: s,
        "data-radix-select-viewport": "",
        role: "presentation"
      }, { ...u.$attrs, ...t }, {
        style: {
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: 1,
          overflow: "auto"
        },
        onScroll: l
      }), {
        default: v(() => [
          y(u.$slots, "default")
        ]),
        _: 3
      }, 16, ["style"])
    ], 64));
  }
}), sa = /* @__PURE__ */ g({
  __name: "SelectScrollButtonImpl",
  emits: ["autoScroll"],
  setup(o, { emit: t }) {
    const e = t, { injectCollection: n } = le(), s = n(), i = De(et), r = x(null);
    function l() {
      r.value !== null && (window.clearInterval(r.value), r.value = null);
    }
    ee(() => {
      const c = s.value.find(
        (p) => p === document.activeElement
      );
      c == null || c.scrollIntoView({ block: "nearest" });
    });
    function u() {
      r.value === null && (r.value = window.setInterval(() => {
        e("autoScroll");
      }, 50));
    }
    function d() {
      var c;
      (c = i.onItemLeave) == null || c.call(i), r.value === null && (r.value = window.setInterval(() => {
        e("autoScroll");
      }, 50));
    }
    return co(() => l()), (c, p) => {
      var f;
      return h(), b(a(T), B({
        "aria-hidden": "",
        style: {
          flexShrink: 0
        }
      }, (f = c.$parent) == null ? void 0 : f.$props, {
        onPointerdown: u,
        onPointermove: d,
        onPointerleave: p[0] || (p[0] = () => {
          l();
        })
      }), {
        default: v(() => [
          y(c.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
}), Oc = /* @__PURE__ */ g({
  __name: "SelectScrollUpButton",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = De(et), e = t.position === "item-aligned" ? Jo() : void 0, { primitiveElement: n, currentElement: s } = R(), i = x(!1);
    return ee((r) => {
      var l, u;
      if ((l = t.viewport) != null && l.value && ((u = t.isPositioned) != null && u.value)) {
        let d = function() {
          i.value = c.scrollTop > 0;
        };
        const c = t.viewport.value;
        d(), c.addEventListener("scroll", d), r(() => c.removeEventListener("scroll", d));
      }
    }), X(s, () => {
      s.value && (e == null || e.onScrollButtonChange(s.value));
    }), (r, l) => i.value ? (h(), b(sa, {
      key: 0,
      ref_key: "primitiveElement",
      ref: n,
      onAutoScroll: l[0] || (l[0] = () => {
        const { viewport: u, selectedItem: d } = a(t);
        u != null && u.value && (d != null && d.value) && (u.value.scrollTop = u.value.scrollTop - d.value.offsetHeight);
      })
    }, {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 512)) : q("", !0);
  }
}), $c = /* @__PURE__ */ g({
  __name: "SelectScrollDownButton",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = De(et), e = t.position === "item-aligned" ? Jo() : void 0, { primitiveElement: n, currentElement: s } = R(), i = x(!1);
    return ee((r) => {
      var l, u;
      if ((l = t.viewport) != null && l.value && ((u = t.isPositioned) != null && u.value)) {
        let d = function() {
          const p = c.scrollHeight - c.clientHeight;
          i.value = Math.ceil(c.scrollTop) < p;
        };
        const c = t.viewport.value;
        d(), c.addEventListener("scroll", d), r(() => c.removeEventListener("scroll", d));
      }
    }), X(s, () => {
      s.value && (e == null || e.onScrollButtonChange(s.value));
    }), (r, l) => i.value ? (h(), b(sa, {
      key: 0,
      ref_key: "primitiveElement",
      ref: n,
      onAutoScroll: l[0] || (l[0] = () => {
        const { viewport: u, selectedItem: d } = a(t);
        u != null && u.value && (d != null && d.value) && (u.value.scrollTop = u.value.scrollTop + d.value.offsetHeight);
      })
    }, {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 512)) : q("", !0);
  }
}), Pc = /* @__PURE__ */ g({
  __name: "SelectValue",
  props: {
    placeholder: { default: "" },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const { primitiveElement: t, currentElement: e } = R(), n = Te(), s = Cn();
    return bn(() => {
      var r;
      const i = !!Dt((r = s == null ? void 0 : s.default) == null ? void 0 : r.call(s)).length;
      n.onValueElementHasChildrenChange(i);
    }), U(() => {
      n.valueElement = e;
    }), (i, r) => (h(), b(a(T), {
      ref_key: "primitiveElement",
      ref: t,
      as: i.as,
      "as-child": i.asChild,
      style: { pointerEvents: "none" }
    }, {
      default: v(() => {
        var l;
        return [
          a(na)((l = a(n).modelValue) == null ? void 0 : l.value) ? (h(), Q(re, { key: 0 }, [
            ue(je(i.placeholder), 1)
          ], 64)) : y(i.$slots, "default", { key: 1 })
        ];
      }),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), Bc = /* @__PURE__ */ g({
  __name: "SelectIcon",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    return (t, e) => (h(), b(a(T), {
      "aria-hidden": "",
      as: t.as,
      "as-child": t.asChild
    }, {
      default: v(() => [
        y(t.$slots, "default", {}, () => [
          ue("▼")
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), ia = /* @__PURE__ */ g({
  __name: "BaseSeparator",
  props: {
    orientation: { default: "horizontal" },
    decorative: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o, e = ["horizontal", "vertical"];
    function n(l) {
      return e.includes(l);
    }
    const s = P(
      () => n(t.orientation) ? t.orientation : "horizontal"
    ), i = P(
      () => s.value === "vertical" ? t.orientation : void 0
    ), r = P(
      () => t.decorative ? { role: "none" } : { "aria-orientation": i.value, role: "separator" }
    );
    return (l, u) => (h(), b(a(T), B({
      as: l.as,
      "as-child": l.asChild,
      "data-orientation": s.value
    }, r.value), {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "as-child", "data-orientation"]));
  }
}), Tc = /* @__PURE__ */ g({
  __name: "Separator",
  props: {
    orientation: { default: "horizontal" },
    decorative: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(ia, k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function ra(o, [t, e]) {
  return Math.min(e, Math.max(t, o));
}
function Jr(o = [], t, e) {
  const n = [...o];
  return n[e] = t, n.sort((s, i) => s - i);
}
function la(o, t, e) {
  const i = 100 / (e - t) * (o - t);
  return ra(i, [0, 100]);
}
function Zr(o, t) {
  return t > 2 ? `Value ${o + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][o] : void 0;
}
function Qr(o, t) {
  if (o.length === 1)
    return 0;
  const e = o.map((s) => Math.abs(s - t)), n = Math.min(...e);
  return e.indexOf(n);
}
function el(o, t, e) {
  const n = o / 2, i = Zo([0, 50], [0, n]);
  return (n - i(t) * e) * e;
}
function tl(o) {
  return o.slice(0, -1).map((t, e) => o[e + 1] - t);
}
function ol(o, t) {
  if (t > 0) {
    const e = tl(o);
    return Math.min(...e) >= t;
  }
  return !0;
}
function Zo(o, t) {
  return (e) => {
    if (o[0] === o[1] || t[0] === t[1])
      return t[0];
    const n = (t[1] - t[0]) / (o[1] - o[0]);
    return t[0] + n * (e - o[0]);
  };
}
function nl(o) {
  return (String(o).split(".")[1] || "").length;
}
function al(o, t) {
  const e = 10 ** t;
  return Math.round(o * e) / e;
}
const ua = ["PageUp", "PageDown"], da = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], ca = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, [pa, fa] = H(["SliderVertical", "SliderHorizontal"]), va = /* @__PURE__ */ g({
  __name: "SliderImpl",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  emits: ["slideStart", "slideMove", "slideEnd", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = Nt();
    return (i, r) => (h(), b(a(T), B({ "data-slider-impl": "" }, e, {
      onKeydown: r[0] || (r[0] = (l) => {
        l.key === "Home" ? (n("homeKeyDown", l), l.preventDefault()) : l.key === "End" ? (n("endKeyDown", l), l.preventDefault()) : a(ua).concat(a(da)).includes(l.key) && (n("stepKeyDown", l), l.preventDefault());
      }),
      onPointerdown: r[1] || (r[1] = (l) => {
        const u = l.target;
        u.setPointerCapture(l.pointerId), l.preventDefault(), a(s).thumbElements.value.includes(u) ? u.focus() : n("slideStart", l);
      }),
      onPointermove: r[2] || (r[2] = (l) => {
        l.target.hasPointerCapture(l.pointerId) && n("slideMove", l);
      }),
      onPointerup: r[3] || (r[3] = (l) => {
        const u = l.target;
        u.hasPointerCapture(l.pointerId) && (u.releasePointerCapture(l.pointerId), n("slideEnd", l));
      })
    }), {
      default: v(() => [
        y(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), sl = /* @__PURE__ */ g({
  __name: "SliderHorizontal",
  props: {
    dir: {},
    min: {},
    max: {},
    inverted: { type: Boolean }
  },
  emits: ["slideEnd", "slideStart", "slideMove", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(o, { emit: t }) {
    const e = o, n = t, { max: s, min: i, dir: r, inverted: l } = z(e), { primitiveElement: u, currentElement: d } = R(), c = x(), p = P(() => (r == null ? void 0 : r.value) === "ltr" && !l.value || (r == null ? void 0 : r.value) !== "ltr" && l.value);
    function f(m) {
      const C = c.value || d.value.getBoundingClientRect(), w = [0, C.width], O = p.value ? [i.value, s.value] : [s.value, i.value], _ = Zo(w, O);
      return c.value = C, _(m - C.left);
    }
    return fa({
      startEdge: p.value ? "left" : "right",
      endEdge: p.value ? "right" : "left",
      direction: p.value ? 1 : -1,
      size: "width"
    }), (m, C) => (h(), b(va, {
      ref_key: "primitiveElement",
      ref: u,
      dir: a(r),
      "data-orientation": "horizontal",
      style: ae({
        "--radix-slider-thumb-transform": "translateX(-50%)"
      }),
      onSlideStart: C[0] || (C[0] = (w) => {
        const O = f(w.clientX);
        n("slideStart", O);
      }),
      onSlideMove: C[1] || (C[1] = (w) => {
        const O = f(w.clientX);
        n("slideMove", O);
      }),
      onSlideEnd: C[2] || (C[2] = () => {
        c.value = void 0, n("slideEnd");
      }),
      onStepKeyDown: C[3] || (C[3] = (w) => {
        const O = p.value ? "from-left" : "from-right", _ = a(ca)[O].includes(w.key);
        n("stepKeyDown", w, _ ? -1 : 1);
      }),
      onEndKeyDown: C[4] || (C[4] = (w) => n("endKeyDown", w)),
      onHomeKeyDown: C[5] || (C[5] = (w) => n("homeKeyDown", w))
    }, {
      default: v(() => [
        y(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["dir", "style"]));
  }
}), il = /* @__PURE__ */ g({
  __name: "SliderVertical",
  props: {
    min: {},
    max: {},
    inverted: { type: Boolean }
  },
  emits: ["slideEnd", "slideStart", "slideMove", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(o, { emit: t }) {
    const e = o, n = t, { max: s, min: i, inverted: r } = z(e), { primitiveElement: l, currentElement: u } = R(), d = x(), c = P(() => !r.value);
    function p(f) {
      const m = d.value || u.value.getBoundingClientRect(), C = [0, m.height], w = c.value ? [s.value, i.value] : [i.value, s.value], O = Zo(C, w);
      return d.value = m, O(f - m.top);
    }
    return fa({
      startEdge: c.value ? "bottom" : "top",
      endEdge: c.value ? "top" : "bottom",
      size: "height",
      direction: c.value ? 1 : -1
    }), (f, m) => (h(), b(va, {
      ref_key: "primitiveElement",
      ref: l,
      "data-orientation": "vertical",
      style: ae({
        "--radix-slider-thumb-transform": "translateY(50%)"
      }),
      onSlideStart: m[0] || (m[0] = (C) => {
        const w = p(C.clientY);
        n("slideStart", w);
      }),
      onSlideMove: m[1] || (m[1] = (C) => {
        const w = p(C.clientY);
        n("slideMove", w);
      }),
      onSlideEnd: m[2] || (m[2] = () => {
        d.value = void 0, n("slideEnd");
      }),
      onStepKeyDown: m[3] || (m[3] = (C) => {
        const w = c.value ? "from-bottom" : "from-top", O = a(ca)[w].includes(C.key);
        n("stepKeyDown", C, O ? -1 : 1);
      }),
      onEndKeyDown: m[4] || (m[4] = (C) => n("endKeyDown", C)),
      onHomeKeyDown: m[5] || (m[5] = (C) => n("homeKeyDown", C))
    }, {
      default: v(() => [
        y(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), rl = ["value", "name", "disabled"], [Nt, ll] = H("SliderRoot"), Dc = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "SliderRoot",
  props: {
    name: {},
    defaultValue: { default: () => [0] },
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    orientation: { default: "horizontal" },
    dir: {},
    inverted: { type: Boolean, default: !1 },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minStepsBetweenThumbs: { default: 0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "valueCommit"],
  setup(o, { emit: t }) {
    const e = o, n = t, { min: s, max: i, step: r, minStepsBetweenThumbs: l, orientation: u, disabled: d, dir: c } = z(e), p = de(c), { createCollection: f } = le("sliderThumb"), { primitiveElement: m, currentElement: C } = R();
    f(C);
    const w = Le(C), O = J(e, "modelValue", n, {
      defaultValue: e.defaultValue,
      passive: e.modelValue === void 0
    }), _ = x(0), S = x(O.value);
    function E(M) {
      const N = Qr(O.value, M);
      A(M, N);
    }
    function $(M) {
      A(M, _.value);
    }
    function I() {
      const M = S.value[_.value];
      O.value[_.value] !== M && n("valueCommit", O.value);
    }
    function A(M, N, { commit: D } = { commit: !1 }) {
      var G;
      const L = nl(r.value), W = al(Math.round((M - s.value) / r.value) * r.value + s.value, L), Z = ra(W, [s.value, i.value]), j = Jr(O.value, Z, N);
      if (ol(j, l.value * r.value)) {
        _.value = j.indexOf(Z);
        const ne = String(j) !== String(O.value);
        ne && D && n("valueCommit", j), ne && ((G = V.value[_.value]) == null || G.focus(), O.value = j);
      }
    }
    const V = x([]);
    return ll({
      modelValue: O,
      valueIndexToChangeRef: _,
      thumbElements: V,
      orientation: u,
      min: s,
      max: i,
      disabled: d
    }), (M, N) => (h(), Q(re, null, [
      (h(), b(xe(a(u) === "horizontal" ? sl : il), B(M.$attrs, {
        ref_key: "primitiveElement",
        ref: m,
        "as-child": M.asChild,
        as: M.as,
        min: a(s),
        max: a(i),
        dir: a(p),
        inverted: M.inverted,
        "aria-disabled": a(d),
        "data-disabled": a(d),
        onPointerdown: N[0] || (N[0] = () => {
          a(d) || (S.value = a(O));
        }),
        onSlideStart: N[1] || (N[1] = (D) => !a(d) && E(D)),
        onSlideMove: N[2] || (N[2] = (D) => !a(d) && $(D)),
        onSlideEnd: N[3] || (N[3] = (D) => !a(d) && I),
        onHomeKeyDown: N[4] || (N[4] = (D) => !a(d) && A(a(s), 0, { commit: !0 })),
        onEndKeyDown: N[5] || (N[5] = (D) => !a(d) && A(a(i), a(O).length - 1, { commit: !0 })),
        onStepKeyDown: N[6] || (N[6] = (D, L) => {
          if (!a(d)) {
            const j = a(ua).includes(D.key) || D.shiftKey && a(da).includes(D.key) ? 10 : 1, G = _.value, ne = a(O)[G], tt = a(r) * j * L;
            A(ne + tt, G, { commit: !0 });
          }
        })
      }), {
        default: v(() => [
          y(M.$slots, "default", { modelValue: a(O) })
        ]),
        _: 3
      }, 16, ["as-child", "as", "min", "max", "dir", "inverted", "aria-disabled", "data-disabled"])),
      a(w) ? (h(!0), Q(re, { key: 0 }, po(a(O), (D, L) => (h(), Q("input", {
        key: L,
        value: D,
        type: "number",
        style: { display: "none" },
        name: M.name ? M.name + (a(O).length > 1 ? "[]" : "") : void 0,
        disabled: a(d)
      }, null, 8, rl))), 128)) : q("", !0)
    ], 64));
  }
}), ul = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "SliderThumbImpl",
  props: {
    index: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o, { expose: t }) {
    const e = o, n = Nt(), s = pa(), { primitiveElement: i, currentElement: r } = R(), l = P(() => {
      var C, w;
      return (w = (C = n.modelValue) == null ? void 0 : C.value) == null ? void 0 : w[e.index];
    }), u = P(() => l.value === void 0 ? 0 : la(l.value, n.min.value ?? 0, n.max.value ?? 100)), d = P(() => {
      var C, w;
      return Zr(e.index, ((w = (C = n.modelValue) == null ? void 0 : C.value) == null ? void 0 : w.length) ?? 0);
    }), c = En(r), p = P(() => c[s.size].value), f = P(() => p.value ? el(p.value, u.value, s.direction) : 0), m = Tt();
    return U(() => {
      n.thumbElements.value.push(r.value);
    }), fe(() => {
      const C = n.thumbElements.value.findIndex((w) => w === r.value) ?? -1;
      n.thumbElements.value.splice(C, 1);
    }), t({
      $el: r
    }), (C, w) => (h(), b(a(T), B(C.$attrs, {
      ref_key: "primitiveElement",
      ref: i,
      role: "slider",
      "data-radix-vue-collection-item": "",
      tabindex: a(n).disabled.value ? void 0 : 0,
      "aria-label": C.$attrs["aria-label"] || d.value,
      "data-disabled": a(n).disabled.value,
      "data-orientation": a(n).orientation.value,
      "aria-valuenow": l.value,
      "aria-valuemin": a(n).min.value,
      "aria-valuemax": a(n).max.value,
      "aria-orientation": a(n).orientation.value,
      "as-child": C.asChild,
      as: C.as,
      style: {
        transform: "var(--radix-slider-thumb-transform)",
        position: "absolute",
        [a(s).startEdge]: `calc(${u.value}% + ${f.value}px)`,
        /**
         * There will be no value on initial render while we work out the index so we hide thumbs
         * without a value, otherwise SSR will render them in the wrong position before they
         * snap into the correct position during hydration which would be visually jarring for
         * slower connections.
         */
        display: !a(m) && l.value === void 0 ? "none" : void 0
      },
      onFocus: w[0] || (w[0] = () => {
        a(n).valueIndexToChangeRef.value = C.index;
      })
    }), {
      default: v(() => [
        y(C.$slots, "default")
      ]),
      _: 3
    }, 16, ["tabindex", "aria-label", "data-disabled", "data-orientation", "aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-orientation", "as-child", "as", "style"]));
  }
}), Ic = /* @__PURE__ */ g({
  __name: "SliderThumb",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, { injectCollection: e } = le("sliderThumb"), n = e(), { primitiveElement: s, currentElement: i } = R(), r = P(() => i.value ? n.value.findIndex((l) => l === i.value) : -1);
    return (l, u) => (h(), b(ul, B({
      ref_key: "primitiveElement",
      ref: s
    }, t, { index: r.value }), {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["index"]));
  }
}), Ac = /* @__PURE__ */ g({
  __name: "SliderTrack",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = Nt();
    return (n, s) => (h(), b(a(T), {
      "as-child": t.asChild,
      as: n.as,
      "data-disabled": a(e).disabled.value,
      "data-orientation": a(e).orientation.value
    }, {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "data-disabled", "data-orientation"]));
  }
}), Fc = /* @__PURE__ */ g({
  __name: "SliderRange",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = Nt(), e = pa(), n = P(() => {
      var r, l;
      return (l = (r = t.modelValue) == null ? void 0 : r.value) == null ? void 0 : l.map(
        (u) => la(u, t.min.value, t.max.value)
      );
    }), s = P(() => t.modelValue.value.length > 1 ? Math.min(...n.value) : 0), i = P(() => 100 - Math.max(...n.value));
    return (r, l) => (h(), b(a(T), {
      "data-disabled": a(t).disabled.value,
      "data-orientation": a(t).orientation.value,
      "as-child": r.asChild,
      as: r.as,
      style: ae({
        [a(e).startEdge]: `${s.value}%`,
        [a(e).endEdge]: `${i.value}%`
      })
    }, {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-disabled", "data-orientation", "as-child", "as", "style"]));
  }
}), dl = ["name", "disabled", "required", "value", "checked", "data-state", "data-disabled"], [cl, pl] = H("SwitchRoot"), Mc = /* @__PURE__ */ g({
  __name: "SwitchRoot",
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    id: {},
    value: { default: "on" },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  emits: ["update:checked"],
  setup(o, { emit: t }) {
    const e = o, n = t, { disabled: s } = z(e), i = J(e, "checked", n, {
      defaultValue: e.defaultChecked,
      passive: e.checked === void 0
    });
    function r() {
      s.value || (i.value = !i.value);
    }
    const { primitiveElement: l, currentElement: u } = R(), d = Le(u), c = P(() => {
      var p;
      return e.id && u.value ? (p = document.querySelector(`[for="${e.id}"]`)) == null ? void 0 : p.innerText : void 0;
    });
    return pl({
      checked: i,
      toggleCheck: r,
      disabled: s
    }), (p, f) => (h(), Q(re, null, [
      F(a(T), B(p.$attrs, {
        id: p.id,
        ref_key: "primitiveElement",
        ref: l,
        role: "switch",
        type: p.as === "button" ? "button" : void 0,
        value: p.value,
        "aria-label": p.$attrs["aria-label"] || c.value,
        "aria-checked": a(i),
        "aria-required": p.required,
        "data-state": a(i) ? "checked" : "unchecked",
        "data-disabled": a(s) ? "" : void 0,
        "as-child": p.asChild,
        as: p.as,
        disabled: a(s),
        onClick: r,
        onKeydown: ie(te(r, ["prevent"]), ["enter"])
      }), {
        default: v(() => [
          y(p.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "type", "value", "aria-label", "aria-checked", "aria-required", "data-state", "data-disabled", "as-child", "as", "disabled", "onKeydown"]),
      a(d) ? (h(), Q("input", {
        key: 0,
        type: "checkbox",
        name: p.name,
        tabindex: "-1",
        "aria-hidden": "",
        disabled: a(s),
        required: p.required,
        value: p.value,
        checked: !!a(i),
        "data-state": a(i) ? "checked" : "unchecked",
        "data-disabled": a(s) ? "" : void 0,
        style: ae({
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        })
      }, null, 12, dl)) : q("", !0)
    ], 64));
  }
}), kc = /* @__PURE__ */ g({
  __name: "SwitchThumb",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = cl();
    return (e, n) => {
      var s;
      return h(), b(a(T), {
        "data-state": (s = a(t).checked) != null && s.value ? "checked" : "unchecked",
        "data-disabled": a(t).disabled.value ? "" : void 0,
        "as-child": e.asChild,
        as: e.as
      }, {
        default: v(() => [
          y(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["data-state", "data-disabled", "as-child", "as"]);
    };
  }
}), [Ht, fl] = H("TabsRoot"), Rc = /* @__PURE__ */ g({
  __name: "TabsRoot",
  props: {
    defaultValue: {},
    orientation: { default: "horizontal" },
    dir: {},
    activationMode: { default: "automatic" },
    modelValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, n = t, { orientation: s, dir: i } = z(e), r = de(i), l = J(e, "modelValue", n, {
      defaultValue: e.defaultValue,
      passive: e.modelValue === void 0
    }), u = x();
    return fl({
      modelValue: l,
      changeModelValue: (d) => {
        l.value = d;
      },
      orientation: s,
      dir: r,
      activationMode: e.activationMode,
      baseId: oe(),
      tabsList: u
    }), (d, c) => (h(), b(a(T), {
      dir: a(r),
      "data-orientation": a(s),
      "as-child": d.asChild,
      as: d.as
    }, {
      default: v(() => [
        y(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["dir", "data-orientation", "as-child", "as"]));
  }
}), Vc = /* @__PURE__ */ g({
  __name: "TabsList",
  props: {
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o, { loop: e } = z(t), n = Ht();
    return (s, i) => (h(), b(a(Je), {
      "as-child": "",
      orientation: a(n).orientation.value,
      dir: a(n).dir.value,
      loop: a(e)
    }, {
      default: v(() => [
        F(a(T), {
          ref: (r) => {
            r && "$el" in r && (a(n).tabsList.value = r.$el);
          },
          role: "tablist",
          "as-child": s.asChild,
          as: s.as,
          "aria-orientation": a(n).orientation.value
        }, {
          default: v(() => [
            y(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["as-child", "as", "aria-orientation"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
});
function ma(o, t) {
  return `${o}-trigger-${t}`;
}
function ha(o, t) {
  return `${o}-content-${t}`;
}
const jc = /* @__PURE__ */ g({
  __name: "TabsContent",
  props: {
    value: {},
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = Ht(), n = P(() => ma(e.baseId, t.value)), s = P(() => ha(e.baseId, t.value)), i = P(() => t.value === e.modelValue.value), r = x(i.value);
    return U(() => {
      requestAnimationFrame(() => {
        r.value = !1;
      });
    }), (l, u) => (h(), b(a(se), {
      present: i.value,
      "force-mount": ""
    }, {
      default: v(({ present: d }) => [
        F(a(T), {
          id: s.value,
          "as-child": l.asChild,
          as: l.as,
          role: "tabpanel",
          "data-state": i.value ? "active" : "inactive",
          "data-orientation": a(e).orientation.value,
          "aria-labelledby": n.value,
          hidden: !d.value,
          tabindex: "0",
          style: ae({
            animationDuration: r.value ? "0s" : void 0
          })
        }, {
          default: v(() => [
            l.forceMount || i.value ? y(l.$slots, "default", { key: 0 }) : q("", !0)
          ]),
          _: 2
        }, 1032, ["id", "as-child", "as", "data-state", "data-orientation", "aria-labelledby", "hidden", "style"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Lc = /* @__PURE__ */ g({
  __name: "TabsTrigger",
  props: {
    value: {},
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Ht(), n = P(() => ma(e.baseId, t.value)), s = P(() => ha(e.baseId, t.value)), i = P(() => t.value === e.modelValue.value);
    return (r, l) => (h(), b(a(Ze), {
      "as-child": "",
      focusable: !r.disabled,
      active: i.value
    }, {
      default: v(() => [
        F(a(T), {
          id: n.value,
          role: "tab",
          type: r.as === "button" ? "button" : void 0,
          as: r.as,
          "as-child": r.asChild,
          "aria-selected": i.value ? "true" : "false",
          "aria-controls": s.value,
          "data-state": i.value ? "active" : "inactive",
          disabled: r.disabled,
          "data-disabled": r.disabled ? "" : void 0,
          "data-orientation": a(e).orientation.value,
          onMousedown: l[0] || (l[0] = te((u) => {
            !r.disabled && u.ctrlKey === !1 ? a(e).changeModelValue(r.value) : u.preventDefault();
          }, ["left"])),
          onKeydown: l[1] || (l[1] = ie((u) => a(e).changeModelValue(r.value), ["enter", "space"])),
          onFocus: l[2] || (l[2] = () => {
            const u = a(e).activationMode !== "manual";
            !i.value && !r.disabled && u && a(e).changeModelValue(r.value);
          })
        }, {
          default: v(() => [
            y(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as", "as-child", "aria-selected", "aria-controls", "data-state", "disabled", "data-disabled", "data-orientation"])
      ]),
      _: 3
    }, 8, ["focusable", "active"]));
  }
}), Kc = /* @__PURE__ */ g({
  __name: "TabsIndicator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = Ht(), n = x({
      size: null,
      position: null
    });
    return X(() => e.modelValue.value, async (s) => {
      var r;
      await Y();
      const i = (r = e.tabsList.value) == null ? void 0 : r.querySelector('[role="tab"][data-state="active"]');
      i && (e.orientation.value === "horizontal" ? n.value = {
        size: i.offsetWidth,
        position: i.offsetLeft
      } : n.value = {
        size: i.offsetHeight,
        position: i.offsetTop
      });
    }, { immediate: !0 }), (s, i) => typeof n.value.size == "number" ? (h(), b(a(T), B({ key: 0 }, t, {
      style: {
        "--radix-tabs-indicator-size": `${n.value.size}px`,
        "--radix-tabs-indicator-position": `${n.value.position}px`
      }
    }), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["style"])) : q("", !0);
  }
}), [Wt, vl] = H("TagsInputRoot"), Nc = /* @__PURE__ */ g({
  __name: "TagsInputRoot",
  props: {
    modelValue: {},
    defaultValue: { default: () => [] },
    addOnPaste: { type: Boolean },
    duplicate: { type: Boolean },
    disabled: { type: Boolean },
    delimiter: { default: "," },
    dir: {},
    max: { default: 0 },
    required: { type: Boolean },
    name: {},
    id: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "invalid"],
  setup(o, { emit: t }) {
    const e = o, n = t, { addOnPaste: s, disabled: i, delimiter: r, max: l, id: u, dir: d } = z(e), c = de(d), p = J(e, "modelValue", n, {
      defaultValue: e.defaultValue,
      passive: !0,
      deep: !0
    }), { primitiveElement: f, currentElement: m } = R(), { focused: C } = ss(m), w = Le(m), { getItems: O } = Rn(), _ = x(), S = x(!1);
    return vl({
      modelValue: p,
      onAddValue: (E) => {
        if (p.value.length >= l.value && l.value)
          return n("invalid", E), !1;
        if (e.duplicate)
          return p.value.push(E), !0;
        if (p.value.includes(E))
          S.value = !0;
        else
          return p.value.push(E), !0;
        return n("invalid", E), !1;
      },
      onRemoveValue: (E) => {
        E !== -1 && p.value.splice(E, 1);
      },
      onInputKeydown: (E) => {
        const $ = E.target, I = O().map((V) => V.ref).filter((V) => V.dataset.disabled !== "");
        if (!I.length)
          return;
        const A = I.at(-1);
        switch (E.key) {
          case "Delete":
          case "Backspace": {
            if ($.selectionStart !== 0 || $.selectionEnd !== 0)
              break;
            if (_.value) {
              const V = I.findIndex((M) => M === _.value);
              p.value.splice(V, 1), _.value = _.value === A ? I.at(V - 1) : I.at(V + 1), E.preventDefault();
            } else
              E.key === "Backspace" && (_.value = A, E.preventDefault());
            break;
          }
          case "Home":
          case "End":
          case "ArrowRight":
          case "ArrowLeft": {
            const V = E.key === "ArrowRight" && c.value === "ltr" || E.key === "ArrowLeft" && c.value === "rtl", M = !V;
            if ($.selectionStart !== 0 || $.selectionEnd !== 0)
              break;
            if (M && !_.value)
              _.value = A, E.preventDefault();
            else if (V && A && _.value === A)
              _.value = void 0, E.preventDefault();
            else if (_.value) {
              const N = qe(E, _.value, void 0, {
                itemsArray: I,
                loop: !1,
                dir: c.value
              });
              N && (_.value = N), E.preventDefault();
            }
            break;
          }
          case "ArrowUp":
          case "ArrowDown": {
            _.value && E.preventDefault();
            break;
          }
          default:
            _.value = void 0;
        }
      },
      selectedElement: _,
      isInvalidInput: S,
      addOnPaste: s,
      dir: c,
      disabled: i,
      delimiter: r,
      max: l,
      id: u
    }), (E, $) => (h(), b(a(Vn), null, {
      default: v(() => [
        F(a(T), {
          ref_key: "primitiveElement",
          ref: f,
          dir: a(c),
          as: E.as,
          "as-child": E.asChild,
          "data-invalid": S.value ? "" : void 0,
          "data-disabled": a(i) ? "" : void 0,
          "data-focused": a(C) ? "" : void 0
        }, {
          default: v(() => [
            y(E.$slots, "default", { values: a(p) }),
            a(w) && E.name ? (h(), b(a(kn), {
              key: 0,
              name: E.name,
              value: a(p),
              required: E.required,
              disabled: a(i)
            }, null, 8, ["name", "value", "required", "disabled"])) : q("", !0)
          ]),
          _: 3
        }, 8, ["dir", "as", "as-child", "data-invalid", "data-disabled", "data-focused"])
      ]),
      _: 3
    }));
  }
}), Hc = /* @__PURE__ */ g({
  __name: "TagsInputInput",
  props: {
    placeholder: {},
    autoFocus: { type: Boolean },
    maxLength: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "input" }
  },
  setup(o) {
    const t = o, e = Wt(), { primitiveElement: n, currentElement: s } = R();
    async function i(u) {
      if (await Y(), u.defaultPrevented)
        return;
      const d = u.target;
      if (!d.value)
        return;
      e.onAddValue(d.value) && (d.value = ""), u.preventDefault();
    }
    function r(u) {
      e.isInvalidInput.value = !1;
      const d = e.delimiter.value;
      if (d === u.data) {
        const c = u.target;
        c.value = c.value.replaceAll(d, ""), e.onAddValue(c.value) && (c.value = "");
      }
    }
    function l(u) {
      if (e.addOnPaste.value) {
        u.preventDefault();
        const d = u.clipboardData;
        if (!d)
          return;
        const c = d.getData("text");
        e.delimiter.value ? c.split(e.delimiter.value).forEach((f) => {
          e.onAddValue(f);
        }) : e.onAddValue(c);
      }
    }
    return U(() => {
      const u = s.value.nodeName === "INPUT" ? s.value : s.value.querySelector("input");
      u && setTimeout(() => {
        t.autoFocus && (u == null || u.focus());
      }, 1);
    }), (u, d) => {
      var c;
      return h(), b(a(T), B(t, {
        id: (c = a(e).id) == null ? void 0 : c.value,
        ref_key: "primitiveElement",
        ref: n,
        type: "text",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        maxlength: u.maxLength,
        disabled: a(e).disabled.value,
        "data-invalid": a(e).isInvalidInput.value ? "" : void 0,
        onInput: r,
        onKeydown: [
          ie(i, ["enter"]),
          a(e).onInputKeydown
        ],
        onPaste: l
      }), {
        default: v(() => [
          y(u.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "maxlength", "disabled", "data-invalid", "onKeydown"]);
    };
  }
}), [ya, ml] = H("TagsInputItem"), Wc = /* @__PURE__ */ g({
  __name: "TagsInputItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, { value: e } = z(t), n = Wt(), { primitiveElement: s, currentElement: i } = R(), r = P(() => n.selectedElement.value === i.value), l = oe(), u = P(() => t.disabled || n.disabled.value);
    return ml({
      value: e,
      isSelected: r,
      disabled: u,
      textId: l
    }), (d, c) => (h(), b(a(jn), null, {
      default: v(() => [
        F(a(T), {
          ref_key: "primitiveElement",
          ref: s,
          as: d.as,
          "as-child": d.asChild,
          "aria-labelledby": a(l),
          "aria-current": r.value,
          "data-disabled": u.value ? "" : void 0,
          "data-state": r.value ? "active" : "inactive"
        }, {
          default: v(() => [
            y(d.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child", "aria-labelledby", "aria-current", "data-disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), zc = /* @__PURE__ */ g({
  __name: "TagsInputItemText",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "span" }
  },
  setup(o) {
    const t = o, e = ya();
    return (n, s) => (h(), b(a(T), B(t, {
      id: a(e).textId
    }), {
      default: v(() => [
        y(n.$slots, "default", {}, () => [
          ue(je(a(e).value.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), Uc = /* @__PURE__ */ g({
  __name: "TagsInputItemDelete",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Wt(), n = ya(), s = P(() => {
      var r;
      return ((r = n.disabled) == null ? void 0 : r.value) || e.disabled.value;
    });
    function i() {
      if (s.value)
        return;
      const r = e.modelValue.value.findIndex((l) => l === n.value.value);
      e.onRemoveValue(r);
    }
    return (r, l) => (h(), b(a(T), B({ tabindex: "-1" }, t, {
      "aria-labelledby": a(n).textId,
      "aria-current": a(n).isSelected.value,
      "data-state": a(n).isSelected.value ? "active" : "inactive",
      "data-disabled": s.value ? "" : void 0,
      type: r.as === "button" ? "button" : void 0,
      onClick: i
    }), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby", "aria-current", "data-state", "data-disabled", "type"]));
  }
}), qc = /* @__PURE__ */ g({
  __name: "TagsInputClear",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Wt();
    function n() {
      e.disabled.value || (e.modelValue.value = []);
    }
    return (s, i) => (h(), b(a(T), B(t, {
      type: s.as === "button" ? "button" : void 0,
      "data-disabled": a(e).disabled.value ? "" : void 0,
      onClick: n
    }), {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "data-disabled"]));
  }
}), [zt, hl] = H("ToastProvider"), Gc = /* @__PURE__ */ g({
  __name: "ToastProvider",
  props: {
    label: { default: "Notification" },
    duration: { default: 5e3 },
    swipeDirection: { default: "right" },
    swipeThreshold: { default: 50 }
  },
  setup(o) {
    const t = o, { label: e, duration: n, swipeDirection: s, swipeThreshold: i } = z(t), r = x(), l = x(0), u = x(!1), d = x(!1);
    if (t.label && typeof t.label == "string" && !t.label.trim()) {
      const c = "Invalid prop `label` supplied to `ToastProvider`. Expected non-empty `string`.";
      throw new Error(c);
    }
    return hl({
      label: e,
      duration: n,
      swipeDirection: s,
      swipeThreshold: i,
      toastCount: l,
      viewport: r,
      onViewportChange(c) {
        r.value = c;
      },
      onToastAdd() {
        l.value++;
      },
      onToastRemove() {
        l.value--;
      },
      isFocusedToastEscapeKeyDownRef: u,
      isClosePausedRef: d
    }), (c, p) => y(c.$slots, "default");
  }
}), yl = "toast.swipeStart", gl = "toast.swipeMove", bl = "toast.swipeCancel", Cl = "toast.swipeEnd", _l = ["F8"], ro = "toast.viewportPause", lo = "toast.viewportResume";
function Et(o, t, e) {
  const n = e.originalEvent.currentTarget, s = new CustomEvent(o, {
    bubbles: !1,
    cancelable: !0,
    detail: e
  });
  t && n.addEventListener(o, t, { once: !0 }), n.dispatchEvent(s);
}
function dn(o, t, e = 0) {
  const n = Math.abs(o.x), s = Math.abs(o.y), i = n > s;
  return t === "left" || t === "right" ? i && n > e : !i && s > e;
}
function wl(o) {
  return o.nodeType === o.ELEMENT_NODE;
}
function ga(o) {
  const t = [];
  return Array.from(o.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && t.push(n.textContent), wl(n)) {
      const s = n.ariaHidden || n.hidden || n.style.display === "none", i = n.dataset.radixToastAnnounceExclude === "";
      if (!s)
        if (i) {
          const r = n.dataset.radixToastAnnounceAlt;
          r && t.push(r);
        } else
          t.push(...ga(n));
    }
  }), t;
}
const Sl = /* @__PURE__ */ g({
  __name: "ToastAnnounce",
  setup(o) {
    const t = zt(), e = Za(1e3), n = x(!1);
    return ns(() => {
      n.value = !0;
    }), (s, i) => a(e) || n.value ? (h(), b(a(Xe), { key: 0 }, {
      default: v(() => [
        ue(je(a(t).label.value) + " ", 1),
        y(s.$slots, "default")
      ]),
      _: 3
    })) : q("", !0);
  }
}), [El, xl] = H("ToastRoot"), Ol = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "ToastRootImpl",
  props: {
    type: {},
    open: { type: Boolean, default: !1 },
    duration: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "li" }
  },
  emits: ["close", "escapeKeyDown", "pause", "resume", "swipeStart", "swipeMove", "swipeCancel", "swipeEnd"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = be(), { primitiveElement: i, currentElement: r } = R(), l = zt(), u = x(null), d = x(null), c = P(() => e.duration || l.duration.value), p = x(0), f = x(c.value), m = x(0);
    function C(_) {
      !_ || _ === Number.POSITIVE_INFINITY || (window.clearTimeout(m.value), p.value = (/* @__PURE__ */ new Date()).getTime(), m.value = window.setTimeout(w, _));
    }
    function w() {
      var S, E;
      ((S = r.value) == null ? void 0 : S.contains(document.activeElement)) && ((E = l.viewport.value) == null || E.focus()), n("close");
    }
    const O = P(() => r.value ? ga(r.value) : null);
    if (e.type && !["foreground", "background"].includes(e.type)) {
      const _ = "Invalid prop `type` supplied to `Toast`. Expected `foreground | background`.";
      throw new Error(_);
    }
    return ee((_) => {
      const S = l.viewport.value;
      if (S) {
        const E = () => {
          C(f.value), n("resume");
        }, $ = () => {
          const I = (/* @__PURE__ */ new Date()).getTime() - p.value;
          f.value = f.value - I, window.clearTimeout(m.value), n("pause");
        };
        return S.addEventListener(ro, $), S.addEventListener(lo, E), () => {
          S.removeEventListener(ro, $), S.removeEventListener(lo, E);
        };
      }
    }), ee(() => {
      e.open && !l.isClosePausedRef.value && C(c.value);
    }), bo("Escape", (_) => {
      n("escapeKeyDown", _), _.defaultPrevented || (l.isFocusedToastEscapeKeyDownRef.value = !0, w());
    }), U(() => {
      l.onToastAdd();
    }), fe(() => {
      l.onToastRemove();
    }), xl({ onClose: w }), (_, S) => (h(), Q(re, null, [
      O.value ? (h(), b(Sl, {
        key: 0,
        role: "status",
        "aria-live": _.type === "foreground" ? "assertive" : "polite",
        "aria-atomic": ""
      }, {
        default: v(() => [
          ue(je(O.value), 1)
        ]),
        _: 1
      }, 8, ["aria-live"])) : q("", !0),
      (h(), b(Ue, {
        to: a(l).viewport.value
      }, [
        F(a(T), B({
          ref: (E) => {
            a(s)(E), i.value = E;
          },
          role: "status",
          "aria-live": "off",
          "aria-atomic": "",
          tabindex: "0",
          "data-radix-vue-collection-item": ""
        }, _.$attrs, {
          as: _.as,
          "as-child": _.asChild,
          "data-state": _.open ? "open" : "closed",
          "data-swipe-direction": a(l).swipeDirection.value,
          style: { userSelect: "none", touchAction: "none" },
          onPointerdown: S[0] || (S[0] = te((E) => {
            u.value = { x: E.clientX, y: E.clientY };
          }, ["left"])),
          onPointermove: S[1] || (S[1] = (E) => {
            if (!u.value)
              return;
            const $ = E.clientX - u.value.x, I = E.clientY - u.value.y, A = !!d.value, V = ["left", "right"].includes(a(l).swipeDirection.value), M = ["left", "up"].includes(a(l).swipeDirection.value) ? Math.min : Math.max, N = V ? M(0, $) : 0, D = V ? 0 : M(0, I), L = E.pointerType === "touch" ? 10 : 2, W = { x: N, y: D }, Z = { originalEvent: E, delta: W };
            A ? (d.value = W, a(Et)(a(gl), (j) => n("swipeMove", j), Z)) : a(dn)(W, a(l).swipeDirection.value, L) ? (d.value = W, a(Et)(a(yl), (j) => n("swipeStart", j), Z), E.target.setPointerCapture(E.pointerId)) : (Math.abs($) > L || Math.abs(I) > L) && (u.value = null);
          }),
          onPointerup: S[2] || (S[2] = (E) => {
            const $ = d.value, I = E.target;
            if (I.hasPointerCapture(E.pointerId) && I.releasePointerCapture(E.pointerId), d.value = null, u.value = null, $) {
              const A = E.currentTarget, V = { originalEvent: E, delta: $ };
              a(dn)($, a(l).swipeDirection.value, a(l).swipeThreshold.value) ? a(Et)(a(Cl), (M) => n("swipeEnd", M), V) : a(Et)(a(bl), (M) => n("swipeCancel", M), V), A == null || A.addEventListener("click", (M) => M.preventDefault(), {
                once: !0
              });
            }
          })
        }), {
          default: v(() => [
            y(_.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "data-state", "data-swipe-direction"])
      ], 8, ["to"]))
    ], 64));
  }
}), Yc = /* @__PURE__ */ g({
  __name: "ToastRoot",
  props: {
    defaultOpen: { type: Boolean, default: !0 },
    forceMount: { type: Boolean },
    type: { default: "foreground" },
    open: { type: Boolean, default: void 0 },
    duration: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "li" }
  },
  emits: ["close", "escapeKeyDown", "pause", "resume", "swipeStart", "swipeMove", "swipeCancel", "swipeEnd", "update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = J(e, "open", n, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    });
    return (i, r) => (h(), b(a(se), {
      present: i.forceMount || a(s)
    }, {
      default: v(() => [
        F(Ol, B({
          open: a(s),
          type: i.type,
          as: i.as,
          "as-child": i.asChild,
          duration: i.duration
        }, i.$attrs, {
          onClose: r[0] || (r[0] = (l) => s.value = !1),
          onPause: r[1] || (r[1] = (l) => n("pause")),
          onResume: r[2] || (r[2] = (l) => n("resume")),
          onEscapeKeyDown: r[3] || (r[3] = (l) => n("escapeKeyDown", l)),
          onSwipeStart: r[4] || (r[4] = (l) => {
            n("swipeStart", l), l.currentTarget.setAttribute("data-swipe", "start");
          }),
          onSwipeMove: r[5] || (r[5] = (l) => {
            const { x: u, y: d } = l.detail.delta, c = l.currentTarget;
            c.setAttribute("data-swipe", "move"), c.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
          }),
          onSwipeCancel: r[6] || (r[6] = (l) => {
            const u = l.currentTarget;
            u.setAttribute("data-swipe", "cancel"), u.style.removeProperty("--radix-toast-swipe-move-x"), u.style.removeProperty("--radix-toast-swipe-move-y"), u.style.removeProperty("--radix-toast-swipe-end-x"), u.style.removeProperty("--radix-toast-swipe-end-y");
          }),
          onSwipeEnd: r[7] || (r[7] = (l) => {
            const { x: u, y: d } = l.detail.delta, c = l.currentTarget;
            c.setAttribute("data-swipe", "end"), c.style.removeProperty("--radix-toast-swipe-move-x"), c.style.removeProperty("--radix-toast-swipe-move-y"), c.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), s.value = !1;
          })
        }), {
          default: v(() => [
            y(i.$slots, "default")
          ]),
          _: 3
        }, 16, ["open", "type", "as", "as-child", "duration"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), ba = /* @__PURE__ */ g({
  __name: "ToastAnnounceExclude",
  props: {
    altText: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    return (t, e) => (h(), b(a(T), {
      as: t.as,
      "as-child": t.asChild,
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": t.altText || void 0
    }, {
      default: v(() => [
        y(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-radix-toast-announce-alt"]));
  }
}), $l = /* @__PURE__ */ g({
  __name: "ToastClose",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = El();
    return (n, s) => (h(), b(ba, { "as-child": "" }, {
      default: v(() => [
        F(a(T), B(t, {
          type: n.as === "button" ? "button" : void 0,
          onClick: s[0] || (s[0] = (i) => a(e).onClose())
        }), {
          default: v(() => [
            y(n.$slots, "default")
          ]),
          _: 3
        }, 16, ["type"])
      ]),
      _: 3
    }));
  }
}), Xc = /* @__PURE__ */ g({
  __name: "ToastAction",
  props: {
    altText: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    if (!o.altText)
      throw new Error("Missing prop `altText` expected on `ToastAction`");
    return (e, n) => e.altText ? (h(), b(ba, {
      key: 0,
      "alt-text": e.altText,
      "as-child": ""
    }, {
      default: v(() => [
        F($l, {
          as: e.as,
          "as-child": e.asChild
        }, {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child"])
      ]),
      _: 3
    }, 8, ["alt-text"])) : q("", !0);
  }
}), cn = /* @__PURE__ */ g({
  __name: "FocusProxy",
  emits: ["focusFromOutsideViewport"],
  setup(o, { emit: t }) {
    const e = t, n = zt();
    return (s, i) => (h(), b(a(Xe), {
      "aria-hidden": "",
      tabindex: "0",
      style: { position: "'fixed'" },
      onFocus: i[0] || (i[0] = (r) => {
        var d;
        const l = r.relatedTarget;
        !((d = a(n).viewport.value) != null && d.contains(l)) && e("focusFromOutsideViewport");
      })
    }, {
      default: v(() => [
        y(s.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Jc = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "ToastViewport",
  props: {
    hotkey: { default: () => _l },
    label: { default: "Notifications ({hotkey})" },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "ol" }
  },
  setup(o) {
    const t = o, { hotkey: e, label: n } = z(t), { primitiveElement: s, currentElement: i } = R(), { createCollection: r } = le(), l = r(i), u = zt(), d = P(() => u.toastCount.value > 0), c = x(), p = x();
    bo(e.value, () => {
      i.value.focus();
    }), U(() => {
      u.onViewportChange(i.value);
    }), ee((m) => {
      const C = i.value;
      if (d.value && C) {
        const w = () => {
          if (!u.isClosePausedRef.value) {
            const $ = new CustomEvent(ro);
            C.dispatchEvent($), u.isClosePausedRef.value = !0;
          }
        }, O = () => {
          if (u.isClosePausedRef.value) {
            const $ = new CustomEvent(lo);
            C.dispatchEvent($), u.isClosePausedRef.value = !1;
          }
        }, _ = ($) => {
          !C.contains($.relatedTarget) && O();
        }, S = () => {
          C.contains(document.activeElement) || O();
        }, E = ($) => {
          var V, M, N;
          const I = $.altKey || $.ctrlKey || $.metaKey;
          if ($.key === "Tab" && !I) {
            const D = document.activeElement, L = $.shiftKey;
            if ($.target === C && L) {
              (V = c.value) == null || V.focus();
              return;
            }
            const j = f({ tabbingDirection: L ? "backwards" : "forwards" }), G = j.findIndex((ne) => ne === D);
            xt(j.slice(G + 1)) ? $.preventDefault() : L ? (M = c.value) == null || M.focus() : (N = p.value) == null || N.focus();
          }
        };
        C.addEventListener("focusin", w), C.addEventListener("focusout", _), C.addEventListener("pointermove", w), C.addEventListener("pointerleave", S), C.addEventListener("keydown", E), window.addEventListener("blur", w), window.addEventListener("focus", O), m(() => {
          C.removeEventListener("focusin", w), C.removeEventListener("focusout", _), C.removeEventListener("pointermove", w), C.removeEventListener("pointerleave", S), C.removeEventListener("keydown", E), window.removeEventListener("blur", w), window.removeEventListener("focus", O);
        });
      }
    });
    function f({ tabbingDirection: m }) {
      const w = l.value.map((O) => {
        const _ = [O, ...xo(O)];
        return m === "forwards" ? _ : _.reverse();
      });
      return (m === "forwards" ? w.reverse() : w).flat();
    }
    return (m, C) => (h(), b(a(Ms), {
      role: "region",
      "aria-label": a(n).replace("{hotkey}", a(e).join("+").replace(/Key/g, "").replace(/Digit/g, "")),
      tabindex: "-1",
      style: ae({
        // incase list has size when empty (e.g. padding), we remove pointer events so
        // it doesn't prevent interactions with page elements that it overlays
        pointerEvents: d.value ? void 0 : "none"
      })
    }, {
      default: v(() => [
        d.value ? (h(), b(cn, {
          key: 0,
          ref: (w) => {
            c.value = a(ve)(w);
          },
          onFocusFromOutsideViewport: C[0] || (C[0] = () => {
            const w = f({
              tabbingDirection: "forwards"
            });
            a(xt)(w);
          })
        }, null, 512)) : q("", !0),
        F(a(T), B({
          ref_key: "primitiveElement",
          ref: s,
          tabindex: "-1",
          as: m.as,
          "as-child": m.asChild
        }, m.$attrs), {
          default: v(() => [
            y(m.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child"]),
        d.value ? (h(), b(cn, {
          key: 1,
          ref: (w) => {
            p.value = a(ve)(w);
          },
          onFocusFromOutsideViewport: C[1] || (C[1] = () => {
            const w = f({
              tabbingDirection: "backwards"
            });
            a(xt)(w);
          })
        }, null, 512)) : q("", !0)
      ]),
      _: 3
    }, 8, ["aria-label", "style"]));
  }
}), Zc = /* @__PURE__ */ g({
  __name: "ToastTitle",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Qc = /* @__PURE__ */ g({
  __name: "ToastDescription",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(T), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Pl = /* @__PURE__ */ g({
  __name: "ToggleRoot",
  props: {
    defaultValue: { type: Boolean },
    pressed: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  emits: ["update:pressed"],
  setup(o, { emit: t }) {
    const e = o, s = J(e, "pressed", t, {
      defaultValue: e.defaultValue,
      passive: e.pressed === void 0
    });
    function i() {
      s.value = !s.value;
    }
    const r = P(() => s.value ? "on" : "off");
    return (l, u) => (h(), b(a(T), {
      type: l.as === "button" ? "button" : void 0,
      "as-child": e.asChild,
      as: l.as,
      "aria-pressed": a(s),
      "data-state": r.value,
      "data-disabled": l.disabled ? "" : void 0,
      disabled: l.disabled,
      onClick: i,
      onKeydown: ie(i, ["enter"])
    }, {
      default: v(() => [
        y(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["type", "as-child", "as", "aria-pressed", "data-state", "data-disabled", "disabled", "onKeydown"]));
  }
}), [Bl, Tl] = H("ToggleGroupRoot"), Dl = /* @__PURE__ */ g({
  __name: "ToggleGroupRoot",
  props: {
    type: { default: "single" },
    defaultValue: {},
    modelValue: {},
    rovingFocus: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    orientation: {},
    dir: {},
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, n = t, { loop: s, rovingFocus: i, disabled: r, dir: l } = z(e), u = de(l), { modelValue: d, changeModelValue: c } = $n(e, n);
    return Tl({
      type: e.type,
      modelValue: d,
      changeModelValue: c,
      dir: u,
      orientation: e.orientation,
      loop: s,
      rovingFocus: i,
      disabled: r
    }), (p, f) => (h(), b(xe(a(i) ? a(Je) : a(T)), {
      "as-child": "",
      orientation: a(i) ? p.orientation : void 0,
      dir: a(u),
      loop: a(i) ? a(s) : void 0
    }, {
      default: v(() => [
        F(a(T), {
          role: "group",
          "as-child": p.asChild,
          as: p.as
        }, {
          default: v(() => [
            y(p.$slots, "default", { modelValue: a(d) })
          ]),
          _: 3
        }, 8, ["as-child", "as"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
}), Il = /* @__PURE__ */ g({
  __name: "ToggleGroupItem",
  props: {
    value: {},
    defaultValue: { type: Boolean },
    pressed: { type: Boolean },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Bl(), n = P(() => {
      var i;
      return ((i = e.disabled) == null ? void 0 : i.value) || t.disabled;
    }), s = P(() => {
      var i;
      return (i = e.modelValue.value) == null ? void 0 : i.includes(t.value);
    });
    return (i, r) => (h(), b(xe(a(e).rovingFocus.value ? a(Ze) : a(T)), {
      "as-child": "",
      focusable: !n.value,
      active: s.value
    }, {
      default: v(() => {
        var l;
        return [
          F(a(Pl), B(t, {
            disabled: n.value,
            pressed: a(e).type === "single" ? a(e).modelValue.value === i.value : (l = a(e).modelValue.value) == null ? void 0 : l.includes(i.value),
            "onUpdate:pressed": r[0] || (r[0] = (u) => a(e).changeModelValue(i.value))
          }), {
            default: v(() => [
              y(i.$slots, "default")
            ]),
            _: 3
          }, 16, ["disabled", "pressed"])
        ];
      }),
      _: 3
    }, 8, ["focusable", "active"]));
  }
}), [Ca, Al] = H("ToolbarRoot"), ep = /* @__PURE__ */ g({
  __name: "ToolbarRoot",
  props: {
    orientation: { default: "horizontal" },
    dir: {},
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o, { orientation: e, dir: n } = z(t), s = de(n);
    return Al({ orientation: e, dir: s }), (i, r) => (h(), b(a(Je), {
      "as-child": "",
      orientation: a(e),
      dir: a(s),
      loop: i.loop
    }, {
      default: v(() => [
        F(a(T), {
          role: "toolbar",
          "aria-orientation": a(e),
          "as-child": i.asChild,
          as: i.as
        }, {
          default: v(() => [
            y(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["aria-orientation", "as-child", "as"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
}), Fl = /* @__PURE__ */ g({
  __name: "ToolbarButton",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ze), {
      "as-child": "",
      focusable: !e.disabled
    }, {
      default: v(() => [
        F(a(T), B({
          type: e.as === "button" ? "button" : void 0
        }, t), {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 16, ["type"])
      ]),
      _: 3
    }, 8, ["focusable"]));
  }
}), tp = /* @__PURE__ */ g({
  __name: "ToolbarLink",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "a" }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ze), {
      "as-child": "",
      focusable: ""
    }, {
      default: v(() => [
        F(a(T), B(t, {
          onKeydown: n[0] || (n[0] = (s) => {
            var i;
            s.key === " " && ((i = s.currentTarget) == null || i.click());
          })
        }), {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
}), op = /* @__PURE__ */ g({
  __name: "ToolbarToggleGroup",
  props: {
    type: {},
    defaultValue: {},
    modelValue: {},
    rovingFocus: { type: Boolean },
    disabled: { type: Boolean },
    orientation: {},
    dir: {},
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = Ca(), i = ce(n);
    return (r, l) => (h(), b(a(Dl), B({ ...e, ...a(i) }, {
      "data-orientation": a(s).orientation.value,
      dir: a(s).dir.value,
      "roving-focus": !1
    }), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["data-orientation", "dir"]));
  }
}), np = /* @__PURE__ */ g({
  __name: "ToolbarToggleItem",
  props: {
    value: {},
    defaultValue: { type: Boolean },
    pressed: { type: Boolean },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(Fl, { "as-child": "" }, {
      default: v(() => [
        F(a(Il), k(K(t)), {
          default: v(() => [
            y(e.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
}), ap = /* @__PURE__ */ g({
  __name: "ToolbarSeparator",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(o) {
    const t = o, e = Ca();
    return (n, s) => (h(), b(ia, {
      orientation: a(e).orientation.value,
      "as-child": t.asChild,
      as: n.as
    }, {
      default: v(() => [
        y(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["orientation", "as-child", "as"]));
  }
}), _a = "tooltip.open";
function Ml(o, t) {
  const e = Math.abs(t.top - o.y), n = Math.abs(t.bottom - o.y), s = Math.abs(t.right - o.x), i = Math.abs(t.left - o.x);
  switch (Math.min(e, n, s, i)) {
    case i:
      return "left";
    case s:
      return "right";
    case e:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function kl(o, t, e = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: o.x - e, y: o.y + e },
        { x: o.x + e, y: o.y + e }
      );
      break;
    case "bottom":
      n.push(
        { x: o.x - e, y: o.y - e },
        { x: o.x + e, y: o.y - e }
      );
      break;
    case "left":
      n.push(
        { x: o.x + e, y: o.y - e },
        { x: o.x + e, y: o.y + e }
      );
      break;
    case "right":
      n.push(
        { x: o.x - e, y: o.y - e },
        { x: o.x - e, y: o.y + e }
      );
      break;
  }
  return n;
}
function Rl(o) {
  const { top: t, right: e, bottom: n, left: s } = o;
  return [
    { x: s, y: t },
    { x: e, y: t },
    { x: e, y: n },
    { x: s, y: n }
  ];
}
function Vl(o, t) {
  const { x: e, y: n } = o;
  let s = !1;
  for (let i = 0, r = t.length - 1; i < t.length; r = i++) {
    const l = t[i].x, u = t[i].y, d = t[r].x, c = t[r].y;
    u > n != c > n && e < (d - l) * (n - u) / (c - u) + l && (s = !s);
  }
  return s;
}
function jl(o) {
  const t = o.slice();
  return t.sort((e, n) => e.x < n.x ? -1 : e.x > n.x ? 1 : e.y < n.y ? -1 : e.y > n.y ? 1 : 0), Ll(t);
}
function Ll(o) {
  if (o.length <= 1)
    return o.slice();
  const t = [];
  for (let n = 0; n < o.length; n++) {
    const s = o[n];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], r = t[t.length - 2];
      if ((i.x - r.x) * (s.y - r.y) >= (i.y - r.y) * (s.x - r.x))
        t.pop();
      else
        break;
    }
    t.push(s);
  }
  t.pop();
  const e = [];
  for (let n = o.length - 1; n >= 0; n--) {
    const s = o[n];
    for (; e.length >= 2; ) {
      const i = e[e.length - 1], r = e[e.length - 2];
      if ((i.x - r.x) * (s.y - r.y) >= (i.y - r.y) * (s.x - r.x))
        e.pop();
      else
        break;
    }
    e.push(s);
  }
  return e.pop(), t.length === 1 && e.length === 1 && t[0].x === e[0].x && t[0].y === e[0].y ? t : t.concat(e);
}
const [Qo, Kl] = H("TooltipProvider"), sp = /* @__PURE__ */ g({
  __name: "TooltipProvider",
  props: {
    delayDuration: { default: 700 },
    skipDelayDuration: { default: 300 },
    disableHoverableContent: { type: Boolean, default: !1 },
    disableClosingTrigger: { type: Boolean }
  },
  setup(o) {
    const t = o, { delayDuration: e, skipDelayDuration: n, disableHoverableContent: s, disableClosingTrigger: i } = z(t), r = x(!0), l = x(!1), { start: u, stop: d } = go(() => {
      r.value = !0;
    }, n, { immediate: !1 });
    return Kl({
      isOpenDelayed: r,
      delayDuration: e,
      onOpen() {
        d(), r.value = !1;
      },
      onClose() {
        u();
      },
      isPointerInTransitRef: l,
      onPointerInTransitChange(c) {
        l.value = c;
      },
      disableHoverableContent: s,
      disableClosingTrigger: i
    }), (c, p) => y(c.$slots, "default");
  }
}), [Ut, Nl] = H("TooltipRoot"), ip = /* @__PURE__ */ g({
  __name: "TooltipRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    delayDuration: { default: void 0 },
    disableHoverableContent: { type: Boolean, default: void 0 },
    disableClosingTrigger: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = Qo(), i = P(() => e.disableHoverableContent ?? s.disableHoverableContent.value), r = P(() => e.disableClosingTrigger ?? s.disableClosingTrigger.value), l = P(() => e.delayDuration ?? s.delayDuration.value), u = J(e, "open", n, {
      defaultValue: e.defaultOpen,
      passive: e.open === void 0
    });
    X(u, (_) => {
      s.onClose && (_ ? (s.onOpen(), document.dispatchEvent(new CustomEvent(_a))) : s.onClose());
    });
    const d = x(!1), c = x(), p = P(() => u.value ? d.value ? "delayed-open" : "instant-open" : "closed"), { start: f, stop: m } = go(() => {
      d.value = !0, u.value = !0;
    }, l, { immediate: !1 });
    function C() {
      m(), d.value = !1, u.value = !0;
    }
    function w() {
      m(), u.value = !1;
    }
    function O() {
      f();
    }
    return Nl({
      contentId: oe(),
      open: u,
      stateAttribute: p,
      trigger: c,
      onTriggerChange(_) {
        c.value = _;
      },
      onTriggerEnter() {
        s.isOpenDelayed.value ? O() : C();
      },
      onTriggerLeave() {
        i.value ? w() : m();
      },
      onOpen: C,
      onClose: w,
      disableHoverableContent: i,
      disableClosingTrigger: r
    }), (_, S) => (h(), b(a(Ke), null, {
      default: v(() => [
        y(_.$slots, "default")
      ]),
      _: 3
    }));
  }
}), rp = /* @__PURE__ */ g({
  __name: "TooltipTrigger",
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: "button" }
  },
  setup(o) {
    const t = o, e = Ut(), n = Qo(), { primitiveElement: s, currentElement: i } = R(), r = x(!1), l = x(!1);
    function u() {
      r.value = !1;
    }
    function d() {
      r.value = !0, document.addEventListener("pointerup", u, { once: !0 });
    }
    return U(() => {
      e.onTriggerChange(i.value);
    }), (c, p) => (h(), b(a(Ne), { "as-child": "" }, {
      default: v(() => [
        F(a(T), {
          ref_key: "primitiveElement",
          ref: s,
          "aria-describedby": a(e).open.value ? a(e).contentId : void 0,
          "data-state": a(e).stateAttribute.value,
          as: c.as,
          "as-child": t.asChild,
          onPointermove: p[0] || (p[0] = (f) => {
            f.pointerType !== "touch" && !l.value && !a(n).isPointerInTransitRef.value && (a(e).onTriggerEnter(), l.value = !0);
          }),
          onPointerleave: p[1] || (p[1] = (f) => {
            a(e).onTriggerLeave(), l.value = !1;
          }),
          onPointerdown: d,
          onFocus: p[2] || (p[2] = () => {
            r.value || a(e).onOpen();
          }),
          onBlur: p[3] || (p[3] = (f) => a(e).onClose()),
          onClick: p[4] || (p[4] = () => {
            a(e).disableClosingTrigger.value || a(e).onClose();
          })
        }, {
          default: v(() => [
            y(c.$slots, "default")
          ]),
          _: 3
        }, 8, ["aria-describedby", "data-state", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), wa = /* @__PURE__ */ g({
  __name: "TooltipContentImpl",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean, default: !1 },
    as: {},
    side: { default: "top" },
    sideOffset: { default: 0 },
    align: { default: "center" },
    alignOffset: {},
    avoidCollisions: { type: Boolean, default: !0 },
    collisionBoundary: { default: () => [] },
    collisionPadding: { default: 0 },
    arrowPadding: { default: 0 },
    sticky: { default: "partial" },
    hideWhenDetached: { type: Boolean, default: !1 }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = x(), i = Ut(), r = P(() => {
      var p, f;
      if (e.ariaLabel)
        return e.ariaLabel;
      const u = (f = (p = Cn()).default) == null ? void 0 : f.call(p);
      let d = "";
      function c(m) {
        typeof m.children == "string" ? d += m.children : Array.isArray(m.children) && m.children.forEach((C) => c(C));
      }
      return u == null || u.forEach((m) => c(m)), d;
    }), l = P(() => {
      const { ariaLabel: u, ...d } = e;
      return d;
    });
    return U(() => {
      Re(window, "scroll", (u) => {
        const d = u.target;
        d != null && d.contains(i.trigger.value) && i.onClose();
      }), Re(window, _a, i.onClose);
    }), (u, d) => (h(), b(a(Pe), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: d[0] || (d[0] = (c) => n("escapeKeyDown", c)),
      onPointerDownOutside: d[1] || (d[1] = (c) => {
        var p;
        a(i).disableClosingTrigger.value && ((p = a(i).trigger.value) != null && p.contains(c.target)) && c.preventDefault(), n("pointerDownOutside", c);
      }),
      onFocusOutside: d[2] || (d[2] = te(() => {
      }, ["prevent"])),
      onDismiss: d[3] || (d[3] = (c) => a(i).onClose())
    }, {
      default: v(() => [
        F(a(Ge), B({
          ref_key: "contentElement",
          ref: s,
          "data-state": a(i).stateAttribute.value
        }, { ...u.$attrs, ...l.value }, { style: {
          "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
          "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
          "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        } }), {
          default: v(() => [
            y(u.$slots, "default"),
            F(a(Xe), {
              id: a(i).contentId,
              role: "tooltip"
            }, {
              default: v(() => [
                ue(je(r.value), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 3
        }, 16, ["data-state", "style"])
      ]),
      _: 3
    }));
  }
}), Hl = /* @__PURE__ */ g({
  __name: "TooltipContentHoverable",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  setup(o) {
    const t = o, { primitiveElement: e, currentElement: n } = R(), { trigger: s, onClose: i } = Ut(), r = Qo(), l = x(null);
    function u() {
      l.value = null, r.onPointerInTransitChange(!1);
    }
    function d(c, p) {
      const f = c.currentTarget, m = { x: c.clientX, y: c.clientY }, C = Ml(m, f.getBoundingClientRect()), w = kl(m, C), O = Rl(p.getBoundingClientRect()), _ = jl([...w, ...O]);
      l.value = _, r.onPointerInTransitChange(!0);
    }
    return ee((c) => {
      if (s.value && n.value) {
        const p = (m) => d(m, n.value), f = (m) => d(m, s.value);
        s.value.addEventListener("pointerleave", p), n.value.addEventListener("pointerleave", f), c(() => {
          var m, C;
          (m = s.value) == null || m.removeEventListener("pointerleave", p), (C = n.value) == null || C.removeEventListener("pointerleave", f);
        });
      }
    }), ee((c) => {
      if (l.value) {
        const p = (f) => {
          var _, S;
          if (!l.value)
            return;
          const m = f.target, C = { x: f.clientX, y: f.clientY }, w = ((_ = s.value) == null ? void 0 : _.contains(m)) || ((S = n.value) == null ? void 0 : S.contains(m)), O = !Vl(C, l.value);
          w ? u() : O && (u(), i());
        };
        document.addEventListener("pointermove", p), c(() => document.removeEventListener("pointermove", p));
      }
    }), (c, p) => (h(), b(wa, B({
      ref_key: "primitiveElement",
      ref: e
    }, t), {
      default: v(() => [
        y(c.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), lp = /* @__PURE__ */ g({
  __name: "TooltipContent",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(o, { emit: t }) {
    const e = o, n = t, s = Ut(), i = pe(e, n);
    return (r, l) => a(s).open.value ? (h(), b(xe(a(s).disableHoverableContent.value ? wa : Hl), k(B({ key: 0 }, a(i))), {
      default: v(() => [
        y(r.$slots, "default")
      ]),
      _: 3
    }, 16)) : q("", !0);
  }
}), up = /* @__PURE__ */ g({
  __name: "TooltipArrow",
  props: {
    width: { default: 10 },
    height: { default: 5 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a(Ye), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), dp = /* @__PURE__ */ g({
  __name: "TooltipPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(o) {
    const t = o;
    return (e, n) => (h(), b(a($e), k(K(t)), {
      default: v(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  Jl as AccordionContent,
  Zl as AccordionHeader,
  Xl as AccordionItem,
  Yl as AccordionRoot,
  Ql as AccordionTrigger,
  uu as AlertDialogAction,
  iu as AlertDialogCancel,
  au as AlertDialogContent,
  lu as AlertDialogDescription,
  su as AlertDialogOverlay,
  nu as AlertDialogPortal,
  tu as AlertDialogRoot,
  ru as AlertDialogTitle,
  ou as AlertDialogTrigger,
  du as AspectRatio,
  fu as AvatarFallback,
  pu as AvatarImage,
  cu as AvatarRoot,
  mu as CheckboxIndicator,
  vu as CheckboxRoot,
  Ss as CollapsibleContent,
  Cs as CollapsibleRoot,
  _s as CollapsibleTrigger,
  gu as ComboboxAnchor,
  Bu as ComboboxArrow,
  Cu as ComboboxCancel,
  Su as ComboboxContent,
  Eu as ComboboxEmpty,
  _u as ComboboxGroup,
  yu as ComboboxInput,
  Ou as ComboboxItem,
  $u as ComboboxItemIndicator,
  wu as ComboboxLabel,
  Tu as ComboboxPortal,
  hu as ComboboxRoot,
  Pu as ComboboxSeparator,
  bu as ComboboxTrigger,
  xu as ComboboxViewport,
  ql as ConfigProvider,
  Mu as ContextMenuArrow,
  ju as ContextMenuCheckboxItem,
  Fu as ContextMenuContent,
  Ru as ContextMenuGroup,
  ku as ContextMenuItem,
  Lu as ContextMenuItemIndicator,
  Ku as ContextMenuLabel,
  Au as ContextMenuPortal,
  Nu as ContextMenuRadioGroup,
  Hu as ContextMenuRadioItem,
  Du as ContextMenuRoot,
  Vu as ContextMenuSeparator,
  Wu as ContextMenuSub,
  zu as ContextMenuSubContent,
  Uu as ContextMenuSubTrigger,
  Iu as ContextMenuTrigger,
  Dn as DialogClose,
  Zs as DialogContent,
  oi as DialogDescription,
  ei as DialogOverlay,
  eu as DialogPortal,
  Bs as DialogRoot,
  ti as DialogTitle,
  Ts as DialogTrigger,
  Ju as DropdownMenuArrow,
  td as DropdownMenuCheckboxItem,
  Xu as DropdownMenuContent,
  Qu as DropdownMenuGroup,
  Zu as DropdownMenuItem,
  od as DropdownMenuItemIndicator,
  nd as DropdownMenuLabel,
  Yu as DropdownMenuPortal,
  ad as DropdownMenuRadioGroup,
  sd as DropdownMenuRadioItem,
  qu as DropdownMenuRoot,
  ed as DropdownMenuSeparator,
  id as DropdownMenuSub,
  rd as DropdownMenuSubContent,
  ld as DropdownMenuSubTrigger,
  Gu as DropdownMenuTrigger,
  fd as HoverCardArrow,
  pd as HoverCardContent,
  cd as HoverCardPortal,
  ud as HoverCardRoot,
  dd as HoverCardTrigger,
  vd as Label,
  Cd as MenubarArrow,
  Ed as MenubarCheckboxItem,
  bd as MenubarContent,
  wd as MenubarGroup,
  _d as MenubarItem,
  xd as MenubarItemIndicator,
  Od as MenubarLabel,
  hd as MenubarMenu,
  gd as MenubarPortal,
  $d as MenubarRadioGroup,
  Pd as MenubarRadioItem,
  md as MenubarRoot,
  Sd as MenubarSeparator,
  Bd as MenubarSub,
  Td as MenubarSubContent,
  Dd as MenubarSubTrigger,
  yd as MenubarTrigger,
  Fd as NavigationMenuContent,
  Md as NavigationMenuIndicator,
  Ad as NavigationMenuItem,
  kd as NavigationMenuLink,
  Rd as NavigationMenuList,
  Id as NavigationMenuRoot,
  Vd as NavigationMenuSub,
  jd as NavigationMenuTrigger,
  Ld as NavigationMenuViewport,
  Nd as PaginationEllipsis,
  Hd as PaginationFirst,
  Wd as PaginationLast,
  zd as PaginationList,
  Ud as PaginationListItem,
  qd as PaginationNext,
  Gd as PaginationPrev,
  Kd as PaginationRoot,
  Xd as PinInputInput,
  Yd as PinInputRoot,
  nc as PopoverAnchor,
  tc as PopoverArrow,
  oc as PopoverClose,
  ec as PopoverContent,
  Qd as PopoverPortal,
  Jd as PopoverRoot,
  Zd as PopoverTrigger,
  T as Primitive,
  sc as ProgressIndicator,
  ac as ProgressRoot,
  lc as RadioGroupIndicator,
  rc as RadioGroupItem,
  ic as RadioGroupRoot,
  fc as ScrollAreaCorner,
  uc as ScrollAreaRoot,
  cc as ScrollAreaScrollbar,
  pc as ScrollAreaThumb,
  dc as ScrollAreaViewport,
  gc as SelectArrow,
  yc as SelectContent,
  wc as SelectGroup,
  Bc as SelectIcon,
  Cc as SelectItem,
  _c as SelectItemIndicator,
  Ec as SelectItemText,
  Sc as SelectLabel,
  hc as SelectPortal,
  vc as SelectRoot,
  $c as SelectScrollDownButton,
  Oc as SelectScrollUpButton,
  bc as SelectSeparator,
  mc as SelectTrigger,
  Pc as SelectValue,
  xc as SelectViewport,
  Tc as Separator,
  Fc as SliderRange,
  Dc as SliderRoot,
  Ic as SliderThumb,
  Ac as SliderTrack,
  So as Slot,
  Mc as SwitchRoot,
  kc as SwitchThumb,
  jc as TabsContent,
  Kc as TabsIndicator,
  Vc as TabsList,
  Rc as TabsRoot,
  Lc as TabsTrigger,
  qc as TagsInputClear,
  Hc as TagsInputInput,
  Wc as TagsInputItem,
  Uc as TagsInputItemDelete,
  zc as TagsInputItemText,
  Nc as TagsInputRoot,
  Xc as ToastAction,
  $l as ToastClose,
  Qc as ToastDescription,
  Gc as ToastProvider,
  Yc as ToastRoot,
  Zc as ToastTitle,
  Jc as ToastViewport,
  Pl as Toggle,
  Il as ToggleGroupItem,
  Dl as ToggleGroupRoot,
  Fl as ToolbarButton,
  tp as ToolbarLink,
  ep as ToolbarRoot,
  ap as ToolbarSeparator,
  op as ToolbarToggleGroup,
  np as ToolbarToggleItem,
  up as TooltipArrow,
  lp as TooltipContent,
  dp as TooltipPortal,
  sp as TooltipProvider,
  ip as TooltipRoot,
  rp as TooltipTrigger,
  Xe as VisuallyHidden,
  ce as useEmitAsProps,
  It as useForwardProps,
  pe as useForwardPropsEmits,
  oe as useId,
  xn as useStateMachine,
  Gl as withDefault
};
